/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * KoboToolbox Primary API
 * This page documents all KoboToolbox API endpoints, except for those implementing the OpenRosa protocol, which are [documented separately](/api/openrosa/docs/).

The endpoints are grouped by area of intended use. Each category contains related endpoints, with detailed documentation on usage and configuration. Use this as a reference to quickly find the right endpoint for managing projects, forms, data, permissions, integrations, logs, and organizational resources.

**General note**: All projects (whether deployed or draft), as well as all library content (questions, blocks, templates, and collections) in the user-facing application are represented in the API as "assets".
 * OpenAPI spec version: 2.0.0 (api_v2)
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'

import type { AddAuthenticatorConflictResponse } from '../../models/addAuthenticatorConflictResponse'

import type { AuthenticatedByCodeResponse } from '../../models/authenticatedByCodeResponse'

import type { AuthenticatedByPasswordAnd2FAResponse } from '../../models/authenticatedByPasswordAnd2FAResponse'

import type { AuthenticatedByPasswordResponse } from '../../models/authenticatedByPasswordResponse'

import type { AuthenticatedResponse } from '../../models/authenticatedResponse'

import type { AuthenticationOrReauthenticationResponse } from '../../models/authenticationOrReauthenticationResponse'

import type { AuthenticationResponse } from '../../models/authenticationResponse'

import type { AuthenticatorsResponse } from '../../models/authenticatorsResponse'

import type { ChangePasswordBody } from '../../models/changePasswordBody'

import type { ConfigurationResponse } from '../../models/configurationResponse'

import type { ConfirmLoginCodeBody } from '../../models/confirmLoginCodeBody'

import type { ConflictResponse } from '../../models/conflictResponse'

import type { EmailAddressesResponse } from '../../models/emailAddressesResponse'

import type { EmailBody } from '../../models/emailBody'

import type { EmailVerificationInfoResponse } from '../../models/emailVerificationInfoResponse'

import type { EndSessionsBody } from '../../models/endSessionsBody'

import type { ErrorResponse } from '../../models/errorResponse'

import type { ForbiddenResponse } from '../../models/forbiddenResponse'

import type { LoginBody } from '../../models/loginBody'

import type { MFAAuthenticateBody } from '../../models/mFAAuthenticateBody'

import type { MarkPrimaryEmailBody } from '../../models/markPrimaryEmailBody'

import type { NotFoundResponse } from '../../models/notFoundResponse'

import type { PasswordResetInfoResponse } from '../../models/passwordResetInfoResponse'

import type { PhoneBody } from '../../models/phoneBody'

import type { PhoneNumberChangeResponse } from '../../models/phoneNumberChangeResponse'

import type { PhoneNumbersResponse } from '../../models/phoneNumbersResponse'

import type { ProviderAccountBody } from '../../models/providerAccountBody'

import type { ProviderAccountsResponse } from '../../models/providerAccountsResponse'

import type { ProviderRedirectBody } from '../../models/providerRedirectBody'

import type { ProviderSignupBody } from '../../models/providerSignupBody'

import type { ProviderSignupResponse } from '../../models/providerSignupResponse'

import type { ProviderTokenBody } from '../../models/providerTokenBody'

import type { ReauthenticateBody } from '../../models/reauthenticateBody'

import type { ReauthenticationRequiredResponse } from '../../models/reauthenticationRequiredResponse'

import type { RecoveryCodesResponse } from '../../models/recoveryCodesResponse'

import type { RefreshTokenBody } from '../../models/refreshTokenBody'

import type { RefreshTokenResponse } from '../../models/refreshTokenResponse'

import type { RequestPasswordBody } from '../../models/requestPasswordBody'

import type { ResetPasswordBody } from '../../models/resetPasswordBody'

import type { SessionGoneResponse } from '../../models/sessionGoneResponse'

import type { SessionsResponse } from '../../models/sessionsResponse'

import type { SetupTOTPBody } from '../../models/setupTOTPBody'

import type { SignupBody } from '../../models/signupBody'

import type { StatusOKResponse } from '../../models/statusOKResponse'

import type { TOTPAuthenticatorNotFoundResponse } from '../../models/tOTPAuthenticatorNotFoundResponse'

import type { TOTPAuthenticatorResponse } from '../../models/tOTPAuthenticatorResponse'

import type { TooManyRequestsResponse } from '../../models/tooManyRequestsResponse'

import type { UnauthenticatedResponse } from '../../models/unauthenticatedResponse'

import type { VerifyEmailBody } from '../../models/verifyEmailBody'

import type { VerifyPhoneBody } from '../../models/verifyPhoneBody'

import { fetchAllauth } from '../../orval.allauthMutator'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * There are many configuration options that alter the functionality
and behavior of django-allauth, some of which can also impact the
frontend. Therefore, relevant configuration options are exposed via
this endpoint. The data returned is not user/authentication
dependent. Hence, it suffices to only fetch this data once at boot
time of your application.

 * @summary Get configuration
 */
export type allauthBrowserV1ConfigGetResponse200 = {
  data: ConfigurationResponse
  status: 200
}

export type allauthBrowserV1ConfigGetResponseSuccess = allauthBrowserV1ConfigGetResponse200 & {
  headers: Headers
}

export type allauthBrowserV1ConfigGetResponse = allauthBrowserV1ConfigGetResponseSuccess

export const getAllauthBrowserV1ConfigGetUrl = () => {
  return `/api/v2/allauth/browser/v1/config`
}

export const allauthBrowserV1ConfigGet = async (options?: RequestInit): Promise<allauthBrowserV1ConfigGetResponse> => {
  return fetchAllauth<allauthBrowserV1ConfigGetResponse>(getAllauthBrowserV1ConfigGetUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getAllauthBrowserV1ConfigGetQueryKey = () => {
  return ['api', 'v2', 'allauth', 'browser', 'v1', 'config'] as const
}

export const getAllauthBrowserV1ConfigGetQueryOptions = <
  TData = Awaited<ReturnType<typeof allauthBrowserV1ConfigGet>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof allauthBrowserV1ConfigGet>>, TError, TData>
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAllauthBrowserV1ConfigGetQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof allauthBrowserV1ConfigGet>>> = ({ signal }) =>
    allauthBrowserV1ConfigGet({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof allauthBrowserV1ConfigGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type AllauthBrowserV1ConfigGetQueryResult = NonNullable<Awaited<ReturnType<typeof allauthBrowserV1ConfigGet>>>
export type AllauthBrowserV1ConfigGetQueryError = unknown

/**
 * @summary Get configuration
 */

export function useAllauthBrowserV1ConfigGet<
  TData = Awaited<ReturnType<typeof allauthBrowserV1ConfigGet>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof allauthBrowserV1ConfigGet>>, TError, TData>
  request?: SecondParameter<typeof fetchAllauth>
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAllauthBrowserV1ConfigGetQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * There are many configuration options that alter the functionality
and behavior of django-allauth, some of which can also impact the
frontend. Therefore, relevant configuration options are exposed via
this endpoint. The data returned is not user/authentication
dependent. Hence, it suffices to only fetch this data once at boot
time of your application.

 * @summary Get configuration
 */
export type allauthAppV1ConfigGetResponse200 = {
  data: ConfigurationResponse
  status: 200
}

export type allauthAppV1ConfigGetResponseSuccess = allauthAppV1ConfigGetResponse200 & {
  headers: Headers
}

export type allauthAppV1ConfigGetResponse = allauthAppV1ConfigGetResponseSuccess

export const getAllauthAppV1ConfigGetUrl = () => {
  return `/api/v2/allauth/app/v1/config`
}

export const allauthAppV1ConfigGet = async (options?: RequestInit): Promise<allauthAppV1ConfigGetResponse> => {
  return fetchAllauth<allauthAppV1ConfigGetResponse>(getAllauthAppV1ConfigGetUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getAllauthAppV1ConfigGetQueryKey = () => {
  return ['api', 'v2', 'allauth', 'app', 'v1', 'config'] as const
}

export const getAllauthAppV1ConfigGetQueryOptions = <
  TData = Awaited<ReturnType<typeof allauthAppV1ConfigGet>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof allauthAppV1ConfigGet>>, TError, TData>
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAllauthAppV1ConfigGetQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof allauthAppV1ConfigGet>>> = ({ signal }) =>
    allauthAppV1ConfigGet({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof allauthAppV1ConfigGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type AllauthAppV1ConfigGetQueryResult = NonNullable<Awaited<ReturnType<typeof allauthAppV1ConfigGet>>>
export type AllauthAppV1ConfigGetQueryError = unknown

/**
 * @summary Get configuration
 */

export function useAllauthAppV1ConfigGet<
  TData = Awaited<ReturnType<typeof allauthAppV1ConfigGet>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof allauthAppV1ConfigGet>>, TError, TData>
  request?: SecondParameter<typeof fetchAllauth>
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAllauthAppV1ConfigGetQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * Login using a username-password or email-password combination.

 * @summary Login
 */
export type allauthBrowserV1AuthLoginPostResponse200 = {
  data: AuthenticatedByPasswordResponse
  status: 200
}

export type allauthBrowserV1AuthLoginPostResponse400 = {
  data: ErrorResponse
  status: 400
}

export type allauthBrowserV1AuthLoginPostResponse401 = {
  data: AuthenticationResponse
  status: 401
}

export type allauthBrowserV1AuthLoginPostResponse409 = {
  data: ConflictResponse
  status: 409
}

export type allauthBrowserV1AuthLoginPostResponseSuccess = allauthBrowserV1AuthLoginPostResponse200 & {
  headers: Headers
}
export type allauthBrowserV1AuthLoginPostResponseError = (
  | allauthBrowserV1AuthLoginPostResponse400
  | allauthBrowserV1AuthLoginPostResponse401
  | allauthBrowserV1AuthLoginPostResponse409
) & {
  headers: Headers
}

export type allauthBrowserV1AuthLoginPostResponse =
  | allauthBrowserV1AuthLoginPostResponseSuccess
  | allauthBrowserV1AuthLoginPostResponseError

export const getAllauthBrowserV1AuthLoginPostUrl = () => {
  return `/api/v2/allauth/browser/v1/auth/login`
}

export const allauthBrowserV1AuthLoginPost = async (
  loginBody: LoginBody,
  options?: RequestInit,
): Promise<allauthBrowserV1AuthLoginPostResponse> => {
  return fetchAllauth<allauthBrowserV1AuthLoginPostResponse>(getAllauthBrowserV1AuthLoginPostUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(loginBody),
  })
}

export const getAllauthBrowserV1AuthLoginPostMutationOptions = <
  TError = ErrorResponse | AuthenticationResponse | ConflictResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AuthLoginPost>>,
    TError,
    { data: LoginBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<
  Awaited<ReturnType<typeof allauthBrowserV1AuthLoginPost>>,
  TError,
  { data: LoginBody },
  TContext
> => {
  const mutationKey = ['allauthBrowserV1AuthLoginPost']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof allauthBrowserV1AuthLoginPost>>, { data: LoginBody }> = (
    props,
  ) => {
    const { data } = props ?? {}

    return allauthBrowserV1AuthLoginPost(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthBrowserV1AuthLoginPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthBrowserV1AuthLoginPost>>
>
export type AllauthBrowserV1AuthLoginPostMutationBody = LoginBody
export type AllauthBrowserV1AuthLoginPostMutationError = ErrorResponse | AuthenticationResponse | ConflictResponse

/**
 * @summary Login
 */
export const useAllauthBrowserV1AuthLoginPost = <
  TError = ErrorResponse | AuthenticationResponse | ConflictResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AuthLoginPost>>,
    TError,
    { data: LoginBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthBrowserV1AuthLoginPostMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Login using a username-password or email-password combination.

 * @summary Login
 */
export type allauthAppV1AuthLoginPostResponse200 = {
  data: AuthenticatedByPasswordResponse
  status: 200
}

export type allauthAppV1AuthLoginPostResponse400 = {
  data: ErrorResponse
  status: 400
}

export type allauthAppV1AuthLoginPostResponse401 = {
  data: AuthenticationResponse
  status: 401
}

export type allauthAppV1AuthLoginPostResponse409 = {
  data: ConflictResponse
  status: 409
}

export type allauthAppV1AuthLoginPostResponseSuccess = allauthAppV1AuthLoginPostResponse200 & {
  headers: Headers
}
export type allauthAppV1AuthLoginPostResponseError = (
  | allauthAppV1AuthLoginPostResponse400
  | allauthAppV1AuthLoginPostResponse401
  | allauthAppV1AuthLoginPostResponse409
) & {
  headers: Headers
}

export type allauthAppV1AuthLoginPostResponse =
  | allauthAppV1AuthLoginPostResponseSuccess
  | allauthAppV1AuthLoginPostResponseError

export const getAllauthAppV1AuthLoginPostUrl = () => {
  return `/api/v2/allauth/app/v1/auth/login`
}

export const allauthAppV1AuthLoginPost = async (
  loginBody: LoginBody,
  options?: RequestInit,
): Promise<allauthAppV1AuthLoginPostResponse> => {
  return fetchAllauth<allauthAppV1AuthLoginPostResponse>(getAllauthAppV1AuthLoginPostUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(loginBody),
  })
}

export const getAllauthAppV1AuthLoginPostMutationOptions = <
  TError = ErrorResponse | AuthenticationResponse | ConflictResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1AuthLoginPost>>,
    TError,
    { data: LoginBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<
  Awaited<ReturnType<typeof allauthAppV1AuthLoginPost>>,
  TError,
  { data: LoginBody },
  TContext
> => {
  const mutationKey = ['allauthAppV1AuthLoginPost']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof allauthAppV1AuthLoginPost>>, { data: LoginBody }> = (
    props,
  ) => {
    const { data } = props ?? {}

    return allauthAppV1AuthLoginPost(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthAppV1AuthLoginPostMutationResult = NonNullable<Awaited<ReturnType<typeof allauthAppV1AuthLoginPost>>>
export type AllauthAppV1AuthLoginPostMutationBody = LoginBody
export type AllauthAppV1AuthLoginPostMutationError = ErrorResponse | AuthenticationResponse | ConflictResponse

/**
 * @summary Login
 */
export const useAllauthAppV1AuthLoginPost = <
  TError = ErrorResponse | AuthenticationResponse | ConflictResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1AuthLoginPost>>,
    TError,
    { data: LoginBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthAppV1AuthLoginPostMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Whether or not `username`, `email`, `phone` or combination of those are
required depends on the configuration of django-allauth. Additionally,
if a custom signup form is used there may be other custom properties
required.

 * @summary Signup
 */
export type allauthBrowserV1AuthSignupPostResponse200 = {
  data: AuthenticatedByPasswordResponse
  status: 200
}

export type allauthBrowserV1AuthSignupPostResponse400 = {
  data: ErrorResponse
  status: 400
}

export type allauthBrowserV1AuthSignupPostResponse401 = {
  data: AuthenticationResponse
  status: 401
}

export type allauthBrowserV1AuthSignupPostResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type allauthBrowserV1AuthSignupPostResponse409 = {
  data: ConflictResponse
  status: 409
}

export type allauthBrowserV1AuthSignupPostResponseSuccess = allauthBrowserV1AuthSignupPostResponse200 & {
  headers: Headers
}
export type allauthBrowserV1AuthSignupPostResponseError = (
  | allauthBrowserV1AuthSignupPostResponse400
  | allauthBrowserV1AuthSignupPostResponse401
  | allauthBrowserV1AuthSignupPostResponse403
  | allauthBrowserV1AuthSignupPostResponse409
) & {
  headers: Headers
}

export type allauthBrowserV1AuthSignupPostResponse =
  | allauthBrowserV1AuthSignupPostResponseSuccess
  | allauthBrowserV1AuthSignupPostResponseError

export const getAllauthBrowserV1AuthSignupPostUrl = () => {
  return `/api/v2/allauth/browser/v1/auth/signup`
}

export const allauthBrowserV1AuthSignupPost = async (
  signupBody: SignupBody,
  options?: RequestInit,
): Promise<allauthBrowserV1AuthSignupPostResponse> => {
  return fetchAllauth<allauthBrowserV1AuthSignupPostResponse>(getAllauthBrowserV1AuthSignupPostUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(signupBody),
  })
}

export const getAllauthBrowserV1AuthSignupPostMutationOptions = <
  TError = ErrorResponse | AuthenticationResponse | ForbiddenResponse | ConflictResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AuthSignupPost>>,
    TError,
    { data: SignupBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<
  Awaited<ReturnType<typeof allauthBrowserV1AuthSignupPost>>,
  TError,
  { data: SignupBody },
  TContext
> => {
  const mutationKey = ['allauthBrowserV1AuthSignupPost']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allauthBrowserV1AuthSignupPost>>,
    { data: SignupBody }
  > = (props) => {
    const { data } = props ?? {}

    return allauthBrowserV1AuthSignupPost(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthBrowserV1AuthSignupPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthBrowserV1AuthSignupPost>>
>
export type AllauthBrowserV1AuthSignupPostMutationBody = SignupBody
export type AllauthBrowserV1AuthSignupPostMutationError =
  | ErrorResponse
  | AuthenticationResponse
  | ForbiddenResponse
  | ConflictResponse

/**
 * @summary Signup
 */
export const useAllauthBrowserV1AuthSignupPost = <
  TError = ErrorResponse | AuthenticationResponse | ForbiddenResponse | ConflictResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AuthSignupPost>>,
    TError,
    { data: SignupBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthBrowserV1AuthSignupPostMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Whether or not `username`, `email`, `phone` or combination of those are
required depends on the configuration of django-allauth. Additionally,
if a custom signup form is used there may be other custom properties
required.

 * @summary Signup
 */
export type allauthAppV1AuthSignupPostResponse200 = {
  data: AuthenticatedByPasswordResponse
  status: 200
}

export type allauthAppV1AuthSignupPostResponse400 = {
  data: ErrorResponse
  status: 400
}

export type allauthAppV1AuthSignupPostResponse401 = {
  data: AuthenticationResponse
  status: 401
}

export type allauthAppV1AuthSignupPostResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type allauthAppV1AuthSignupPostResponse409 = {
  data: ConflictResponse
  status: 409
}

export type allauthAppV1AuthSignupPostResponseSuccess = allauthAppV1AuthSignupPostResponse200 & {
  headers: Headers
}
export type allauthAppV1AuthSignupPostResponseError = (
  | allauthAppV1AuthSignupPostResponse400
  | allauthAppV1AuthSignupPostResponse401
  | allauthAppV1AuthSignupPostResponse403
  | allauthAppV1AuthSignupPostResponse409
) & {
  headers: Headers
}

export type allauthAppV1AuthSignupPostResponse =
  | allauthAppV1AuthSignupPostResponseSuccess
  | allauthAppV1AuthSignupPostResponseError

export const getAllauthAppV1AuthSignupPostUrl = () => {
  return `/api/v2/allauth/app/v1/auth/signup`
}

export const allauthAppV1AuthSignupPost = async (
  signupBody: SignupBody,
  options?: RequestInit,
): Promise<allauthAppV1AuthSignupPostResponse> => {
  return fetchAllauth<allauthAppV1AuthSignupPostResponse>(getAllauthAppV1AuthSignupPostUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(signupBody),
  })
}

export const getAllauthAppV1AuthSignupPostMutationOptions = <
  TError = ErrorResponse | AuthenticationResponse | ForbiddenResponse | ConflictResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1AuthSignupPost>>,
    TError,
    { data: SignupBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<
  Awaited<ReturnType<typeof allauthAppV1AuthSignupPost>>,
  TError,
  { data: SignupBody },
  TContext
> => {
  const mutationKey = ['allauthAppV1AuthSignupPost']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof allauthAppV1AuthSignupPost>>, { data: SignupBody }> = (
    props,
  ) => {
    const { data } = props ?? {}

    return allauthAppV1AuthSignupPost(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthAppV1AuthSignupPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthAppV1AuthSignupPost>>
>
export type AllauthAppV1AuthSignupPostMutationBody = SignupBody
export type AllauthAppV1AuthSignupPostMutationError =
  | ErrorResponse
  | AuthenticationResponse
  | ForbiddenResponse
  | ConflictResponse

/**
 * @summary Signup
 */
export const useAllauthAppV1AuthSignupPost = <
  TError = ErrorResponse | AuthenticationResponse | ForbiddenResponse | ConflictResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1AuthSignupPost>>,
    TError,
    { data: SignupBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthAppV1AuthSignupPostMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Obtain email verification information, given the token that was sent to
the user by email.

 * @summary Get email verification information
 */
export type allauthBrowserV1AuthEmailVerifyGetResponse200 = {
  data: EmailVerificationInfoResponse
  status: 200
}

export type allauthBrowserV1AuthEmailVerifyGetResponse400 = {
  data: ErrorResponse
  status: 400
}

export type allauthBrowserV1AuthEmailVerifyGetResponse409 = {
  data: ConflictResponse
  status: 409
}

export type allauthBrowserV1AuthEmailVerifyGetResponseSuccess = allauthBrowserV1AuthEmailVerifyGetResponse200 & {
  headers: Headers
}
export type allauthBrowserV1AuthEmailVerifyGetResponseError = (
  | allauthBrowserV1AuthEmailVerifyGetResponse400
  | allauthBrowserV1AuthEmailVerifyGetResponse409
) & {
  headers: Headers
}

export type allauthBrowserV1AuthEmailVerifyGetResponse =
  | allauthBrowserV1AuthEmailVerifyGetResponseSuccess
  | allauthBrowserV1AuthEmailVerifyGetResponseError

export const getAllauthBrowserV1AuthEmailVerifyGetUrl = () => {
  return `/api/v2/allauth/browser/v1/auth/email/verify`
}

export const allauthBrowserV1AuthEmailVerifyGet = async (
  options?: RequestInit,
): Promise<allauthBrowserV1AuthEmailVerifyGetResponse> => {
  return fetchAllauth<allauthBrowserV1AuthEmailVerifyGetResponse>(getAllauthBrowserV1AuthEmailVerifyGetUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getAllauthBrowserV1AuthEmailVerifyGetQueryKey = () => {
  return ['api', 'v2', 'allauth', 'browser', 'v1', 'auth', 'email', 'verify'] as const
}

export const getAllauthBrowserV1AuthEmailVerifyGetQueryOptions = <
  TData = Awaited<ReturnType<typeof allauthBrowserV1AuthEmailVerifyGet>>,
  TError = ErrorResponse | ConflictResponse,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof allauthBrowserV1AuthEmailVerifyGet>>, TError, TData>
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAllauthBrowserV1AuthEmailVerifyGetQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof allauthBrowserV1AuthEmailVerifyGet>>> = ({ signal }) =>
    allauthBrowserV1AuthEmailVerifyGet({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AuthEmailVerifyGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type AllauthBrowserV1AuthEmailVerifyGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof allauthBrowserV1AuthEmailVerifyGet>>
>
export type AllauthBrowserV1AuthEmailVerifyGetQueryError = ErrorResponse | ConflictResponse

/**
 * @summary Get email verification information
 */

export function useAllauthBrowserV1AuthEmailVerifyGet<
  TData = Awaited<ReturnType<typeof allauthBrowserV1AuthEmailVerifyGet>>,
  TError = ErrorResponse | ConflictResponse,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof allauthBrowserV1AuthEmailVerifyGet>>, TError, TData>
  request?: SecondParameter<typeof fetchAllauth>
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAllauthBrowserV1AuthEmailVerifyGetQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * Complete the email verification process. Depending on the configuration,
email addresses are either verified by opening a link that is sent to
their email address, or, by inputting a code that is sent. On the API,
both cases are handled identically. Meaning, the required key is either
the one from the link, or, the code itself.

Note that a status code of 401 does not imply failure. It indicates that
the email verification was successful, yet, the user is still not signed
in. For example, in case `ACCOUNT_LOGIN_ON_EMAIL_CONFIRMATION` is set to
`False`, a 401 is returned when verifying as part of login/signup.

 * @summary Verify an email
 */
export type allauthBrowserV1AuthEmailVerifyPostResponse200 = {
  data: AuthenticatedResponse
  status: 200
}

export type allauthBrowserV1AuthEmailVerifyPostResponse400 = {
  data: ErrorResponse
  status: 400
}

export type allauthBrowserV1AuthEmailVerifyPostResponse401 = {
  data: UnauthenticatedResponse
  status: 401
}

export type allauthBrowserV1AuthEmailVerifyPostResponse409 = {
  data: ConflictResponse
  status: 409
}

export type allauthBrowserV1AuthEmailVerifyPostResponseSuccess = allauthBrowserV1AuthEmailVerifyPostResponse200 & {
  headers: Headers
}
export type allauthBrowserV1AuthEmailVerifyPostResponseError = (
  | allauthBrowserV1AuthEmailVerifyPostResponse400
  | allauthBrowserV1AuthEmailVerifyPostResponse401
  | allauthBrowserV1AuthEmailVerifyPostResponse409
) & {
  headers: Headers
}

export type allauthBrowserV1AuthEmailVerifyPostResponse =
  | allauthBrowserV1AuthEmailVerifyPostResponseSuccess
  | allauthBrowserV1AuthEmailVerifyPostResponseError

export const getAllauthBrowserV1AuthEmailVerifyPostUrl = () => {
  return `/api/v2/allauth/browser/v1/auth/email/verify`
}

export const allauthBrowserV1AuthEmailVerifyPost = async (
  verifyEmailBody: VerifyEmailBody,
  options?: RequestInit,
): Promise<allauthBrowserV1AuthEmailVerifyPostResponse> => {
  return fetchAllauth<allauthBrowserV1AuthEmailVerifyPostResponse>(getAllauthBrowserV1AuthEmailVerifyPostUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(verifyEmailBody),
  })
}

export const getAllauthBrowserV1AuthEmailVerifyPostMutationOptions = <
  TError = ErrorResponse | UnauthenticatedResponse | ConflictResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AuthEmailVerifyPost>>,
    TError,
    { data: VerifyEmailBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<
  Awaited<ReturnType<typeof allauthBrowserV1AuthEmailVerifyPost>>,
  TError,
  { data: VerifyEmailBody },
  TContext
> => {
  const mutationKey = ['allauthBrowserV1AuthEmailVerifyPost']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allauthBrowserV1AuthEmailVerifyPost>>,
    { data: VerifyEmailBody }
  > = (props) => {
    const { data } = props ?? {}

    return allauthBrowserV1AuthEmailVerifyPost(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthBrowserV1AuthEmailVerifyPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthBrowserV1AuthEmailVerifyPost>>
>
export type AllauthBrowserV1AuthEmailVerifyPostMutationBody = VerifyEmailBody
export type AllauthBrowserV1AuthEmailVerifyPostMutationError =
  | ErrorResponse
  | UnauthenticatedResponse
  | ConflictResponse

/**
 * @summary Verify an email
 */
export const useAllauthBrowserV1AuthEmailVerifyPost = <
  TError = ErrorResponse | UnauthenticatedResponse | ConflictResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AuthEmailVerifyPost>>,
    TError,
    { data: VerifyEmailBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthBrowserV1AuthEmailVerifyPostMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Obtain email verification information, given the token that was sent to
the user by email.

 * @summary Get email verification information
 */
export type allauthAppV1AuthEmailVerifyGetResponse200 = {
  data: EmailVerificationInfoResponse
  status: 200
}

export type allauthAppV1AuthEmailVerifyGetResponse400 = {
  data: ErrorResponse
  status: 400
}

export type allauthAppV1AuthEmailVerifyGetResponse409 = {
  data: ConflictResponse
  status: 409
}

export type allauthAppV1AuthEmailVerifyGetResponseSuccess = allauthAppV1AuthEmailVerifyGetResponse200 & {
  headers: Headers
}
export type allauthAppV1AuthEmailVerifyGetResponseError = (
  | allauthAppV1AuthEmailVerifyGetResponse400
  | allauthAppV1AuthEmailVerifyGetResponse409
) & {
  headers: Headers
}

export type allauthAppV1AuthEmailVerifyGetResponse =
  | allauthAppV1AuthEmailVerifyGetResponseSuccess
  | allauthAppV1AuthEmailVerifyGetResponseError

export const getAllauthAppV1AuthEmailVerifyGetUrl = () => {
  return `/api/v2/allauth/app/v1/auth/email/verify`
}

export const allauthAppV1AuthEmailVerifyGet = async (
  options?: RequestInit,
): Promise<allauthAppV1AuthEmailVerifyGetResponse> => {
  return fetchAllauth<allauthAppV1AuthEmailVerifyGetResponse>(getAllauthAppV1AuthEmailVerifyGetUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getAllauthAppV1AuthEmailVerifyGetQueryKey = () => {
  return ['api', 'v2', 'allauth', 'app', 'v1', 'auth', 'email', 'verify'] as const
}

export const getAllauthAppV1AuthEmailVerifyGetQueryOptions = <
  TData = Awaited<ReturnType<typeof allauthAppV1AuthEmailVerifyGet>>,
  TError = ErrorResponse | ConflictResponse,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof allauthAppV1AuthEmailVerifyGet>>, TError, TData>
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAllauthAppV1AuthEmailVerifyGetQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof allauthAppV1AuthEmailVerifyGet>>> = ({ signal }) =>
    allauthAppV1AuthEmailVerifyGet({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof allauthAppV1AuthEmailVerifyGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type AllauthAppV1AuthEmailVerifyGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof allauthAppV1AuthEmailVerifyGet>>
>
export type AllauthAppV1AuthEmailVerifyGetQueryError = ErrorResponse | ConflictResponse

/**
 * @summary Get email verification information
 */

export function useAllauthAppV1AuthEmailVerifyGet<
  TData = Awaited<ReturnType<typeof allauthAppV1AuthEmailVerifyGet>>,
  TError = ErrorResponse | ConflictResponse,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof allauthAppV1AuthEmailVerifyGet>>, TError, TData>
  request?: SecondParameter<typeof fetchAllauth>
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAllauthAppV1AuthEmailVerifyGetQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * Complete the email verification process. Depending on the configuration,
email addresses are either verified by opening a link that is sent to
their email address, or, by inputting a code that is sent. On the API,
both cases are handled identically. Meaning, the required key is either
the one from the link, or, the code itself.

Note that a status code of 401 does not imply failure. It indicates that
the email verification was successful, yet, the user is still not signed
in. For example, in case `ACCOUNT_LOGIN_ON_EMAIL_CONFIRMATION` is set to
`False`, a 401 is returned when verifying as part of login/signup.

 * @summary Verify an email
 */
export type allauthAppV1AuthEmailVerifyPostResponse200 = {
  data: AuthenticatedResponse
  status: 200
}

export type allauthAppV1AuthEmailVerifyPostResponse400 = {
  data: ErrorResponse
  status: 400
}

export type allauthAppV1AuthEmailVerifyPostResponse401 = {
  data: UnauthenticatedResponse
  status: 401
}

export type allauthAppV1AuthEmailVerifyPostResponse409 = {
  data: ConflictResponse
  status: 409
}

export type allauthAppV1AuthEmailVerifyPostResponseSuccess = allauthAppV1AuthEmailVerifyPostResponse200 & {
  headers: Headers
}
export type allauthAppV1AuthEmailVerifyPostResponseError = (
  | allauthAppV1AuthEmailVerifyPostResponse400
  | allauthAppV1AuthEmailVerifyPostResponse401
  | allauthAppV1AuthEmailVerifyPostResponse409
) & {
  headers: Headers
}

export type allauthAppV1AuthEmailVerifyPostResponse =
  | allauthAppV1AuthEmailVerifyPostResponseSuccess
  | allauthAppV1AuthEmailVerifyPostResponseError

export const getAllauthAppV1AuthEmailVerifyPostUrl = () => {
  return `/api/v2/allauth/app/v1/auth/email/verify`
}

export const allauthAppV1AuthEmailVerifyPost = async (
  verifyEmailBody: VerifyEmailBody,
  options?: RequestInit,
): Promise<allauthAppV1AuthEmailVerifyPostResponse> => {
  return fetchAllauth<allauthAppV1AuthEmailVerifyPostResponse>(getAllauthAppV1AuthEmailVerifyPostUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(verifyEmailBody),
  })
}

export const getAllauthAppV1AuthEmailVerifyPostMutationOptions = <
  TError = ErrorResponse | UnauthenticatedResponse | ConflictResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1AuthEmailVerifyPost>>,
    TError,
    { data: VerifyEmailBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<
  Awaited<ReturnType<typeof allauthAppV1AuthEmailVerifyPost>>,
  TError,
  { data: VerifyEmailBody },
  TContext
> => {
  const mutationKey = ['allauthAppV1AuthEmailVerifyPost']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allauthAppV1AuthEmailVerifyPost>>,
    { data: VerifyEmailBody }
  > = (props) => {
    const { data } = props ?? {}

    return allauthAppV1AuthEmailVerifyPost(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthAppV1AuthEmailVerifyPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthAppV1AuthEmailVerifyPost>>
>
export type AllauthAppV1AuthEmailVerifyPostMutationBody = VerifyEmailBody
export type AllauthAppV1AuthEmailVerifyPostMutationError = ErrorResponse | UnauthenticatedResponse | ConflictResponse

/**
 * @summary Verify an email
 */
export const useAllauthAppV1AuthEmailVerifyPost = <
  TError = ErrorResponse | UnauthenticatedResponse | ConflictResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1AuthEmailVerifyPost>>,
    TError,
    { data: VerifyEmailBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthAppV1AuthEmailVerifyPostMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Requests a new email verification code.
Requires `ACCOUNT_EMAIL_VERIFICATION_SUPPORTS_RESEND = True`.

 * @summary Resend email verification code
 */
export type allauthBrowserV1AuthEmailVerifyResendPostResponse200 = {
  data: StatusOKResponse
  status: 200
}

export type allauthBrowserV1AuthEmailVerifyResendPostResponse409 = {
  data: ConflictResponse
  status: 409
}

export type allauthBrowserV1AuthEmailVerifyResendPostResponse429 = {
  data: TooManyRequestsResponse
  status: 429
}

export type allauthBrowserV1AuthEmailVerifyResendPostResponseSuccess =
  allauthBrowserV1AuthEmailVerifyResendPostResponse200 & {
    headers: Headers
  }
export type allauthBrowserV1AuthEmailVerifyResendPostResponseError = (
  | allauthBrowserV1AuthEmailVerifyResendPostResponse409
  | allauthBrowserV1AuthEmailVerifyResendPostResponse429
) & {
  headers: Headers
}

export type allauthBrowserV1AuthEmailVerifyResendPostResponse =
  | allauthBrowserV1AuthEmailVerifyResendPostResponseSuccess
  | allauthBrowserV1AuthEmailVerifyResendPostResponseError

export const getAllauthBrowserV1AuthEmailVerifyResendPostUrl = () => {
  return `/api/v2/allauth/browser/v1/auth/email/verify/resend`
}

export const allauthBrowserV1AuthEmailVerifyResendPost = async (
  options?: RequestInit,
): Promise<allauthBrowserV1AuthEmailVerifyResendPostResponse> => {
  return fetchAllauth<allauthBrowserV1AuthEmailVerifyResendPostResponse>(
    getAllauthBrowserV1AuthEmailVerifyResendPostUrl(),
    {
      ...options,
      method: 'POST',
    },
  )
}

export const getAllauthBrowserV1AuthEmailVerifyResendPostMutationOptions = <
  TError = ConflictResponse | TooManyRequestsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AuthEmailVerifyResendPost>>,
    TError,
    void,
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<
  Awaited<ReturnType<typeof allauthBrowserV1AuthEmailVerifyResendPost>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['allauthBrowserV1AuthEmailVerifyResendPost']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allauthBrowserV1AuthEmailVerifyResendPost>>,
    void
  > = () => {
    return allauthBrowserV1AuthEmailVerifyResendPost(requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthBrowserV1AuthEmailVerifyResendPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthBrowserV1AuthEmailVerifyResendPost>>
>

export type AllauthBrowserV1AuthEmailVerifyResendPostMutationError = ConflictResponse | TooManyRequestsResponse

/**
 * @summary Resend email verification code
 */
export const useAllauthBrowserV1AuthEmailVerifyResendPost = <
  TError = ConflictResponse | TooManyRequestsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AuthEmailVerifyResendPost>>,
    TError,
    void,
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthBrowserV1AuthEmailVerifyResendPostMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Requests a new email verification code.
Requires `ACCOUNT_EMAIL_VERIFICATION_SUPPORTS_RESEND = True`.

 * @summary Resend email verification code
 */
export type allauthAppV1AuthEmailVerifyResendPostResponse200 = {
  data: StatusOKResponse
  status: 200
}

export type allauthAppV1AuthEmailVerifyResendPostResponse409 = {
  data: ConflictResponse
  status: 409
}

export type allauthAppV1AuthEmailVerifyResendPostResponse429 = {
  data: TooManyRequestsResponse
  status: 429
}

export type allauthAppV1AuthEmailVerifyResendPostResponseSuccess = allauthAppV1AuthEmailVerifyResendPostResponse200 & {
  headers: Headers
}
export type allauthAppV1AuthEmailVerifyResendPostResponseError = (
  | allauthAppV1AuthEmailVerifyResendPostResponse409
  | allauthAppV1AuthEmailVerifyResendPostResponse429
) & {
  headers: Headers
}

export type allauthAppV1AuthEmailVerifyResendPostResponse =
  | allauthAppV1AuthEmailVerifyResendPostResponseSuccess
  | allauthAppV1AuthEmailVerifyResendPostResponseError

export const getAllauthAppV1AuthEmailVerifyResendPostUrl = () => {
  return `/api/v2/allauth/app/v1/auth/email/verify/resend`
}

export const allauthAppV1AuthEmailVerifyResendPost = async (
  options?: RequestInit,
): Promise<allauthAppV1AuthEmailVerifyResendPostResponse> => {
  return fetchAllauth<allauthAppV1AuthEmailVerifyResendPostResponse>(getAllauthAppV1AuthEmailVerifyResendPostUrl(), {
    ...options,
    method: 'POST',
  })
}

export const getAllauthAppV1AuthEmailVerifyResendPostMutationOptions = <
  TError = ConflictResponse | TooManyRequestsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1AuthEmailVerifyResendPost>>,
    TError,
    void,
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<Awaited<ReturnType<typeof allauthAppV1AuthEmailVerifyResendPost>>, TError, void, TContext> => {
  const mutationKey = ['allauthAppV1AuthEmailVerifyResendPost']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof allauthAppV1AuthEmailVerifyResendPost>>, void> = () => {
    return allauthAppV1AuthEmailVerifyResendPost(requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthAppV1AuthEmailVerifyResendPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthAppV1AuthEmailVerifyResendPost>>
>

export type AllauthAppV1AuthEmailVerifyResendPostMutationError = ConflictResponse | TooManyRequestsResponse

/**
 * @summary Resend email verification code
 */
export const useAllauthAppV1AuthEmailVerifyResendPost = <
  TError = ConflictResponse | TooManyRequestsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1AuthEmailVerifyResendPost>>,
    TError,
    void,
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthAppV1AuthEmailVerifyResendPostMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Complete the phone number verification process. Note that a status code
of 401 does not imply failure. It merely indicates that the phone number
verification was successful, yet, the user is still not signed in.

 * @summary Verify a phone number
 */
export type allauthBrowserV1AuthPhoneVerifyPostResponse200 = {
  data: AuthenticatedResponse
  status: 200
}

export type allauthBrowserV1AuthPhoneVerifyPostResponse400 = {
  data: ErrorResponse
  status: 400
}

export type allauthBrowserV1AuthPhoneVerifyPostResponse401 = {
  data: UnauthenticatedResponse
  status: 401
}

export type allauthBrowserV1AuthPhoneVerifyPostResponse409 = {
  data: ConflictResponse
  status: 409
}

export type allauthBrowserV1AuthPhoneVerifyPostResponseSuccess = allauthBrowserV1AuthPhoneVerifyPostResponse200 & {
  headers: Headers
}
export type allauthBrowserV1AuthPhoneVerifyPostResponseError = (
  | allauthBrowserV1AuthPhoneVerifyPostResponse400
  | allauthBrowserV1AuthPhoneVerifyPostResponse401
  | allauthBrowserV1AuthPhoneVerifyPostResponse409
) & {
  headers: Headers
}

export type allauthBrowserV1AuthPhoneVerifyPostResponse =
  | allauthBrowserV1AuthPhoneVerifyPostResponseSuccess
  | allauthBrowserV1AuthPhoneVerifyPostResponseError

export const getAllauthBrowserV1AuthPhoneVerifyPostUrl = () => {
  return `/api/v2/allauth/browser/v1/auth/phone/verify`
}

export const allauthBrowserV1AuthPhoneVerifyPost = async (
  verifyPhoneBody: VerifyPhoneBody,
  options?: RequestInit,
): Promise<allauthBrowserV1AuthPhoneVerifyPostResponse> => {
  return fetchAllauth<allauthBrowserV1AuthPhoneVerifyPostResponse>(getAllauthBrowserV1AuthPhoneVerifyPostUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(verifyPhoneBody),
  })
}

export const getAllauthBrowserV1AuthPhoneVerifyPostMutationOptions = <
  TError = ErrorResponse | UnauthenticatedResponse | ConflictResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AuthPhoneVerifyPost>>,
    TError,
    { data: VerifyPhoneBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<
  Awaited<ReturnType<typeof allauthBrowserV1AuthPhoneVerifyPost>>,
  TError,
  { data: VerifyPhoneBody },
  TContext
> => {
  const mutationKey = ['allauthBrowserV1AuthPhoneVerifyPost']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allauthBrowserV1AuthPhoneVerifyPost>>,
    { data: VerifyPhoneBody }
  > = (props) => {
    const { data } = props ?? {}

    return allauthBrowserV1AuthPhoneVerifyPost(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthBrowserV1AuthPhoneVerifyPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthBrowserV1AuthPhoneVerifyPost>>
>
export type AllauthBrowserV1AuthPhoneVerifyPostMutationBody = VerifyPhoneBody
export type AllauthBrowserV1AuthPhoneVerifyPostMutationError =
  | ErrorResponse
  | UnauthenticatedResponse
  | ConflictResponse

/**
 * @summary Verify a phone number
 */
export const useAllauthBrowserV1AuthPhoneVerifyPost = <
  TError = ErrorResponse | UnauthenticatedResponse | ConflictResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AuthPhoneVerifyPost>>,
    TError,
    { data: VerifyPhoneBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthBrowserV1AuthPhoneVerifyPostMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Complete the phone number verification process. Note that a status code
of 401 does not imply failure. It merely indicates that the phone number
verification was successful, yet, the user is still not signed in.

 * @summary Verify a phone number
 */
export type allauthAppV1AuthPhoneVerifyPostResponse200 = {
  data: AuthenticatedResponse
  status: 200
}

export type allauthAppV1AuthPhoneVerifyPostResponse400 = {
  data: ErrorResponse
  status: 400
}

export type allauthAppV1AuthPhoneVerifyPostResponse401 = {
  data: UnauthenticatedResponse
  status: 401
}

export type allauthAppV1AuthPhoneVerifyPostResponse409 = {
  data: ConflictResponse
  status: 409
}

export type allauthAppV1AuthPhoneVerifyPostResponseSuccess = allauthAppV1AuthPhoneVerifyPostResponse200 & {
  headers: Headers
}
export type allauthAppV1AuthPhoneVerifyPostResponseError = (
  | allauthAppV1AuthPhoneVerifyPostResponse400
  | allauthAppV1AuthPhoneVerifyPostResponse401
  | allauthAppV1AuthPhoneVerifyPostResponse409
) & {
  headers: Headers
}

export type allauthAppV1AuthPhoneVerifyPostResponse =
  | allauthAppV1AuthPhoneVerifyPostResponseSuccess
  | allauthAppV1AuthPhoneVerifyPostResponseError

export const getAllauthAppV1AuthPhoneVerifyPostUrl = () => {
  return `/api/v2/allauth/app/v1/auth/phone/verify`
}

export const allauthAppV1AuthPhoneVerifyPost = async (
  verifyPhoneBody: VerifyPhoneBody,
  options?: RequestInit,
): Promise<allauthAppV1AuthPhoneVerifyPostResponse> => {
  return fetchAllauth<allauthAppV1AuthPhoneVerifyPostResponse>(getAllauthAppV1AuthPhoneVerifyPostUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(verifyPhoneBody),
  })
}

export const getAllauthAppV1AuthPhoneVerifyPostMutationOptions = <
  TError = ErrorResponse | UnauthenticatedResponse | ConflictResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1AuthPhoneVerifyPost>>,
    TError,
    { data: VerifyPhoneBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<
  Awaited<ReturnType<typeof allauthAppV1AuthPhoneVerifyPost>>,
  TError,
  { data: VerifyPhoneBody },
  TContext
> => {
  const mutationKey = ['allauthAppV1AuthPhoneVerifyPost']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allauthAppV1AuthPhoneVerifyPost>>,
    { data: VerifyPhoneBody }
  > = (props) => {
    const { data } = props ?? {}

    return allauthAppV1AuthPhoneVerifyPost(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthAppV1AuthPhoneVerifyPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthAppV1AuthPhoneVerifyPost>>
>
export type AllauthAppV1AuthPhoneVerifyPostMutationBody = VerifyPhoneBody
export type AllauthAppV1AuthPhoneVerifyPostMutationError = ErrorResponse | UnauthenticatedResponse | ConflictResponse

/**
 * @summary Verify a phone number
 */
export const useAllauthAppV1AuthPhoneVerifyPost = <
  TError = ErrorResponse | UnauthenticatedResponse | ConflictResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1AuthPhoneVerifyPost>>,
    TError,
    { data: VerifyPhoneBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthAppV1AuthPhoneVerifyPostMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Requests a new phone number verification code.
Requires `ACCOUNT_PHONE_VERIFICATION_SUPPORTS_RESEND = True`.

 * @summary Resend phone number verification code
 */
export type allauthBrowserV1AuthPhoneVerifyResendPostResponse200 = {
  data: StatusOKResponse
  status: 200
}

export type allauthBrowserV1AuthPhoneVerifyResendPostResponse409 = {
  data: ConflictResponse
  status: 409
}

export type allauthBrowserV1AuthPhoneVerifyResendPostResponse429 = {
  data: TooManyRequestsResponse
  status: 429
}

export type allauthBrowserV1AuthPhoneVerifyResendPostResponseSuccess =
  allauthBrowserV1AuthPhoneVerifyResendPostResponse200 & {
    headers: Headers
  }
export type allauthBrowserV1AuthPhoneVerifyResendPostResponseError = (
  | allauthBrowserV1AuthPhoneVerifyResendPostResponse409
  | allauthBrowserV1AuthPhoneVerifyResendPostResponse429
) & {
  headers: Headers
}

export type allauthBrowserV1AuthPhoneVerifyResendPostResponse =
  | allauthBrowserV1AuthPhoneVerifyResendPostResponseSuccess
  | allauthBrowserV1AuthPhoneVerifyResendPostResponseError

export const getAllauthBrowserV1AuthPhoneVerifyResendPostUrl = () => {
  return `/api/v2/allauth/browser/v1/auth/phone/verify/resend`
}

export const allauthBrowserV1AuthPhoneVerifyResendPost = async (
  options?: RequestInit,
): Promise<allauthBrowserV1AuthPhoneVerifyResendPostResponse> => {
  return fetchAllauth<allauthBrowserV1AuthPhoneVerifyResendPostResponse>(
    getAllauthBrowserV1AuthPhoneVerifyResendPostUrl(),
    {
      ...options,
      method: 'POST',
    },
  )
}

export const getAllauthBrowserV1AuthPhoneVerifyResendPostMutationOptions = <
  TError = ConflictResponse | TooManyRequestsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AuthPhoneVerifyResendPost>>,
    TError,
    void,
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<
  Awaited<ReturnType<typeof allauthBrowserV1AuthPhoneVerifyResendPost>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['allauthBrowserV1AuthPhoneVerifyResendPost']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allauthBrowserV1AuthPhoneVerifyResendPost>>,
    void
  > = () => {
    return allauthBrowserV1AuthPhoneVerifyResendPost(requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthBrowserV1AuthPhoneVerifyResendPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthBrowserV1AuthPhoneVerifyResendPost>>
>

export type AllauthBrowserV1AuthPhoneVerifyResendPostMutationError = ConflictResponse | TooManyRequestsResponse

/**
 * @summary Resend phone number verification code
 */
export const useAllauthBrowserV1AuthPhoneVerifyResendPost = <
  TError = ConflictResponse | TooManyRequestsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AuthPhoneVerifyResendPost>>,
    TError,
    void,
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthBrowserV1AuthPhoneVerifyResendPostMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Requests a new phone number verification code.
Requires `ACCOUNT_PHONE_VERIFICATION_SUPPORTS_RESEND = True`.

 * @summary Resend phone number verification code
 */
export type allauthAppV1AuthPhoneVerifyResendPostResponse200 = {
  data: StatusOKResponse
  status: 200
}

export type allauthAppV1AuthPhoneVerifyResendPostResponse409 = {
  data: ConflictResponse
  status: 409
}

export type allauthAppV1AuthPhoneVerifyResendPostResponse429 = {
  data: TooManyRequestsResponse
  status: 429
}

export type allauthAppV1AuthPhoneVerifyResendPostResponseSuccess = allauthAppV1AuthPhoneVerifyResendPostResponse200 & {
  headers: Headers
}
export type allauthAppV1AuthPhoneVerifyResendPostResponseError = (
  | allauthAppV1AuthPhoneVerifyResendPostResponse409
  | allauthAppV1AuthPhoneVerifyResendPostResponse429
) & {
  headers: Headers
}

export type allauthAppV1AuthPhoneVerifyResendPostResponse =
  | allauthAppV1AuthPhoneVerifyResendPostResponseSuccess
  | allauthAppV1AuthPhoneVerifyResendPostResponseError

export const getAllauthAppV1AuthPhoneVerifyResendPostUrl = () => {
  return `/api/v2/allauth/app/v1/auth/phone/verify/resend`
}

export const allauthAppV1AuthPhoneVerifyResendPost = async (
  options?: RequestInit,
): Promise<allauthAppV1AuthPhoneVerifyResendPostResponse> => {
  return fetchAllauth<allauthAppV1AuthPhoneVerifyResendPostResponse>(getAllauthAppV1AuthPhoneVerifyResendPostUrl(), {
    ...options,
    method: 'POST',
  })
}

export const getAllauthAppV1AuthPhoneVerifyResendPostMutationOptions = <
  TError = ConflictResponse | TooManyRequestsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1AuthPhoneVerifyResendPost>>,
    TError,
    void,
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<Awaited<ReturnType<typeof allauthAppV1AuthPhoneVerifyResendPost>>, TError, void, TContext> => {
  const mutationKey = ['allauthAppV1AuthPhoneVerifyResendPost']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof allauthAppV1AuthPhoneVerifyResendPost>>, void> = () => {
    return allauthAppV1AuthPhoneVerifyResendPost(requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthAppV1AuthPhoneVerifyResendPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthAppV1AuthPhoneVerifyResendPost>>
>

export type AllauthAppV1AuthPhoneVerifyResendPostMutationError = ConflictResponse | TooManyRequestsResponse

/**
 * @summary Resend phone number verification code
 */
export const useAllauthAppV1AuthPhoneVerifyResendPost = <
  TError = ConflictResponse | TooManyRequestsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1AuthPhoneVerifyResendPost>>,
    TError,
    void,
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthAppV1AuthPhoneVerifyResendPostMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * In order to safeguard the account, some actions require the user to be
recently authenticated.  If you try to perform such an action without
having been recently authenticated, a `401` status is returned, listing
flows that can be performed to reauthenticate. One such flow is the flow
with ID `reauthenticate`, which allows for the user to input the
password. This is the endpoint related towards that flow.

 * @summary Reauthenticate
 */
export type allauthBrowserV1AuthReauthenticatePostResponse200 = {
  data: AuthenticatedByPasswordResponse
  status: 200
}

export type allauthBrowserV1AuthReauthenticatePostResponse400 = {
  data: ErrorResponse
  status: 400
}

export type allauthBrowserV1AuthReauthenticatePostResponseSuccess =
  allauthBrowserV1AuthReauthenticatePostResponse200 & {
    headers: Headers
  }
export type allauthBrowserV1AuthReauthenticatePostResponseError = allauthBrowserV1AuthReauthenticatePostResponse400 & {
  headers: Headers
}

export type allauthBrowserV1AuthReauthenticatePostResponse =
  | allauthBrowserV1AuthReauthenticatePostResponseSuccess
  | allauthBrowserV1AuthReauthenticatePostResponseError

export const getAllauthBrowserV1AuthReauthenticatePostUrl = () => {
  return `/api/v2/allauth/browser/v1/auth/reauthenticate`
}

export const allauthBrowserV1AuthReauthenticatePost = async (
  reauthenticateBody: ReauthenticateBody,
  options?: RequestInit,
): Promise<allauthBrowserV1AuthReauthenticatePostResponse> => {
  return fetchAllauth<allauthBrowserV1AuthReauthenticatePostResponse>(getAllauthBrowserV1AuthReauthenticatePostUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(reauthenticateBody),
  })
}

export const getAllauthBrowserV1AuthReauthenticatePostMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AuthReauthenticatePost>>,
    TError,
    { data: ReauthenticateBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<
  Awaited<ReturnType<typeof allauthBrowserV1AuthReauthenticatePost>>,
  TError,
  { data: ReauthenticateBody },
  TContext
> => {
  const mutationKey = ['allauthBrowserV1AuthReauthenticatePost']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allauthBrowserV1AuthReauthenticatePost>>,
    { data: ReauthenticateBody }
  > = (props) => {
    const { data } = props ?? {}

    return allauthBrowserV1AuthReauthenticatePost(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthBrowserV1AuthReauthenticatePostMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthBrowserV1AuthReauthenticatePost>>
>
export type AllauthBrowserV1AuthReauthenticatePostMutationBody = ReauthenticateBody
export type AllauthBrowserV1AuthReauthenticatePostMutationError = ErrorResponse

/**
 * @summary Reauthenticate
 */
export const useAllauthBrowserV1AuthReauthenticatePost = <TError = ErrorResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AuthReauthenticatePost>>,
    TError,
    { data: ReauthenticateBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthBrowserV1AuthReauthenticatePostMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * In order to safeguard the account, some actions require the user to be
recently authenticated.  If you try to perform such an action without
having been recently authenticated, a `401` status is returned, listing
flows that can be performed to reauthenticate. One such flow is the flow
with ID `reauthenticate`, which allows for the user to input the
password. This is the endpoint related towards that flow.

 * @summary Reauthenticate
 */
export type allauthAppV1AuthReauthenticatePostResponse200 = {
  data: AuthenticatedByPasswordResponse
  status: 200
}

export type allauthAppV1AuthReauthenticatePostResponse400 = {
  data: ErrorResponse
  status: 400
}

export type allauthAppV1AuthReauthenticatePostResponseSuccess = allauthAppV1AuthReauthenticatePostResponse200 & {
  headers: Headers
}
export type allauthAppV1AuthReauthenticatePostResponseError = allauthAppV1AuthReauthenticatePostResponse400 & {
  headers: Headers
}

export type allauthAppV1AuthReauthenticatePostResponse =
  | allauthAppV1AuthReauthenticatePostResponseSuccess
  | allauthAppV1AuthReauthenticatePostResponseError

export const getAllauthAppV1AuthReauthenticatePostUrl = () => {
  return `/api/v2/allauth/app/v1/auth/reauthenticate`
}

export const allauthAppV1AuthReauthenticatePost = async (
  reauthenticateBody: ReauthenticateBody,
  options?: RequestInit,
): Promise<allauthAppV1AuthReauthenticatePostResponse> => {
  return fetchAllauth<allauthAppV1AuthReauthenticatePostResponse>(getAllauthAppV1AuthReauthenticatePostUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(reauthenticateBody),
  })
}

export const getAllauthAppV1AuthReauthenticatePostMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1AuthReauthenticatePost>>,
    TError,
    { data: ReauthenticateBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<
  Awaited<ReturnType<typeof allauthAppV1AuthReauthenticatePost>>,
  TError,
  { data: ReauthenticateBody },
  TContext
> => {
  const mutationKey = ['allauthAppV1AuthReauthenticatePost']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allauthAppV1AuthReauthenticatePost>>,
    { data: ReauthenticateBody }
  > = (props) => {
    const { data } = props ?? {}

    return allauthAppV1AuthReauthenticatePost(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthAppV1AuthReauthenticatePostMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthAppV1AuthReauthenticatePost>>
>
export type AllauthAppV1AuthReauthenticatePostMutationBody = ReauthenticateBody
export type AllauthAppV1AuthReauthenticatePostMutationError = ErrorResponse

/**
 * @summary Reauthenticate
 */
export const useAllauthAppV1AuthReauthenticatePost = <TError = ErrorResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1AuthReauthenticatePost>>,
    TError,
    { data: ReauthenticateBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthAppV1AuthReauthenticatePostMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Initiates the password reset procedure. Depending on whether or not
`ACCOUNT_PASSWORD_RESET_BY_CODE_ENABLED` is `True`, the procedure is
either stateless or stateful.

In case codes are used, it is stateful, and a new
`password_reset_by_code` flow is started. In this case, on a successful
password reset request, you will receive a 401 indicating the pending
status of this flow.

In case password reset is configured to use (stateless) links, you will
receive a 200 on a successful password reset request.

 * @summary Request password
 */
export type allauthBrowserV1AuthPasswordRequestPostResponse200 = {
  data: StatusOKResponse
  status: 200
}

export type allauthBrowserV1AuthPasswordRequestPostResponse400 = {
  data: ErrorResponse
  status: 400
}

export type allauthBrowserV1AuthPasswordRequestPostResponse401 = {
  data: AuthenticationResponse
  status: 401
}

export type allauthBrowserV1AuthPasswordRequestPostResponseSuccess =
  allauthBrowserV1AuthPasswordRequestPostResponse200 & {
    headers: Headers
  }
export type allauthBrowserV1AuthPasswordRequestPostResponseError = (
  | allauthBrowserV1AuthPasswordRequestPostResponse400
  | allauthBrowserV1AuthPasswordRequestPostResponse401
) & {
  headers: Headers
}

export type allauthBrowserV1AuthPasswordRequestPostResponse =
  | allauthBrowserV1AuthPasswordRequestPostResponseSuccess
  | allauthBrowserV1AuthPasswordRequestPostResponseError

export const getAllauthBrowserV1AuthPasswordRequestPostUrl = () => {
  return `/api/v2/allauth/browser/v1/auth/password/request`
}

export const allauthBrowserV1AuthPasswordRequestPost = async (
  requestPasswordBody: RequestPasswordBody,
  options?: RequestInit,
): Promise<allauthBrowserV1AuthPasswordRequestPostResponse> => {
  return fetchAllauth<allauthBrowserV1AuthPasswordRequestPostResponse>(
    getAllauthBrowserV1AuthPasswordRequestPostUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(requestPasswordBody),
    },
  )
}

export const getAllauthBrowserV1AuthPasswordRequestPostMutationOptions = <
  TError = ErrorResponse | AuthenticationResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AuthPasswordRequestPost>>,
    TError,
    { data: RequestPasswordBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<
  Awaited<ReturnType<typeof allauthBrowserV1AuthPasswordRequestPost>>,
  TError,
  { data: RequestPasswordBody },
  TContext
> => {
  const mutationKey = ['allauthBrowserV1AuthPasswordRequestPost']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allauthBrowserV1AuthPasswordRequestPost>>,
    { data: RequestPasswordBody }
  > = (props) => {
    const { data } = props ?? {}

    return allauthBrowserV1AuthPasswordRequestPost(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthBrowserV1AuthPasswordRequestPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthBrowserV1AuthPasswordRequestPost>>
>
export type AllauthBrowserV1AuthPasswordRequestPostMutationBody = RequestPasswordBody
export type AllauthBrowserV1AuthPasswordRequestPostMutationError = ErrorResponse | AuthenticationResponse

/**
 * @summary Request password
 */
export const useAllauthBrowserV1AuthPasswordRequestPost = <
  TError = ErrorResponse | AuthenticationResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AuthPasswordRequestPost>>,
    TError,
    { data: RequestPasswordBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthBrowserV1AuthPasswordRequestPostMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Initiates the password reset procedure. Depending on whether or not
`ACCOUNT_PASSWORD_RESET_BY_CODE_ENABLED` is `True`, the procedure is
either stateless or stateful.

In case codes are used, it is stateful, and a new
`password_reset_by_code` flow is started. In this case, on a successful
password reset request, you will receive a 401 indicating the pending
status of this flow.

In case password reset is configured to use (stateless) links, you will
receive a 200 on a successful password reset request.

 * @summary Request password
 */
export type allauthAppV1AuthPasswordRequestPostResponse200 = {
  data: StatusOKResponse
  status: 200
}

export type allauthAppV1AuthPasswordRequestPostResponse400 = {
  data: ErrorResponse
  status: 400
}

export type allauthAppV1AuthPasswordRequestPostResponse401 = {
  data: AuthenticationResponse
  status: 401
}

export type allauthAppV1AuthPasswordRequestPostResponseSuccess = allauthAppV1AuthPasswordRequestPostResponse200 & {
  headers: Headers
}
export type allauthAppV1AuthPasswordRequestPostResponseError = (
  | allauthAppV1AuthPasswordRequestPostResponse400
  | allauthAppV1AuthPasswordRequestPostResponse401
) & {
  headers: Headers
}

export type allauthAppV1AuthPasswordRequestPostResponse =
  | allauthAppV1AuthPasswordRequestPostResponseSuccess
  | allauthAppV1AuthPasswordRequestPostResponseError

export const getAllauthAppV1AuthPasswordRequestPostUrl = () => {
  return `/api/v2/allauth/app/v1/auth/password/request`
}

export const allauthAppV1AuthPasswordRequestPost = async (
  requestPasswordBody: RequestPasswordBody,
  options?: RequestInit,
): Promise<allauthAppV1AuthPasswordRequestPostResponse> => {
  return fetchAllauth<allauthAppV1AuthPasswordRequestPostResponse>(getAllauthAppV1AuthPasswordRequestPostUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(requestPasswordBody),
  })
}

export const getAllauthAppV1AuthPasswordRequestPostMutationOptions = <
  TError = ErrorResponse | AuthenticationResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1AuthPasswordRequestPost>>,
    TError,
    { data: RequestPasswordBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<
  Awaited<ReturnType<typeof allauthAppV1AuthPasswordRequestPost>>,
  TError,
  { data: RequestPasswordBody },
  TContext
> => {
  const mutationKey = ['allauthAppV1AuthPasswordRequestPost']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allauthAppV1AuthPasswordRequestPost>>,
    { data: RequestPasswordBody }
  > = (props) => {
    const { data } = props ?? {}

    return allauthAppV1AuthPasswordRequestPost(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthAppV1AuthPasswordRequestPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthAppV1AuthPasswordRequestPost>>
>
export type AllauthAppV1AuthPasswordRequestPostMutationBody = RequestPasswordBody
export type AllauthAppV1AuthPasswordRequestPostMutationError = ErrorResponse | AuthenticationResponse

/**
 * @summary Request password
 */
export const useAllauthAppV1AuthPasswordRequestPost = <
  TError = ErrorResponse | AuthenticationResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1AuthPasswordRequestPost>>,
    TError,
    { data: RequestPasswordBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthAppV1AuthPasswordRequestPostMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Used to obtain information on and validate a password reset key.  The
key passed is either the key encoded in the password reset URL that the
user has received per email, or, the password reset code in case of
`ACCOUNT_PASSWORD_RESET_BY_CODE_ENABLED`. Note that in case of a code,
the number of requests you can make is limited (by
`ACCOUNT_PASSWORD_RESET_BY_CODE_MAX_ATTEMPTS`).

 * @summary Get password reset information
 */
export type allauthBrowserV1AuthPasswordResetGetResponse200 = {
  data: PasswordResetInfoResponse
  status: 200
}

export type allauthBrowserV1AuthPasswordResetGetResponse400 = {
  data: ErrorResponse
  status: 400
}

export type allauthBrowserV1AuthPasswordResetGetResponse409 = {
  data: ConflictResponse
  status: 409
}

export type allauthBrowserV1AuthPasswordResetGetResponseSuccess = allauthBrowserV1AuthPasswordResetGetResponse200 & {
  headers: Headers
}
export type allauthBrowserV1AuthPasswordResetGetResponseError = (
  | allauthBrowserV1AuthPasswordResetGetResponse400
  | allauthBrowserV1AuthPasswordResetGetResponse409
) & {
  headers: Headers
}

export type allauthBrowserV1AuthPasswordResetGetResponse =
  | allauthBrowserV1AuthPasswordResetGetResponseSuccess
  | allauthBrowserV1AuthPasswordResetGetResponseError

export const getAllauthBrowserV1AuthPasswordResetGetUrl = () => {
  return `/api/v2/allauth/browser/v1/auth/password/reset`
}

export const allauthBrowserV1AuthPasswordResetGet = async (
  options?: RequestInit,
): Promise<allauthBrowserV1AuthPasswordResetGetResponse> => {
  return fetchAllauth<allauthBrowserV1AuthPasswordResetGetResponse>(getAllauthBrowserV1AuthPasswordResetGetUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getAllauthBrowserV1AuthPasswordResetGetQueryKey = () => {
  return ['api', 'v2', 'allauth', 'browser', 'v1', 'auth', 'password', 'reset'] as const
}

export const getAllauthBrowserV1AuthPasswordResetGetQueryOptions = <
  TData = Awaited<ReturnType<typeof allauthBrowserV1AuthPasswordResetGet>>,
  TError = ErrorResponse | ConflictResponse,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof allauthBrowserV1AuthPasswordResetGet>>, TError, TData>
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAllauthBrowserV1AuthPasswordResetGetQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof allauthBrowserV1AuthPasswordResetGet>>> = ({ signal }) =>
    allauthBrowserV1AuthPasswordResetGet({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AuthPasswordResetGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type AllauthBrowserV1AuthPasswordResetGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof allauthBrowserV1AuthPasswordResetGet>>
>
export type AllauthBrowserV1AuthPasswordResetGetQueryError = ErrorResponse | ConflictResponse

/**
 * @summary Get password reset information
 */

export function useAllauthBrowserV1AuthPasswordResetGet<
  TData = Awaited<ReturnType<typeof allauthBrowserV1AuthPasswordResetGet>>,
  TError = ErrorResponse | ConflictResponse,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof allauthBrowserV1AuthPasswordResetGet>>, TError, TData>
  request?: SecondParameter<typeof fetchAllauth>
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAllauthBrowserV1AuthPasswordResetGetQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * Perform the password reset, by handing over the password reset key and
the new password. After successfully completing the password reset, the
user is either logged in (in case `ACCOUNT_LOGIN_ON_PASSWORD_RESET` is
`True`), or, the user will need to proceed to the login page.  In case
of the former, a `200` status code is returned, in case of the latter a
401.

 * @summary Reset password
 */
export type allauthBrowserV1AuthPasswordResetPostResponse200 = {
  data: AuthenticatedByPasswordResponse
  status: 200
}

export type allauthBrowserV1AuthPasswordResetPostResponse400 = {
  data: ErrorResponse
  status: 400
}

export type allauthBrowserV1AuthPasswordResetPostResponse401 = {
  data: AuthenticationResponse
  status: 401
}

export type allauthBrowserV1AuthPasswordResetPostResponse409 = {
  data: ConflictResponse
  status: 409
}

export type allauthBrowserV1AuthPasswordResetPostResponseSuccess = allauthBrowserV1AuthPasswordResetPostResponse200 & {
  headers: Headers
}
export type allauthBrowserV1AuthPasswordResetPostResponseError = (
  | allauthBrowserV1AuthPasswordResetPostResponse400
  | allauthBrowserV1AuthPasswordResetPostResponse401
  | allauthBrowserV1AuthPasswordResetPostResponse409
) & {
  headers: Headers
}

export type allauthBrowserV1AuthPasswordResetPostResponse =
  | allauthBrowserV1AuthPasswordResetPostResponseSuccess
  | allauthBrowserV1AuthPasswordResetPostResponseError

export const getAllauthBrowserV1AuthPasswordResetPostUrl = () => {
  return `/api/v2/allauth/browser/v1/auth/password/reset`
}

export const allauthBrowserV1AuthPasswordResetPost = async (
  resetPasswordBody: ResetPasswordBody,
  options?: RequestInit,
): Promise<allauthBrowserV1AuthPasswordResetPostResponse> => {
  return fetchAllauth<allauthBrowserV1AuthPasswordResetPostResponse>(getAllauthBrowserV1AuthPasswordResetPostUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(resetPasswordBody),
  })
}

export const getAllauthBrowserV1AuthPasswordResetPostMutationOptions = <
  TError = ErrorResponse | AuthenticationResponse | ConflictResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AuthPasswordResetPost>>,
    TError,
    { data: ResetPasswordBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<
  Awaited<ReturnType<typeof allauthBrowserV1AuthPasswordResetPost>>,
  TError,
  { data: ResetPasswordBody },
  TContext
> => {
  const mutationKey = ['allauthBrowserV1AuthPasswordResetPost']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allauthBrowserV1AuthPasswordResetPost>>,
    { data: ResetPasswordBody }
  > = (props) => {
    const { data } = props ?? {}

    return allauthBrowserV1AuthPasswordResetPost(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthBrowserV1AuthPasswordResetPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthBrowserV1AuthPasswordResetPost>>
>
export type AllauthBrowserV1AuthPasswordResetPostMutationBody = ResetPasswordBody
export type AllauthBrowserV1AuthPasswordResetPostMutationError =
  | ErrorResponse
  | AuthenticationResponse
  | ConflictResponse

/**
 * @summary Reset password
 */
export const useAllauthBrowserV1AuthPasswordResetPost = <
  TError = ErrorResponse | AuthenticationResponse | ConflictResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AuthPasswordResetPost>>,
    TError,
    { data: ResetPasswordBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthBrowserV1AuthPasswordResetPostMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Used to obtain information on and validate a password reset key.  The
key passed is either the key encoded in the password reset URL that the
user has received per email, or, the password reset code in case of
`ACCOUNT_PASSWORD_RESET_BY_CODE_ENABLED`. Note that in case of a code,
the number of requests you can make is limited (by
`ACCOUNT_PASSWORD_RESET_BY_CODE_MAX_ATTEMPTS`).

 * @summary Get password reset information
 */
export type allauthAppV1AuthPasswordResetGetResponse200 = {
  data: PasswordResetInfoResponse
  status: 200
}

export type allauthAppV1AuthPasswordResetGetResponse400 = {
  data: ErrorResponse
  status: 400
}

export type allauthAppV1AuthPasswordResetGetResponse409 = {
  data: ConflictResponse
  status: 409
}

export type allauthAppV1AuthPasswordResetGetResponseSuccess = allauthAppV1AuthPasswordResetGetResponse200 & {
  headers: Headers
}
export type allauthAppV1AuthPasswordResetGetResponseError = (
  | allauthAppV1AuthPasswordResetGetResponse400
  | allauthAppV1AuthPasswordResetGetResponse409
) & {
  headers: Headers
}

export type allauthAppV1AuthPasswordResetGetResponse =
  | allauthAppV1AuthPasswordResetGetResponseSuccess
  | allauthAppV1AuthPasswordResetGetResponseError

export const getAllauthAppV1AuthPasswordResetGetUrl = () => {
  return `/api/v2/allauth/app/v1/auth/password/reset`
}

export const allauthAppV1AuthPasswordResetGet = async (
  options?: RequestInit,
): Promise<allauthAppV1AuthPasswordResetGetResponse> => {
  return fetchAllauth<allauthAppV1AuthPasswordResetGetResponse>(getAllauthAppV1AuthPasswordResetGetUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getAllauthAppV1AuthPasswordResetGetQueryKey = () => {
  return ['api', 'v2', 'allauth', 'app', 'v1', 'auth', 'password', 'reset'] as const
}

export const getAllauthAppV1AuthPasswordResetGetQueryOptions = <
  TData = Awaited<ReturnType<typeof allauthAppV1AuthPasswordResetGet>>,
  TError = ErrorResponse | ConflictResponse,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof allauthAppV1AuthPasswordResetGet>>, TError, TData>
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAllauthAppV1AuthPasswordResetGetQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof allauthAppV1AuthPasswordResetGet>>> = ({ signal }) =>
    allauthAppV1AuthPasswordResetGet({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof allauthAppV1AuthPasswordResetGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type AllauthAppV1AuthPasswordResetGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof allauthAppV1AuthPasswordResetGet>>
>
export type AllauthAppV1AuthPasswordResetGetQueryError = ErrorResponse | ConflictResponse

/**
 * @summary Get password reset information
 */

export function useAllauthAppV1AuthPasswordResetGet<
  TData = Awaited<ReturnType<typeof allauthAppV1AuthPasswordResetGet>>,
  TError = ErrorResponse | ConflictResponse,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof allauthAppV1AuthPasswordResetGet>>, TError, TData>
  request?: SecondParameter<typeof fetchAllauth>
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAllauthAppV1AuthPasswordResetGetQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * Perform the password reset, by handing over the password reset key and
the new password. After successfully completing the password reset, the
user is either logged in (in case `ACCOUNT_LOGIN_ON_PASSWORD_RESET` is
`True`), or, the user will need to proceed to the login page.  In case
of the former, a `200` status code is returned, in case of the latter a
401.

 * @summary Reset password
 */
export type allauthAppV1AuthPasswordResetPostResponse200 = {
  data: AuthenticatedByPasswordResponse
  status: 200
}

export type allauthAppV1AuthPasswordResetPostResponse400 = {
  data: ErrorResponse
  status: 400
}

export type allauthAppV1AuthPasswordResetPostResponse401 = {
  data: AuthenticationResponse
  status: 401
}

export type allauthAppV1AuthPasswordResetPostResponse409 = {
  data: ConflictResponse
  status: 409
}

export type allauthAppV1AuthPasswordResetPostResponseSuccess = allauthAppV1AuthPasswordResetPostResponse200 & {
  headers: Headers
}
export type allauthAppV1AuthPasswordResetPostResponseError = (
  | allauthAppV1AuthPasswordResetPostResponse400
  | allauthAppV1AuthPasswordResetPostResponse401
  | allauthAppV1AuthPasswordResetPostResponse409
) & {
  headers: Headers
}

export type allauthAppV1AuthPasswordResetPostResponse =
  | allauthAppV1AuthPasswordResetPostResponseSuccess
  | allauthAppV1AuthPasswordResetPostResponseError

export const getAllauthAppV1AuthPasswordResetPostUrl = () => {
  return `/api/v2/allauth/app/v1/auth/password/reset`
}

export const allauthAppV1AuthPasswordResetPost = async (
  resetPasswordBody: ResetPasswordBody,
  options?: RequestInit,
): Promise<allauthAppV1AuthPasswordResetPostResponse> => {
  return fetchAllauth<allauthAppV1AuthPasswordResetPostResponse>(getAllauthAppV1AuthPasswordResetPostUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(resetPasswordBody),
  })
}

export const getAllauthAppV1AuthPasswordResetPostMutationOptions = <
  TError = ErrorResponse | AuthenticationResponse | ConflictResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1AuthPasswordResetPost>>,
    TError,
    { data: ResetPasswordBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<
  Awaited<ReturnType<typeof allauthAppV1AuthPasswordResetPost>>,
  TError,
  { data: ResetPasswordBody },
  TContext
> => {
  const mutationKey = ['allauthAppV1AuthPasswordResetPost']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allauthAppV1AuthPasswordResetPost>>,
    { data: ResetPasswordBody }
  > = (props) => {
    const { data } = props ?? {}

    return allauthAppV1AuthPasswordResetPost(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthAppV1AuthPasswordResetPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthAppV1AuthPasswordResetPost>>
>
export type AllauthAppV1AuthPasswordResetPostMutationBody = ResetPasswordBody
export type AllauthAppV1AuthPasswordResetPostMutationError = ErrorResponse | AuthenticationResponse | ConflictResponse

/**
 * @summary Reset password
 */
export const useAllauthAppV1AuthPasswordResetPost = <
  TError = ErrorResponse | AuthenticationResponse | ConflictResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1AuthPasswordResetPost>>,
    TError,
    { data: ResetPasswordBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthAppV1AuthPasswordResetPostMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Initiates the third-party provider authentication redirect flow. As calling
this endpoint results in a user facing redirect (302), this call is only
available in a browser, and must be called in a synchronous (non-XHR)
manner.

 * @summary Provider redirect
 */
export type allauthBrowserV1AuthProviderRedirectPostResponse302 = {
  data: void
  status: 302
}
export type allauthBrowserV1AuthProviderRedirectPostResponseError =
  allauthBrowserV1AuthProviderRedirectPostResponse302 & {
    headers: Headers
  }

export type allauthBrowserV1AuthProviderRedirectPostResponse = allauthBrowserV1AuthProviderRedirectPostResponseError

export const getAllauthBrowserV1AuthProviderRedirectPostUrl = () => {
  return `/api/v2/allauth/browser/v1/auth/provider/redirect`
}

export const allauthBrowserV1AuthProviderRedirectPost = async (
  providerRedirectBody: ProviderRedirectBody,
  options?: RequestInit,
): Promise<allauthBrowserV1AuthProviderRedirectPostResponse> => {
  const formUrlEncoded = new URLSearchParams()
  formUrlEncoded.append(`provider`, providerRedirectBody.provider)
  formUrlEncoded.append(`callback_url`, providerRedirectBody.callback_url)
  formUrlEncoded.append(`process`, providerRedirectBody.process)

  return fetchAllauth<allauthBrowserV1AuthProviderRedirectPostResponse>(
    getAllauthBrowserV1AuthProviderRedirectPostUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', ...options?.headers },
      body: formUrlEncoded,
    },
  )
}

export const getAllauthBrowserV1AuthProviderRedirectPostMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AuthProviderRedirectPost>>,
    TError,
    { data: ProviderRedirectBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<
  Awaited<ReturnType<typeof allauthBrowserV1AuthProviderRedirectPost>>,
  TError,
  { data: ProviderRedirectBody },
  TContext
> => {
  const mutationKey = ['allauthBrowserV1AuthProviderRedirectPost']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allauthBrowserV1AuthProviderRedirectPost>>,
    { data: ProviderRedirectBody }
  > = (props) => {
    const { data } = props ?? {}

    return allauthBrowserV1AuthProviderRedirectPost(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthBrowserV1AuthProviderRedirectPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthBrowserV1AuthProviderRedirectPost>>
>
export type AllauthBrowserV1AuthProviderRedirectPostMutationBody = ProviderRedirectBody
export type AllauthBrowserV1AuthProviderRedirectPostMutationError = void

/**
 * @summary Provider redirect
 */
export const useAllauthBrowserV1AuthProviderRedirectPost = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AuthProviderRedirectPost>>,
    TError,
    { data: ProviderRedirectBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthBrowserV1AuthProviderRedirectPostMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Authenticates with a third-party provider using provider tokens received
by other means. For example, in case of a mobile app, the authentication
flow runs completely on the device itself, without any interaction with
the API. Then, when the (device) authentication completes and the mobile
app receives an access and/or ID token, it can hand over these tokens
via this endpoint to authenticate on the server.

 * @summary Provider token
 */
export type allauthBrowserV1AuthProviderTokenPostResponse200 = {
  data: AuthenticatedResponse
  status: 200
}

export type allauthBrowserV1AuthProviderTokenPostResponse400 = {
  data: ErrorResponse
  status: 400
}

export type allauthBrowserV1AuthProviderTokenPostResponse401 = {
  data: AuthenticationResponse
  status: 401
}

export type allauthBrowserV1AuthProviderTokenPostResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type allauthBrowserV1AuthProviderTokenPostResponseSuccess = allauthBrowserV1AuthProviderTokenPostResponse200 & {
  headers: Headers
}
export type allauthBrowserV1AuthProviderTokenPostResponseError = (
  | allauthBrowserV1AuthProviderTokenPostResponse400
  | allauthBrowserV1AuthProviderTokenPostResponse401
  | allauthBrowserV1AuthProviderTokenPostResponse403
) & {
  headers: Headers
}

export type allauthBrowserV1AuthProviderTokenPostResponse =
  | allauthBrowserV1AuthProviderTokenPostResponseSuccess
  | allauthBrowserV1AuthProviderTokenPostResponseError

export const getAllauthBrowserV1AuthProviderTokenPostUrl = () => {
  return `/api/v2/allauth/browser/v1/auth/provider/token`
}

export const allauthBrowserV1AuthProviderTokenPost = async (
  providerTokenBody: ProviderTokenBody,
  options?: RequestInit,
): Promise<allauthBrowserV1AuthProviderTokenPostResponse> => {
  return fetchAllauth<allauthBrowserV1AuthProviderTokenPostResponse>(getAllauthBrowserV1AuthProviderTokenPostUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(providerTokenBody),
  })
}

export const getAllauthBrowserV1AuthProviderTokenPostMutationOptions = <
  TError = ErrorResponse | AuthenticationResponse | ForbiddenResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AuthProviderTokenPost>>,
    TError,
    { data: ProviderTokenBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<
  Awaited<ReturnType<typeof allauthBrowserV1AuthProviderTokenPost>>,
  TError,
  { data: ProviderTokenBody },
  TContext
> => {
  const mutationKey = ['allauthBrowserV1AuthProviderTokenPost']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allauthBrowserV1AuthProviderTokenPost>>,
    { data: ProviderTokenBody }
  > = (props) => {
    const { data } = props ?? {}

    return allauthBrowserV1AuthProviderTokenPost(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthBrowserV1AuthProviderTokenPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthBrowserV1AuthProviderTokenPost>>
>
export type AllauthBrowserV1AuthProviderTokenPostMutationBody = ProviderTokenBody
export type AllauthBrowserV1AuthProviderTokenPostMutationError =
  | ErrorResponse
  | AuthenticationResponse
  | ForbiddenResponse

/**
 * @summary Provider token
 */
export const useAllauthBrowserV1AuthProviderTokenPost = <
  TError = ErrorResponse | AuthenticationResponse | ForbiddenResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AuthProviderTokenPost>>,
    TError,
    { data: ProviderTokenBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthBrowserV1AuthProviderTokenPostMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Authenticates with a third-party provider using provider tokens received
by other means. For example, in case of a mobile app, the authentication
flow runs completely on the device itself, without any interaction with
the API. Then, when the (device) authentication completes and the mobile
app receives an access and/or ID token, it can hand over these tokens
via this endpoint to authenticate on the server.

 * @summary Provider token
 */
export type allauthAppV1AuthProviderTokenPostResponse200 = {
  data: AuthenticatedResponse
  status: 200
}

export type allauthAppV1AuthProviderTokenPostResponse400 = {
  data: ErrorResponse
  status: 400
}

export type allauthAppV1AuthProviderTokenPostResponse401 = {
  data: AuthenticationResponse
  status: 401
}

export type allauthAppV1AuthProviderTokenPostResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type allauthAppV1AuthProviderTokenPostResponseSuccess = allauthAppV1AuthProviderTokenPostResponse200 & {
  headers: Headers
}
export type allauthAppV1AuthProviderTokenPostResponseError = (
  | allauthAppV1AuthProviderTokenPostResponse400
  | allauthAppV1AuthProviderTokenPostResponse401
  | allauthAppV1AuthProviderTokenPostResponse403
) & {
  headers: Headers
}

export type allauthAppV1AuthProviderTokenPostResponse =
  | allauthAppV1AuthProviderTokenPostResponseSuccess
  | allauthAppV1AuthProviderTokenPostResponseError

export const getAllauthAppV1AuthProviderTokenPostUrl = () => {
  return `/api/v2/allauth/app/v1/auth/provider/token`
}

export const allauthAppV1AuthProviderTokenPost = async (
  providerTokenBody: ProviderTokenBody,
  options?: RequestInit,
): Promise<allauthAppV1AuthProviderTokenPostResponse> => {
  return fetchAllauth<allauthAppV1AuthProviderTokenPostResponse>(getAllauthAppV1AuthProviderTokenPostUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(providerTokenBody),
  })
}

export const getAllauthAppV1AuthProviderTokenPostMutationOptions = <
  TError = ErrorResponse | AuthenticationResponse | ForbiddenResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1AuthProviderTokenPost>>,
    TError,
    { data: ProviderTokenBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<
  Awaited<ReturnType<typeof allauthAppV1AuthProviderTokenPost>>,
  TError,
  { data: ProviderTokenBody },
  TContext
> => {
  const mutationKey = ['allauthAppV1AuthProviderTokenPost']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allauthAppV1AuthProviderTokenPost>>,
    { data: ProviderTokenBody }
  > = (props) => {
    const { data } = props ?? {}

    return allauthAppV1AuthProviderTokenPost(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthAppV1AuthProviderTokenPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthAppV1AuthProviderTokenPost>>
>
export type AllauthAppV1AuthProviderTokenPostMutationBody = ProviderTokenBody
export type AllauthAppV1AuthProviderTokenPostMutationError = ErrorResponse | AuthenticationResponse | ForbiddenResponse

/**
 * @summary Provider token
 */
export const useAllauthAppV1AuthProviderTokenPost = <
  TError = ErrorResponse | AuthenticationResponse | ForbiddenResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1AuthProviderTokenPost>>,
    TError,
    { data: ProviderTokenBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthAppV1AuthProviderTokenPostMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * If, while signing up using a third-party provider account, there is
insufficient information received from the provider to automatically
complete the signup process, an additional step is needed to complete
the missing data before the user is fully signed up and authenticated.
The information available so far, such as the pending provider account,
can be retrieved via this endpoint.

 * @summary Provider signup information
 */
export type allauthBrowserV1AuthProviderSignupGetResponse200 = {
  data: ProviderSignupResponse
  status: 200
}

export type allauthBrowserV1AuthProviderSignupGetResponse409 = {
  data: ConflictResponse
  status: 409
}

export type allauthBrowserV1AuthProviderSignupGetResponseSuccess = allauthBrowserV1AuthProviderSignupGetResponse200 & {
  headers: Headers
}
export type allauthBrowserV1AuthProviderSignupGetResponseError = allauthBrowserV1AuthProviderSignupGetResponse409 & {
  headers: Headers
}

export type allauthBrowserV1AuthProviderSignupGetResponse =
  | allauthBrowserV1AuthProviderSignupGetResponseSuccess
  | allauthBrowserV1AuthProviderSignupGetResponseError

export const getAllauthBrowserV1AuthProviderSignupGetUrl = () => {
  return `/api/v2/allauth/browser/v1/auth/provider/signup`
}

export const allauthBrowserV1AuthProviderSignupGet = async (
  options?: RequestInit,
): Promise<allauthBrowserV1AuthProviderSignupGetResponse> => {
  return fetchAllauth<allauthBrowserV1AuthProviderSignupGetResponse>(getAllauthBrowserV1AuthProviderSignupGetUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getAllauthBrowserV1AuthProviderSignupGetQueryKey = () => {
  return ['api', 'v2', 'allauth', 'browser', 'v1', 'auth', 'provider', 'signup'] as const
}

export const getAllauthBrowserV1AuthProviderSignupGetQueryOptions = <
  TData = Awaited<ReturnType<typeof allauthBrowserV1AuthProviderSignupGet>>,
  TError = ConflictResponse,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof allauthBrowserV1AuthProviderSignupGet>>, TError, TData>
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAllauthBrowserV1AuthProviderSignupGetQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof allauthBrowserV1AuthProviderSignupGet>>> = ({ signal }) =>
    allauthBrowserV1AuthProviderSignupGet({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AuthProviderSignupGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type AllauthBrowserV1AuthProviderSignupGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof allauthBrowserV1AuthProviderSignupGet>>
>
export type AllauthBrowserV1AuthProviderSignupGetQueryError = ConflictResponse

/**
 * @summary Provider signup information
 */

export function useAllauthBrowserV1AuthProviderSignupGet<
  TData = Awaited<ReturnType<typeof allauthBrowserV1AuthProviderSignupGet>>,
  TError = ConflictResponse,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof allauthBrowserV1AuthProviderSignupGet>>, TError, TData>
  request?: SecondParameter<typeof fetchAllauth>
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAllauthBrowserV1AuthProviderSignupGetQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * If, while signing up using a third-party provider account, there is
insufficient information received from the provider to automatically
complete the signup process, an additional step is needed to complete
the missing data before the user is fully signed up and authenticated.

 * @summary Provider signup
 */
export type allauthBrowserV1AuthProviderSignupPostResponse200 = {
  data: AuthenticatedResponse
  status: 200
}

export type allauthBrowserV1AuthProviderSignupPostResponse400 = {
  data: ErrorResponse
  status: 400
}

export type allauthBrowserV1AuthProviderSignupPostResponse401 = {
  data: AuthenticationResponse
  status: 401
}

export type allauthBrowserV1AuthProviderSignupPostResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type allauthBrowserV1AuthProviderSignupPostResponse409 = {
  data: ConflictResponse
  status: 409
}

export type allauthBrowserV1AuthProviderSignupPostResponseSuccess =
  allauthBrowserV1AuthProviderSignupPostResponse200 & {
    headers: Headers
  }
export type allauthBrowserV1AuthProviderSignupPostResponseError = (
  | allauthBrowserV1AuthProviderSignupPostResponse400
  | allauthBrowserV1AuthProviderSignupPostResponse401
  | allauthBrowserV1AuthProviderSignupPostResponse403
  | allauthBrowserV1AuthProviderSignupPostResponse409
) & {
  headers: Headers
}

export type allauthBrowserV1AuthProviderSignupPostResponse =
  | allauthBrowserV1AuthProviderSignupPostResponseSuccess
  | allauthBrowserV1AuthProviderSignupPostResponseError

export const getAllauthBrowserV1AuthProviderSignupPostUrl = () => {
  return `/api/v2/allauth/browser/v1/auth/provider/signup`
}

export const allauthBrowserV1AuthProviderSignupPost = async (
  providerSignupBody: ProviderSignupBody,
  options?: RequestInit,
): Promise<allauthBrowserV1AuthProviderSignupPostResponse> => {
  return fetchAllauth<allauthBrowserV1AuthProviderSignupPostResponse>(getAllauthBrowserV1AuthProviderSignupPostUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(providerSignupBody),
  })
}

export const getAllauthBrowserV1AuthProviderSignupPostMutationOptions = <
  TError = ErrorResponse | AuthenticationResponse | ForbiddenResponse | ConflictResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AuthProviderSignupPost>>,
    TError,
    { data: ProviderSignupBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<
  Awaited<ReturnType<typeof allauthBrowserV1AuthProviderSignupPost>>,
  TError,
  { data: ProviderSignupBody },
  TContext
> => {
  const mutationKey = ['allauthBrowserV1AuthProviderSignupPost']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allauthBrowserV1AuthProviderSignupPost>>,
    { data: ProviderSignupBody }
  > = (props) => {
    const { data } = props ?? {}

    return allauthBrowserV1AuthProviderSignupPost(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthBrowserV1AuthProviderSignupPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthBrowserV1AuthProviderSignupPost>>
>
export type AllauthBrowserV1AuthProviderSignupPostMutationBody = ProviderSignupBody
export type AllauthBrowserV1AuthProviderSignupPostMutationError =
  | ErrorResponse
  | AuthenticationResponse
  | ForbiddenResponse
  | ConflictResponse

/**
 * @summary Provider signup
 */
export const useAllauthBrowserV1AuthProviderSignupPost = <
  TError = ErrorResponse | AuthenticationResponse | ForbiddenResponse | ConflictResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AuthProviderSignupPost>>,
    TError,
    { data: ProviderSignupBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthBrowserV1AuthProviderSignupPostMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * If, while signing up using a third-party provider account, there is
insufficient information received from the provider to automatically
complete the signup process, an additional step is needed to complete
the missing data before the user is fully signed up and authenticated.
The information available so far, such as the pending provider account,
can be retrieved via this endpoint.

 * @summary Provider signup information
 */
export type allauthAppV1AuthProviderSignupGetResponse200 = {
  data: ProviderSignupResponse
  status: 200
}

export type allauthAppV1AuthProviderSignupGetResponse409 = {
  data: ConflictResponse
  status: 409
}

export type allauthAppV1AuthProviderSignupGetResponseSuccess = allauthAppV1AuthProviderSignupGetResponse200 & {
  headers: Headers
}
export type allauthAppV1AuthProviderSignupGetResponseError = allauthAppV1AuthProviderSignupGetResponse409 & {
  headers: Headers
}

export type allauthAppV1AuthProviderSignupGetResponse =
  | allauthAppV1AuthProviderSignupGetResponseSuccess
  | allauthAppV1AuthProviderSignupGetResponseError

export const getAllauthAppV1AuthProviderSignupGetUrl = () => {
  return `/api/v2/allauth/app/v1/auth/provider/signup`
}

export const allauthAppV1AuthProviderSignupGet = async (
  options?: RequestInit,
): Promise<allauthAppV1AuthProviderSignupGetResponse> => {
  return fetchAllauth<allauthAppV1AuthProviderSignupGetResponse>(getAllauthAppV1AuthProviderSignupGetUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getAllauthAppV1AuthProviderSignupGetQueryKey = () => {
  return ['api', 'v2', 'allauth', 'app', 'v1', 'auth', 'provider', 'signup'] as const
}

export const getAllauthAppV1AuthProviderSignupGetQueryOptions = <
  TData = Awaited<ReturnType<typeof allauthAppV1AuthProviderSignupGet>>,
  TError = ConflictResponse,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof allauthAppV1AuthProviderSignupGet>>, TError, TData>
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAllauthAppV1AuthProviderSignupGetQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof allauthAppV1AuthProviderSignupGet>>> = ({ signal }) =>
    allauthAppV1AuthProviderSignupGet({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof allauthAppV1AuthProviderSignupGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type AllauthAppV1AuthProviderSignupGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof allauthAppV1AuthProviderSignupGet>>
>
export type AllauthAppV1AuthProviderSignupGetQueryError = ConflictResponse

/**
 * @summary Provider signup information
 */

export function useAllauthAppV1AuthProviderSignupGet<
  TData = Awaited<ReturnType<typeof allauthAppV1AuthProviderSignupGet>>,
  TError = ConflictResponse,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof allauthAppV1AuthProviderSignupGet>>, TError, TData>
  request?: SecondParameter<typeof fetchAllauth>
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAllauthAppV1AuthProviderSignupGetQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * If, while signing up using a third-party provider account, there is
insufficient information received from the provider to automatically
complete the signup process, an additional step is needed to complete
the missing data before the user is fully signed up and authenticated.

 * @summary Provider signup
 */
export type allauthAppV1AuthProviderSignupPostResponse200 = {
  data: AuthenticatedResponse
  status: 200
}

export type allauthAppV1AuthProviderSignupPostResponse400 = {
  data: ErrorResponse
  status: 400
}

export type allauthAppV1AuthProviderSignupPostResponse401 = {
  data: AuthenticationResponse
  status: 401
}

export type allauthAppV1AuthProviderSignupPostResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type allauthAppV1AuthProviderSignupPostResponse409 = {
  data: ConflictResponse
  status: 409
}

export type allauthAppV1AuthProviderSignupPostResponseSuccess = allauthAppV1AuthProviderSignupPostResponse200 & {
  headers: Headers
}
export type allauthAppV1AuthProviderSignupPostResponseError = (
  | allauthAppV1AuthProviderSignupPostResponse400
  | allauthAppV1AuthProviderSignupPostResponse401
  | allauthAppV1AuthProviderSignupPostResponse403
  | allauthAppV1AuthProviderSignupPostResponse409
) & {
  headers: Headers
}

export type allauthAppV1AuthProviderSignupPostResponse =
  | allauthAppV1AuthProviderSignupPostResponseSuccess
  | allauthAppV1AuthProviderSignupPostResponseError

export const getAllauthAppV1AuthProviderSignupPostUrl = () => {
  return `/api/v2/allauth/app/v1/auth/provider/signup`
}

export const allauthAppV1AuthProviderSignupPost = async (
  providerSignupBody: ProviderSignupBody,
  options?: RequestInit,
): Promise<allauthAppV1AuthProviderSignupPostResponse> => {
  return fetchAllauth<allauthAppV1AuthProviderSignupPostResponse>(getAllauthAppV1AuthProviderSignupPostUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(providerSignupBody),
  })
}

export const getAllauthAppV1AuthProviderSignupPostMutationOptions = <
  TError = ErrorResponse | AuthenticationResponse | ForbiddenResponse | ConflictResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1AuthProviderSignupPost>>,
    TError,
    { data: ProviderSignupBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<
  Awaited<ReturnType<typeof allauthAppV1AuthProviderSignupPost>>,
  TError,
  { data: ProviderSignupBody },
  TContext
> => {
  const mutationKey = ['allauthAppV1AuthProviderSignupPost']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allauthAppV1AuthProviderSignupPost>>,
    { data: ProviderSignupBody }
  > = (props) => {
    const { data } = props ?? {}

    return allauthAppV1AuthProviderSignupPost(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthAppV1AuthProviderSignupPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthAppV1AuthProviderSignupPost>>
>
export type AllauthAppV1AuthProviderSignupPostMutationBody = ProviderSignupBody
export type AllauthAppV1AuthProviderSignupPostMutationError =
  | ErrorResponse
  | AuthenticationResponse
  | ForbiddenResponse
  | ConflictResponse

/**
 * @summary Provider signup
 */
export const useAllauthAppV1AuthProviderSignupPost = <
  TError = ErrorResponse | AuthenticationResponse | ForbiddenResponse | ConflictResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1AuthProviderSignupPost>>,
    TError,
    { data: ProviderSignupBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthAppV1AuthProviderSignupPostMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * If, during authentication,  a response with status 401 is encountered where one of the pending
flows has ID `mfa_authenticate`, that indicates that the Two-Factor Authentication stage needs to
be completed.

 * @summary Two-factor authentication
 */
export type allauthBrowserV1Auth2faAuthenticatePostResponse200 = {
  data: AuthenticatedByPasswordAnd2FAResponse
  status: 200
}

export type allauthBrowserV1Auth2faAuthenticatePostResponse400 = {
  data: ErrorResponse
  status: 400
}

export type allauthBrowserV1Auth2faAuthenticatePostResponse401 = {
  data: AuthenticationResponse
  status: 401
}

export type allauthBrowserV1Auth2faAuthenticatePostResponseSuccess =
  allauthBrowserV1Auth2faAuthenticatePostResponse200 & {
    headers: Headers
  }
export type allauthBrowserV1Auth2faAuthenticatePostResponseError = (
  | allauthBrowserV1Auth2faAuthenticatePostResponse400
  | allauthBrowserV1Auth2faAuthenticatePostResponse401
) & {
  headers: Headers
}

export type allauthBrowserV1Auth2faAuthenticatePostResponse =
  | allauthBrowserV1Auth2faAuthenticatePostResponseSuccess
  | allauthBrowserV1Auth2faAuthenticatePostResponseError

export const getAllauthBrowserV1Auth2faAuthenticatePostUrl = () => {
  return `/api/v2/allauth/browser/v1/auth/2fa/authenticate`
}

export const allauthBrowserV1Auth2faAuthenticatePost = async (
  mFAAuthenticateBody: MFAAuthenticateBody,
  options?: RequestInit,
): Promise<allauthBrowserV1Auth2faAuthenticatePostResponse> => {
  return fetchAllauth<allauthBrowserV1Auth2faAuthenticatePostResponse>(
    getAllauthBrowserV1Auth2faAuthenticatePostUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(mFAAuthenticateBody),
    },
  )
}

export const getAllauthBrowserV1Auth2faAuthenticatePostMutationOptions = <
  TError = ErrorResponse | AuthenticationResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1Auth2faAuthenticatePost>>,
    TError,
    { data: MFAAuthenticateBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<
  Awaited<ReturnType<typeof allauthBrowserV1Auth2faAuthenticatePost>>,
  TError,
  { data: MFAAuthenticateBody },
  TContext
> => {
  const mutationKey = ['allauthBrowserV1Auth2faAuthenticatePost']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allauthBrowserV1Auth2faAuthenticatePost>>,
    { data: MFAAuthenticateBody }
  > = (props) => {
    const { data } = props ?? {}

    return allauthBrowserV1Auth2faAuthenticatePost(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthBrowserV1Auth2faAuthenticatePostMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthBrowserV1Auth2faAuthenticatePost>>
>
export type AllauthBrowserV1Auth2faAuthenticatePostMutationBody = MFAAuthenticateBody
export type AllauthBrowserV1Auth2faAuthenticatePostMutationError = ErrorResponse | AuthenticationResponse

/**
 * @summary Two-factor authentication
 */
export const useAllauthBrowserV1Auth2faAuthenticatePost = <
  TError = ErrorResponse | AuthenticationResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1Auth2faAuthenticatePost>>,
    TError,
    { data: MFAAuthenticateBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthBrowserV1Auth2faAuthenticatePostMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * If, during authentication,  a response with status 401 is encountered where one of the pending
flows has ID `mfa_authenticate`, that indicates that the Two-Factor Authentication stage needs to
be completed.

 * @summary Two-factor authentication
 */
export type allauthAppV1Auth2faAuthenticatePostResponse200 = {
  data: AuthenticatedByPasswordAnd2FAResponse
  status: 200
}

export type allauthAppV1Auth2faAuthenticatePostResponse400 = {
  data: ErrorResponse
  status: 400
}

export type allauthAppV1Auth2faAuthenticatePostResponse401 = {
  data: AuthenticationResponse
  status: 401
}

export type allauthAppV1Auth2faAuthenticatePostResponseSuccess = allauthAppV1Auth2faAuthenticatePostResponse200 & {
  headers: Headers
}
export type allauthAppV1Auth2faAuthenticatePostResponseError = (
  | allauthAppV1Auth2faAuthenticatePostResponse400
  | allauthAppV1Auth2faAuthenticatePostResponse401
) & {
  headers: Headers
}

export type allauthAppV1Auth2faAuthenticatePostResponse =
  | allauthAppV1Auth2faAuthenticatePostResponseSuccess
  | allauthAppV1Auth2faAuthenticatePostResponseError

export const getAllauthAppV1Auth2faAuthenticatePostUrl = () => {
  return `/api/v2/allauth/app/v1/auth/2fa/authenticate`
}

export const allauthAppV1Auth2faAuthenticatePost = async (
  mFAAuthenticateBody: MFAAuthenticateBody,
  options?: RequestInit,
): Promise<allauthAppV1Auth2faAuthenticatePostResponse> => {
  return fetchAllauth<allauthAppV1Auth2faAuthenticatePostResponse>(getAllauthAppV1Auth2faAuthenticatePostUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(mFAAuthenticateBody),
  })
}

export const getAllauthAppV1Auth2faAuthenticatePostMutationOptions = <
  TError = ErrorResponse | AuthenticationResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1Auth2faAuthenticatePost>>,
    TError,
    { data: MFAAuthenticateBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<
  Awaited<ReturnType<typeof allauthAppV1Auth2faAuthenticatePost>>,
  TError,
  { data: MFAAuthenticateBody },
  TContext
> => {
  const mutationKey = ['allauthAppV1Auth2faAuthenticatePost']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allauthAppV1Auth2faAuthenticatePost>>,
    { data: MFAAuthenticateBody }
  > = (props) => {
    const { data } = props ?? {}

    return allauthAppV1Auth2faAuthenticatePost(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthAppV1Auth2faAuthenticatePostMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthAppV1Auth2faAuthenticatePost>>
>
export type AllauthAppV1Auth2faAuthenticatePostMutationBody = MFAAuthenticateBody
export type AllauthAppV1Auth2faAuthenticatePostMutationError = ErrorResponse | AuthenticationResponse

/**
 * @summary Two-factor authentication
 */
export const useAllauthAppV1Auth2faAuthenticatePost = <
  TError = ErrorResponse | AuthenticationResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1Auth2faAuthenticatePost>>,
    TError,
    { data: MFAAuthenticateBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthAppV1Auth2faAuthenticatePostMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * In order to safeguard the account, some actions require the user to be
recently authenticated.  If you try to perform such an action without
having been recently authenticated, a `401` status is returned, listing
flows that can be performed to reauthenticate. One such flow is the flow
with ID `mfa_reauthenticate`, which allows for the user to input an
authenticator code (e.g. TOTP or recovery code). This is the endpoint
related towards that flow.

 * @summary Reauthenticate using 2FA
 */
export type allauthBrowserV1Auth2faReauthenticatePostResponse200 = {
  data: AuthenticatedByPasswordAnd2FAResponse
  status: 200
}

export type allauthBrowserV1Auth2faReauthenticatePostResponse400 = {
  data: ErrorResponse
  status: 400
}

export type allauthBrowserV1Auth2faReauthenticatePostResponseSuccess =
  allauthBrowserV1Auth2faReauthenticatePostResponse200 & {
    headers: Headers
  }
export type allauthBrowserV1Auth2faReauthenticatePostResponseError =
  allauthBrowserV1Auth2faReauthenticatePostResponse400 & {
    headers: Headers
  }

export type allauthBrowserV1Auth2faReauthenticatePostResponse =
  | allauthBrowserV1Auth2faReauthenticatePostResponseSuccess
  | allauthBrowserV1Auth2faReauthenticatePostResponseError

export const getAllauthBrowserV1Auth2faReauthenticatePostUrl = () => {
  return `/api/v2/allauth/browser/v1/auth/2fa/reauthenticate`
}

export const allauthBrowserV1Auth2faReauthenticatePost = async (
  mFAAuthenticateBody: MFAAuthenticateBody,
  options?: RequestInit,
): Promise<allauthBrowserV1Auth2faReauthenticatePostResponse> => {
  return fetchAllauth<allauthBrowserV1Auth2faReauthenticatePostResponse>(
    getAllauthBrowserV1Auth2faReauthenticatePostUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(mFAAuthenticateBody),
    },
  )
}

export const getAllauthBrowserV1Auth2faReauthenticatePostMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1Auth2faReauthenticatePost>>,
    TError,
    { data: MFAAuthenticateBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<
  Awaited<ReturnType<typeof allauthBrowserV1Auth2faReauthenticatePost>>,
  TError,
  { data: MFAAuthenticateBody },
  TContext
> => {
  const mutationKey = ['allauthBrowserV1Auth2faReauthenticatePost']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allauthBrowserV1Auth2faReauthenticatePost>>,
    { data: MFAAuthenticateBody }
  > = (props) => {
    const { data } = props ?? {}

    return allauthBrowserV1Auth2faReauthenticatePost(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthBrowserV1Auth2faReauthenticatePostMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthBrowserV1Auth2faReauthenticatePost>>
>
export type AllauthBrowserV1Auth2faReauthenticatePostMutationBody = MFAAuthenticateBody
export type AllauthBrowserV1Auth2faReauthenticatePostMutationError = ErrorResponse

/**
 * @summary Reauthenticate using 2FA
 */
export const useAllauthBrowserV1Auth2faReauthenticatePost = <TError = ErrorResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1Auth2faReauthenticatePost>>,
    TError,
    { data: MFAAuthenticateBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthBrowserV1Auth2faReauthenticatePostMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * In order to safeguard the account, some actions require the user to be
recently authenticated.  If you try to perform such an action without
having been recently authenticated, a `401` status is returned, listing
flows that can be performed to reauthenticate. One such flow is the flow
with ID `mfa_reauthenticate`, which allows for the user to input an
authenticator code (e.g. TOTP or recovery code). This is the endpoint
related towards that flow.

 * @summary Reauthenticate using 2FA
 */
export type allauthAppV1Auth2faReauthenticatePostResponse200 = {
  data: AuthenticatedByPasswordAnd2FAResponse
  status: 200
}

export type allauthAppV1Auth2faReauthenticatePostResponse400 = {
  data: ErrorResponse
  status: 400
}

export type allauthAppV1Auth2faReauthenticatePostResponseSuccess = allauthAppV1Auth2faReauthenticatePostResponse200 & {
  headers: Headers
}
export type allauthAppV1Auth2faReauthenticatePostResponseError = allauthAppV1Auth2faReauthenticatePostResponse400 & {
  headers: Headers
}

export type allauthAppV1Auth2faReauthenticatePostResponse =
  | allauthAppV1Auth2faReauthenticatePostResponseSuccess
  | allauthAppV1Auth2faReauthenticatePostResponseError

export const getAllauthAppV1Auth2faReauthenticatePostUrl = () => {
  return `/api/v2/allauth/app/v1/auth/2fa/reauthenticate`
}

export const allauthAppV1Auth2faReauthenticatePost = async (
  mFAAuthenticateBody: MFAAuthenticateBody,
  options?: RequestInit,
): Promise<allauthAppV1Auth2faReauthenticatePostResponse> => {
  return fetchAllauth<allauthAppV1Auth2faReauthenticatePostResponse>(getAllauthAppV1Auth2faReauthenticatePostUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(mFAAuthenticateBody),
  })
}

export const getAllauthAppV1Auth2faReauthenticatePostMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1Auth2faReauthenticatePost>>,
    TError,
    { data: MFAAuthenticateBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<
  Awaited<ReturnType<typeof allauthAppV1Auth2faReauthenticatePost>>,
  TError,
  { data: MFAAuthenticateBody },
  TContext
> => {
  const mutationKey = ['allauthAppV1Auth2faReauthenticatePost']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allauthAppV1Auth2faReauthenticatePost>>,
    { data: MFAAuthenticateBody }
  > = (props) => {
    const { data } = props ?? {}

    return allauthAppV1Auth2faReauthenticatePost(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthAppV1Auth2faReauthenticatePostMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthAppV1Auth2faReauthenticatePost>>
>
export type AllauthAppV1Auth2faReauthenticatePostMutationBody = MFAAuthenticateBody
export type AllauthAppV1Auth2faReauthenticatePostMutationError = ErrorResponse

/**
 * @summary Reauthenticate using 2FA
 */
export const useAllauthAppV1Auth2faReauthenticatePost = <TError = ErrorResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1Auth2faReauthenticatePost>>,
    TError,
    { data: MFAAuthenticateBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthAppV1Auth2faReauthenticatePostMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Use this endpoint to pass along the received "special" login code.

 * @summary Confirm login code
 */
export type allauthBrowserV1AuthCodeConfirmPostResponse200 = {
  data: AuthenticatedByCodeResponse
  status: 200
}

export type allauthBrowserV1AuthCodeConfirmPostResponse400 = {
  data: ErrorResponse
  status: 400
}

export type allauthBrowserV1AuthCodeConfirmPostResponse401 = {
  data: AuthenticationResponse
  status: 401
}

export type allauthBrowserV1AuthCodeConfirmPostResponse409 = {
  data: ConflictResponse
  status: 409
}

export type allauthBrowserV1AuthCodeConfirmPostResponseSuccess = allauthBrowserV1AuthCodeConfirmPostResponse200 & {
  headers: Headers
}
export type allauthBrowserV1AuthCodeConfirmPostResponseError = (
  | allauthBrowserV1AuthCodeConfirmPostResponse400
  | allauthBrowserV1AuthCodeConfirmPostResponse401
  | allauthBrowserV1AuthCodeConfirmPostResponse409
) & {
  headers: Headers
}

export type allauthBrowserV1AuthCodeConfirmPostResponse =
  | allauthBrowserV1AuthCodeConfirmPostResponseSuccess
  | allauthBrowserV1AuthCodeConfirmPostResponseError

export const getAllauthBrowserV1AuthCodeConfirmPostUrl = () => {
  return `/api/v2/allauth/browser/v1/auth/code/confirm`
}

export const allauthBrowserV1AuthCodeConfirmPost = async (
  confirmLoginCodeBody: ConfirmLoginCodeBody,
  options?: RequestInit,
): Promise<allauthBrowserV1AuthCodeConfirmPostResponse> => {
  return fetchAllauth<allauthBrowserV1AuthCodeConfirmPostResponse>(getAllauthBrowserV1AuthCodeConfirmPostUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(confirmLoginCodeBody),
  })
}

export const getAllauthBrowserV1AuthCodeConfirmPostMutationOptions = <
  TError = ErrorResponse | AuthenticationResponse | ConflictResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AuthCodeConfirmPost>>,
    TError,
    { data: ConfirmLoginCodeBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<
  Awaited<ReturnType<typeof allauthBrowserV1AuthCodeConfirmPost>>,
  TError,
  { data: ConfirmLoginCodeBody },
  TContext
> => {
  const mutationKey = ['allauthBrowserV1AuthCodeConfirmPost']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allauthBrowserV1AuthCodeConfirmPost>>,
    { data: ConfirmLoginCodeBody }
  > = (props) => {
    const { data } = props ?? {}

    return allauthBrowserV1AuthCodeConfirmPost(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthBrowserV1AuthCodeConfirmPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthBrowserV1AuthCodeConfirmPost>>
>
export type AllauthBrowserV1AuthCodeConfirmPostMutationBody = ConfirmLoginCodeBody
export type AllauthBrowserV1AuthCodeConfirmPostMutationError = ErrorResponse | AuthenticationResponse | ConflictResponse

/**
 * @summary Confirm login code
 */
export const useAllauthBrowserV1AuthCodeConfirmPost = <
  TError = ErrorResponse | AuthenticationResponse | ConflictResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AuthCodeConfirmPost>>,
    TError,
    { data: ConfirmLoginCodeBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthBrowserV1AuthCodeConfirmPostMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Use this endpoint to pass along the received "special" login code.

 * @summary Confirm login code
 */
export type allauthAppV1AuthCodeConfirmPostResponse200 = {
  data: AuthenticatedByCodeResponse
  status: 200
}

export type allauthAppV1AuthCodeConfirmPostResponse400 = {
  data: ErrorResponse
  status: 400
}

export type allauthAppV1AuthCodeConfirmPostResponse401 = {
  data: AuthenticationResponse
  status: 401
}

export type allauthAppV1AuthCodeConfirmPostResponse409 = {
  data: ConflictResponse
  status: 409
}

export type allauthAppV1AuthCodeConfirmPostResponseSuccess = allauthAppV1AuthCodeConfirmPostResponse200 & {
  headers: Headers
}
export type allauthAppV1AuthCodeConfirmPostResponseError = (
  | allauthAppV1AuthCodeConfirmPostResponse400
  | allauthAppV1AuthCodeConfirmPostResponse401
  | allauthAppV1AuthCodeConfirmPostResponse409
) & {
  headers: Headers
}

export type allauthAppV1AuthCodeConfirmPostResponse =
  | allauthAppV1AuthCodeConfirmPostResponseSuccess
  | allauthAppV1AuthCodeConfirmPostResponseError

export const getAllauthAppV1AuthCodeConfirmPostUrl = () => {
  return `/api/v2/allauth/app/v1/auth/code/confirm`
}

export const allauthAppV1AuthCodeConfirmPost = async (
  confirmLoginCodeBody: ConfirmLoginCodeBody,
  options?: RequestInit,
): Promise<allauthAppV1AuthCodeConfirmPostResponse> => {
  return fetchAllauth<allauthAppV1AuthCodeConfirmPostResponse>(getAllauthAppV1AuthCodeConfirmPostUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(confirmLoginCodeBody),
  })
}

export const getAllauthAppV1AuthCodeConfirmPostMutationOptions = <
  TError = ErrorResponse | AuthenticationResponse | ConflictResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1AuthCodeConfirmPost>>,
    TError,
    { data: ConfirmLoginCodeBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<
  Awaited<ReturnType<typeof allauthAppV1AuthCodeConfirmPost>>,
  TError,
  { data: ConfirmLoginCodeBody },
  TContext
> => {
  const mutationKey = ['allauthAppV1AuthCodeConfirmPost']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allauthAppV1AuthCodeConfirmPost>>,
    { data: ConfirmLoginCodeBody }
  > = (props) => {
    const { data } = props ?? {}

    return allauthAppV1AuthCodeConfirmPost(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthAppV1AuthCodeConfirmPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthAppV1AuthCodeConfirmPost>>
>
export type AllauthAppV1AuthCodeConfirmPostMutationBody = ConfirmLoginCodeBody
export type AllauthAppV1AuthCodeConfirmPostMutationError = ErrorResponse | AuthenticationResponse | ConflictResponse

/**
 * @summary Confirm login code
 */
export const useAllauthAppV1AuthCodeConfirmPost = <
  TError = ErrorResponse | AuthenticationResponse | ConflictResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1AuthCodeConfirmPost>>,
    TError,
    { data: ConfirmLoginCodeBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthAppV1AuthCodeConfirmPostMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * @summary List the connected third-party provider accounts
 */
export type allauthBrowserV1AccountProvidersGetResponse200 = {
  data: ProviderAccountsResponse
  status: 200
}

export type allauthBrowserV1AccountProvidersGetResponseSuccess = allauthBrowserV1AccountProvidersGetResponse200 & {
  headers: Headers
}

export type allauthBrowserV1AccountProvidersGetResponse = allauthBrowserV1AccountProvidersGetResponseSuccess

export const getAllauthBrowserV1AccountProvidersGetUrl = () => {
  return `/api/v2/allauth/browser/v1/account/providers`
}

export const allauthBrowserV1AccountProvidersGet = async (
  options?: RequestInit,
): Promise<allauthBrowserV1AccountProvidersGetResponse> => {
  return fetchAllauth<allauthBrowserV1AccountProvidersGetResponse>(getAllauthBrowserV1AccountProvidersGetUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getAllauthBrowserV1AccountProvidersGetQueryKey = () => {
  return ['api', 'v2', 'allauth', 'browser', 'v1', 'account', 'providers'] as const
}

export const getAllauthBrowserV1AccountProvidersGetQueryOptions = <
  TData = Awaited<ReturnType<typeof allauthBrowserV1AccountProvidersGet>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof allauthBrowserV1AccountProvidersGet>>, TError, TData>
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAllauthBrowserV1AccountProvidersGetQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof allauthBrowserV1AccountProvidersGet>>> = ({ signal }) =>
    allauthBrowserV1AccountProvidersGet({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AccountProvidersGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type AllauthBrowserV1AccountProvidersGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof allauthBrowserV1AccountProvidersGet>>
>
export type AllauthBrowserV1AccountProvidersGetQueryError = unknown

/**
 * @summary List the connected third-party provider accounts
 */

export function useAllauthBrowserV1AccountProvidersGet<
  TData = Awaited<ReturnType<typeof allauthBrowserV1AccountProvidersGet>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof allauthBrowserV1AccountProvidersGet>>, TError, TData>
  request?: SecondParameter<typeof fetchAllauth>
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAllauthBrowserV1AccountProvidersGetQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * Disconnect a third-party provider account, returning the remaining
accounts that are still connected. The disconnect is not allowed if it
would leave the account unusable. For example, if no password was
set up yet.

 * @summary Disconnect a third-party provider account

 */
export type allauthBrowserV1AccountProvidersDeleteResponse200 = {
  data: ProviderAccountsResponse
  status: 200
}

export type allauthBrowserV1AccountProvidersDeleteResponse400 = {
  data: ErrorResponse
  status: 400
}

export type allauthBrowserV1AccountProvidersDeleteResponseSuccess =
  allauthBrowserV1AccountProvidersDeleteResponse200 & {
    headers: Headers
  }
export type allauthBrowserV1AccountProvidersDeleteResponseError = allauthBrowserV1AccountProvidersDeleteResponse400 & {
  headers: Headers
}

export type allauthBrowserV1AccountProvidersDeleteResponse =
  | allauthBrowserV1AccountProvidersDeleteResponseSuccess
  | allauthBrowserV1AccountProvidersDeleteResponseError

export const getAllauthBrowserV1AccountProvidersDeleteUrl = () => {
  return `/api/v2/allauth/browser/v1/account/providers`
}

export const allauthBrowserV1AccountProvidersDelete = async (
  providerAccountBody: ProviderAccountBody,
  options?: RequestInit,
): Promise<allauthBrowserV1AccountProvidersDeleteResponse> => {
  return fetchAllauth<allauthBrowserV1AccountProvidersDeleteResponse>(getAllauthBrowserV1AccountProvidersDeleteUrl(), {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(providerAccountBody),
  })
}

export const getAllauthBrowserV1AccountProvidersDeleteMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AccountProvidersDelete>>,
    TError,
    { data: ProviderAccountBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<
  Awaited<ReturnType<typeof allauthBrowserV1AccountProvidersDelete>>,
  TError,
  { data: ProviderAccountBody },
  TContext
> => {
  const mutationKey = ['allauthBrowserV1AccountProvidersDelete']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allauthBrowserV1AccountProvidersDelete>>,
    { data: ProviderAccountBody }
  > = (props) => {
    const { data } = props ?? {}

    return allauthBrowserV1AccountProvidersDelete(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthBrowserV1AccountProvidersDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthBrowserV1AccountProvidersDelete>>
>
export type AllauthBrowserV1AccountProvidersDeleteMutationBody = ProviderAccountBody
export type AllauthBrowserV1AccountProvidersDeleteMutationError = ErrorResponse

/**
 * @summary Disconnect a third-party provider account

 */
export const useAllauthBrowserV1AccountProvidersDelete = <TError = ErrorResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AccountProvidersDelete>>,
    TError,
    { data: ProviderAccountBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthBrowserV1AccountProvidersDeleteMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * @summary List the connected third-party provider accounts
 */
export type allauthAppV1AccountProvidersGetResponse200 = {
  data: ProviderAccountsResponse
  status: 200
}

export type allauthAppV1AccountProvidersGetResponseSuccess = allauthAppV1AccountProvidersGetResponse200 & {
  headers: Headers
}

export type allauthAppV1AccountProvidersGetResponse = allauthAppV1AccountProvidersGetResponseSuccess

export const getAllauthAppV1AccountProvidersGetUrl = () => {
  return `/api/v2/allauth/app/v1/account/providers`
}

export const allauthAppV1AccountProvidersGet = async (
  options?: RequestInit,
): Promise<allauthAppV1AccountProvidersGetResponse> => {
  return fetchAllauth<allauthAppV1AccountProvidersGetResponse>(getAllauthAppV1AccountProvidersGetUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getAllauthAppV1AccountProvidersGetQueryKey = () => {
  return ['api', 'v2', 'allauth', 'app', 'v1', 'account', 'providers'] as const
}

export const getAllauthAppV1AccountProvidersGetQueryOptions = <
  TData = Awaited<ReturnType<typeof allauthAppV1AccountProvidersGet>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof allauthAppV1AccountProvidersGet>>, TError, TData>
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAllauthAppV1AccountProvidersGetQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof allauthAppV1AccountProvidersGet>>> = ({ signal }) =>
    allauthAppV1AccountProvidersGet({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof allauthAppV1AccountProvidersGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type AllauthAppV1AccountProvidersGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof allauthAppV1AccountProvidersGet>>
>
export type AllauthAppV1AccountProvidersGetQueryError = unknown

/**
 * @summary List the connected third-party provider accounts
 */

export function useAllauthAppV1AccountProvidersGet<
  TData = Awaited<ReturnType<typeof allauthAppV1AccountProvidersGet>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof allauthAppV1AccountProvidersGet>>, TError, TData>
  request?: SecondParameter<typeof fetchAllauth>
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAllauthAppV1AccountProvidersGetQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * Disconnect a third-party provider account, returning the remaining
accounts that are still connected. The disconnect is not allowed if it
would leave the account unusable. For example, if no password was
set up yet.

 * @summary Disconnect a third-party provider account

 */
export type allauthAppV1AccountProvidersDeleteResponse200 = {
  data: ProviderAccountsResponse
  status: 200
}

export type allauthAppV1AccountProvidersDeleteResponse400 = {
  data: ErrorResponse
  status: 400
}

export type allauthAppV1AccountProvidersDeleteResponseSuccess = allauthAppV1AccountProvidersDeleteResponse200 & {
  headers: Headers
}
export type allauthAppV1AccountProvidersDeleteResponseError = allauthAppV1AccountProvidersDeleteResponse400 & {
  headers: Headers
}

export type allauthAppV1AccountProvidersDeleteResponse =
  | allauthAppV1AccountProvidersDeleteResponseSuccess
  | allauthAppV1AccountProvidersDeleteResponseError

export const getAllauthAppV1AccountProvidersDeleteUrl = () => {
  return `/api/v2/allauth/app/v1/account/providers`
}

export const allauthAppV1AccountProvidersDelete = async (
  providerAccountBody: ProviderAccountBody,
  options?: RequestInit,
): Promise<allauthAppV1AccountProvidersDeleteResponse> => {
  return fetchAllauth<allauthAppV1AccountProvidersDeleteResponse>(getAllauthAppV1AccountProvidersDeleteUrl(), {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(providerAccountBody),
  })
}

export const getAllauthAppV1AccountProvidersDeleteMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1AccountProvidersDelete>>,
    TError,
    { data: ProviderAccountBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<
  Awaited<ReturnType<typeof allauthAppV1AccountProvidersDelete>>,
  TError,
  { data: ProviderAccountBody },
  TContext
> => {
  const mutationKey = ['allauthAppV1AccountProvidersDelete']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allauthAppV1AccountProvidersDelete>>,
    { data: ProviderAccountBody }
  > = (props) => {
    const { data } = props ?? {}

    return allauthAppV1AccountProvidersDelete(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthAppV1AccountProvidersDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthAppV1AccountProvidersDelete>>
>
export type AllauthAppV1AccountProvidersDeleteMutationBody = ProviderAccountBody
export type AllauthAppV1AccountProvidersDeleteMutationError = ErrorResponse

/**
 * @summary Disconnect a third-party provider account

 */
export const useAllauthAppV1AccountProvidersDelete = <TError = ErrorResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1AccountProvidersDelete>>,
    TError,
    { data: ProviderAccountBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthAppV1AccountProvidersDeleteMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Retrieves the list of email addresses of the account.

 * @summary List email addresses
 */
export type allauthBrowserV1AccountEmailGetResponse200 = {
  data: EmailAddressesResponse
  status: 200
}

export type allauthBrowserV1AccountEmailGetResponse401 = {
  data: AuthenticationResponse
  status: 401
}

export type allauthBrowserV1AccountEmailGetResponseSuccess = allauthBrowserV1AccountEmailGetResponse200 & {
  headers: Headers
}
export type allauthBrowserV1AccountEmailGetResponseError = allauthBrowserV1AccountEmailGetResponse401 & {
  headers: Headers
}

export type allauthBrowserV1AccountEmailGetResponse =
  | allauthBrowserV1AccountEmailGetResponseSuccess
  | allauthBrowserV1AccountEmailGetResponseError

export const getAllauthBrowserV1AccountEmailGetUrl = () => {
  return `/api/v2/allauth/browser/v1/account/email`
}

export const allauthBrowserV1AccountEmailGet = async (
  options?: RequestInit,
): Promise<allauthBrowserV1AccountEmailGetResponse> => {
  return fetchAllauth<allauthBrowserV1AccountEmailGetResponse>(getAllauthBrowserV1AccountEmailGetUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getAllauthBrowserV1AccountEmailGetQueryKey = () => {
  return ['api', 'v2', 'allauth', 'browser', 'v1', 'account', 'email'] as const
}

export const getAllauthBrowserV1AccountEmailGetQueryOptions = <
  TData = Awaited<ReturnType<typeof allauthBrowserV1AccountEmailGet>>,
  TError = AuthenticationResponse,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof allauthBrowserV1AccountEmailGet>>, TError, TData>
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAllauthBrowserV1AccountEmailGetQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof allauthBrowserV1AccountEmailGet>>> = ({ signal }) =>
    allauthBrowserV1AccountEmailGet({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AccountEmailGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type AllauthBrowserV1AccountEmailGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof allauthBrowserV1AccountEmailGet>>
>
export type AllauthBrowserV1AccountEmailGetQueryError = AuthenticationResponse

/**
 * @summary List email addresses
 */

export function useAllauthBrowserV1AccountEmailGet<
  TData = Awaited<ReturnType<typeof allauthBrowserV1AccountEmailGet>>,
  TError = AuthenticationResponse,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof allauthBrowserV1AccountEmailGet>>, TError, TData>
  request?: SecondParameter<typeof fetchAllauth>
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAllauthBrowserV1AccountEmailGetQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * The following functionality is available:

  - Adding a new email address for an already signed in user (`ACCOUNT_CHANGE_EMAIL = False`).
  - Change to a new email address for an already signed in user   (`ACCOUNT_CHANGE_EMAIL = True`).
  - Change to a new email address during the email verification process at signup (`ACCOUNT_EMAIL_VERIFICATION_SUPPORTS_CHANGE = True`).

In all cases, an email verification mail will be sent containing a link or code that needs to be verified.

 * @summary Add/Change email address

 */
export type allauthBrowserV1AccountEmailPostResponse200 = {
  data: EmailAddressesResponse
  status: 200
}

export type allauthBrowserV1AccountEmailPostResponse400 = {
  data: ErrorResponse
  status: 400
}

export type allauthBrowserV1AccountEmailPostResponse401 = {
  data: AuthenticationOrReauthenticationResponse
  status: 401
}

export type allauthBrowserV1AccountEmailPostResponse409 = {
  data: ConflictResponse
  status: 409
}

export type allauthBrowserV1AccountEmailPostResponseSuccess = allauthBrowserV1AccountEmailPostResponse200 & {
  headers: Headers
}
export type allauthBrowserV1AccountEmailPostResponseError = (
  | allauthBrowserV1AccountEmailPostResponse400
  | allauthBrowserV1AccountEmailPostResponse401
  | allauthBrowserV1AccountEmailPostResponse409
) & {
  headers: Headers
}

export type allauthBrowserV1AccountEmailPostResponse =
  | allauthBrowserV1AccountEmailPostResponseSuccess
  | allauthBrowserV1AccountEmailPostResponseError

export const getAllauthBrowserV1AccountEmailPostUrl = () => {
  return `/api/v2/allauth/browser/v1/account/email`
}

export const allauthBrowserV1AccountEmailPost = async (
  emailBody: EmailBody,
  options?: RequestInit,
): Promise<allauthBrowserV1AccountEmailPostResponse> => {
  return fetchAllauth<allauthBrowserV1AccountEmailPostResponse>(getAllauthBrowserV1AccountEmailPostUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(emailBody),
  })
}

export const getAllauthBrowserV1AccountEmailPostMutationOptions = <
  TError = ErrorResponse | AuthenticationOrReauthenticationResponse | ConflictResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AccountEmailPost>>,
    TError,
    { data: EmailBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<
  Awaited<ReturnType<typeof allauthBrowserV1AccountEmailPost>>,
  TError,
  { data: EmailBody },
  TContext
> => {
  const mutationKey = ['allauthBrowserV1AccountEmailPost']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allauthBrowserV1AccountEmailPost>>,
    { data: EmailBody }
  > = (props) => {
    const { data } = props ?? {}

    return allauthBrowserV1AccountEmailPost(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthBrowserV1AccountEmailPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthBrowserV1AccountEmailPost>>
>
export type AllauthBrowserV1AccountEmailPostMutationBody = EmailBody
export type AllauthBrowserV1AccountEmailPostMutationError =
  | ErrorResponse
  | AuthenticationOrReauthenticationResponse
  | ConflictResponse

/**
 * @summary Add/Change email address

 */
export const useAllauthBrowserV1AccountEmailPost = <
  TError = ErrorResponse | AuthenticationOrReauthenticationResponse | ConflictResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AccountEmailPost>>,
    TError,
    { data: EmailBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthBrowserV1AccountEmailPostMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Requests for (another) email verification email to be sent. Note that
sending emails is rate limited, so when you send too many requests the
email will not be sent.

 * @summary Request email verification
 */
export type allauthBrowserV1AccountEmailPutResponse200 = {
  data: StatusOKResponse
  status: 200
}

export type allauthBrowserV1AccountEmailPutResponse400 = {
  data: ErrorResponse
  status: 400
}

export type allauthBrowserV1AccountEmailPutResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type allauthBrowserV1AccountEmailPutResponseSuccess = allauthBrowserV1AccountEmailPutResponse200 & {
  headers: Headers
}
export type allauthBrowserV1AccountEmailPutResponseError = (
  | allauthBrowserV1AccountEmailPutResponse400
  | allauthBrowserV1AccountEmailPutResponse403
) & {
  headers: Headers
}

export type allauthBrowserV1AccountEmailPutResponse =
  | allauthBrowserV1AccountEmailPutResponseSuccess
  | allauthBrowserV1AccountEmailPutResponseError

export const getAllauthBrowserV1AccountEmailPutUrl = () => {
  return `/api/v2/allauth/browser/v1/account/email`
}

export const allauthBrowserV1AccountEmailPut = async (
  emailBody: EmailBody,
  options?: RequestInit,
): Promise<allauthBrowserV1AccountEmailPutResponse> => {
  return fetchAllauth<allauthBrowserV1AccountEmailPutResponse>(getAllauthBrowserV1AccountEmailPutUrl(), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(emailBody),
  })
}

export const getAllauthBrowserV1AccountEmailPutMutationOptions = <
  TError = ErrorResponse | ForbiddenResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AccountEmailPut>>,
    TError,
    { data: EmailBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<
  Awaited<ReturnType<typeof allauthBrowserV1AccountEmailPut>>,
  TError,
  { data: EmailBody },
  TContext
> => {
  const mutationKey = ['allauthBrowserV1AccountEmailPut']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allauthBrowserV1AccountEmailPut>>,
    { data: EmailBody }
  > = (props) => {
    const { data } = props ?? {}

    return allauthBrowserV1AccountEmailPut(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthBrowserV1AccountEmailPutMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthBrowserV1AccountEmailPut>>
>
export type AllauthBrowserV1AccountEmailPutMutationBody = EmailBody
export type AllauthBrowserV1AccountEmailPutMutationError = ErrorResponse | ForbiddenResponse

/**
 * @summary Request email verification
 */
export const useAllauthBrowserV1AccountEmailPut = <
  TError = ErrorResponse | ForbiddenResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AccountEmailPut>>,
    TError,
    { data: EmailBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthBrowserV1AccountEmailPutMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Used to change primary email address to a different one. Note that only verified email addresses
can be marked as primary.

 * @summary Change primary email address
 */
export type allauthBrowserV1AccountEmailPatchResponse200 = {
  data: EmailAddressesResponse
  status: 200
}

export type allauthBrowserV1AccountEmailPatchResponse400 = {
  data: ErrorResponse
  status: 400
}

export type allauthBrowserV1AccountEmailPatchResponseSuccess = allauthBrowserV1AccountEmailPatchResponse200 & {
  headers: Headers
}
export type allauthBrowserV1AccountEmailPatchResponseError = allauthBrowserV1AccountEmailPatchResponse400 & {
  headers: Headers
}

export type allauthBrowserV1AccountEmailPatchResponse =
  | allauthBrowserV1AccountEmailPatchResponseSuccess
  | allauthBrowserV1AccountEmailPatchResponseError

export const getAllauthBrowserV1AccountEmailPatchUrl = () => {
  return `/api/v2/allauth/browser/v1/account/email`
}

export const allauthBrowserV1AccountEmailPatch = async (
  markPrimaryEmailBody: MarkPrimaryEmailBody,
  options?: RequestInit,
): Promise<allauthBrowserV1AccountEmailPatchResponse> => {
  return fetchAllauth<allauthBrowserV1AccountEmailPatchResponse>(getAllauthBrowserV1AccountEmailPatchUrl(), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(markPrimaryEmailBody),
  })
}

export const getAllauthBrowserV1AccountEmailPatchMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AccountEmailPatch>>,
    TError,
    { data: MarkPrimaryEmailBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<
  Awaited<ReturnType<typeof allauthBrowserV1AccountEmailPatch>>,
  TError,
  { data: MarkPrimaryEmailBody },
  TContext
> => {
  const mutationKey = ['allauthBrowserV1AccountEmailPatch']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allauthBrowserV1AccountEmailPatch>>,
    { data: MarkPrimaryEmailBody }
  > = (props) => {
    const { data } = props ?? {}

    return allauthBrowserV1AccountEmailPatch(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthBrowserV1AccountEmailPatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthBrowserV1AccountEmailPatch>>
>
export type AllauthBrowserV1AccountEmailPatchMutationBody = MarkPrimaryEmailBody
export type AllauthBrowserV1AccountEmailPatchMutationError = ErrorResponse

/**
 * @summary Change primary email address
 */
export const useAllauthBrowserV1AccountEmailPatch = <TError = ErrorResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AccountEmailPatch>>,
    TError,
    { data: MarkPrimaryEmailBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthBrowserV1AccountEmailPatchMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Used to remove an email address.

 * @summary Remove an email address
 */
export type allauthBrowserV1AccountEmailDeleteResponse200 = {
  data: EmailAddressesResponse
  status: 200
}

export type allauthBrowserV1AccountEmailDeleteResponse400 = {
  data: ErrorResponse
  status: 400
}

export type allauthBrowserV1AccountEmailDeleteResponseSuccess = allauthBrowserV1AccountEmailDeleteResponse200 & {
  headers: Headers
}
export type allauthBrowserV1AccountEmailDeleteResponseError = allauthBrowserV1AccountEmailDeleteResponse400 & {
  headers: Headers
}

export type allauthBrowserV1AccountEmailDeleteResponse =
  | allauthBrowserV1AccountEmailDeleteResponseSuccess
  | allauthBrowserV1AccountEmailDeleteResponseError

export const getAllauthBrowserV1AccountEmailDeleteUrl = () => {
  return `/api/v2/allauth/browser/v1/account/email`
}

export const allauthBrowserV1AccountEmailDelete = async (
  emailBody: EmailBody,
  options?: RequestInit,
): Promise<allauthBrowserV1AccountEmailDeleteResponse> => {
  return fetchAllauth<allauthBrowserV1AccountEmailDeleteResponse>(getAllauthBrowserV1AccountEmailDeleteUrl(), {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(emailBody),
  })
}

export const getAllauthBrowserV1AccountEmailDeleteMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AccountEmailDelete>>,
    TError,
    { data: EmailBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<
  Awaited<ReturnType<typeof allauthBrowserV1AccountEmailDelete>>,
  TError,
  { data: EmailBody },
  TContext
> => {
  const mutationKey = ['allauthBrowserV1AccountEmailDelete']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allauthBrowserV1AccountEmailDelete>>,
    { data: EmailBody }
  > = (props) => {
    const { data } = props ?? {}

    return allauthBrowserV1AccountEmailDelete(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthBrowserV1AccountEmailDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthBrowserV1AccountEmailDelete>>
>
export type AllauthBrowserV1AccountEmailDeleteMutationBody = EmailBody
export type AllauthBrowserV1AccountEmailDeleteMutationError = ErrorResponse

/**
 * @summary Remove an email address
 */
export const useAllauthBrowserV1AccountEmailDelete = <TError = ErrorResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AccountEmailDelete>>,
    TError,
    { data: EmailBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthBrowserV1AccountEmailDeleteMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Retrieves the list of email addresses of the account.

 * @summary List email addresses
 */
export type allauthAppV1AccountEmailGetResponse200 = {
  data: EmailAddressesResponse
  status: 200
}

export type allauthAppV1AccountEmailGetResponse401 = {
  data: AuthenticationResponse
  status: 401
}

export type allauthAppV1AccountEmailGetResponseSuccess = allauthAppV1AccountEmailGetResponse200 & {
  headers: Headers
}
export type allauthAppV1AccountEmailGetResponseError = allauthAppV1AccountEmailGetResponse401 & {
  headers: Headers
}

export type allauthAppV1AccountEmailGetResponse =
  | allauthAppV1AccountEmailGetResponseSuccess
  | allauthAppV1AccountEmailGetResponseError

export const getAllauthAppV1AccountEmailGetUrl = () => {
  return `/api/v2/allauth/app/v1/account/email`
}

export const allauthAppV1AccountEmailGet = async (
  options?: RequestInit,
): Promise<allauthAppV1AccountEmailGetResponse> => {
  return fetchAllauth<allauthAppV1AccountEmailGetResponse>(getAllauthAppV1AccountEmailGetUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getAllauthAppV1AccountEmailGetQueryKey = () => {
  return ['api', 'v2', 'allauth', 'app', 'v1', 'account', 'email'] as const
}

export const getAllauthAppV1AccountEmailGetQueryOptions = <
  TData = Awaited<ReturnType<typeof allauthAppV1AccountEmailGet>>,
  TError = AuthenticationResponse,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof allauthAppV1AccountEmailGet>>, TError, TData>
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAllauthAppV1AccountEmailGetQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof allauthAppV1AccountEmailGet>>> = ({ signal }) =>
    allauthAppV1AccountEmailGet({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof allauthAppV1AccountEmailGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type AllauthAppV1AccountEmailGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof allauthAppV1AccountEmailGet>>
>
export type AllauthAppV1AccountEmailGetQueryError = AuthenticationResponse

/**
 * @summary List email addresses
 */

export function useAllauthAppV1AccountEmailGet<
  TData = Awaited<ReturnType<typeof allauthAppV1AccountEmailGet>>,
  TError = AuthenticationResponse,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof allauthAppV1AccountEmailGet>>, TError, TData>
  request?: SecondParameter<typeof fetchAllauth>
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAllauthAppV1AccountEmailGetQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * The following functionality is available:

  - Adding a new email address for an already signed in user (`ACCOUNT_CHANGE_EMAIL = False`).
  - Change to a new email address for an already signed in user   (`ACCOUNT_CHANGE_EMAIL = True`).
  - Change to a new email address during the email verification process at signup (`ACCOUNT_EMAIL_VERIFICATION_SUPPORTS_CHANGE = True`).

In all cases, an email verification mail will be sent containing a link or code that needs to be verified.

 * @summary Add/Change email address

 */
export type allauthAppV1AccountEmailPostResponse200 = {
  data: EmailAddressesResponse
  status: 200
}

export type allauthAppV1AccountEmailPostResponse400 = {
  data: ErrorResponse
  status: 400
}

export type allauthAppV1AccountEmailPostResponse401 = {
  data: AuthenticationOrReauthenticationResponse
  status: 401
}

export type allauthAppV1AccountEmailPostResponse409 = {
  data: ConflictResponse
  status: 409
}

export type allauthAppV1AccountEmailPostResponseSuccess = allauthAppV1AccountEmailPostResponse200 & {
  headers: Headers
}
export type allauthAppV1AccountEmailPostResponseError = (
  | allauthAppV1AccountEmailPostResponse400
  | allauthAppV1AccountEmailPostResponse401
  | allauthAppV1AccountEmailPostResponse409
) & {
  headers: Headers
}

export type allauthAppV1AccountEmailPostResponse =
  | allauthAppV1AccountEmailPostResponseSuccess
  | allauthAppV1AccountEmailPostResponseError

export const getAllauthAppV1AccountEmailPostUrl = () => {
  return `/api/v2/allauth/app/v1/account/email`
}

export const allauthAppV1AccountEmailPost = async (
  emailBody: EmailBody,
  options?: RequestInit,
): Promise<allauthAppV1AccountEmailPostResponse> => {
  return fetchAllauth<allauthAppV1AccountEmailPostResponse>(getAllauthAppV1AccountEmailPostUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(emailBody),
  })
}

export const getAllauthAppV1AccountEmailPostMutationOptions = <
  TError = ErrorResponse | AuthenticationOrReauthenticationResponse | ConflictResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1AccountEmailPost>>,
    TError,
    { data: EmailBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<
  Awaited<ReturnType<typeof allauthAppV1AccountEmailPost>>,
  TError,
  { data: EmailBody },
  TContext
> => {
  const mutationKey = ['allauthAppV1AccountEmailPost']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof allauthAppV1AccountEmailPost>>, { data: EmailBody }> = (
    props,
  ) => {
    const { data } = props ?? {}

    return allauthAppV1AccountEmailPost(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthAppV1AccountEmailPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthAppV1AccountEmailPost>>
>
export type AllauthAppV1AccountEmailPostMutationBody = EmailBody
export type AllauthAppV1AccountEmailPostMutationError =
  | ErrorResponse
  | AuthenticationOrReauthenticationResponse
  | ConflictResponse

/**
 * @summary Add/Change email address

 */
export const useAllauthAppV1AccountEmailPost = <
  TError = ErrorResponse | AuthenticationOrReauthenticationResponse | ConflictResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1AccountEmailPost>>,
    TError,
    { data: EmailBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthAppV1AccountEmailPostMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Requests for (another) email verification email to be sent. Note that
sending emails is rate limited, so when you send too many requests the
email will not be sent.

 * @summary Request email verification
 */
export type allauthAppV1AccountEmailPutResponse200 = {
  data: StatusOKResponse
  status: 200
}

export type allauthAppV1AccountEmailPutResponse400 = {
  data: ErrorResponse
  status: 400
}

export type allauthAppV1AccountEmailPutResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type allauthAppV1AccountEmailPutResponseSuccess = allauthAppV1AccountEmailPutResponse200 & {
  headers: Headers
}
export type allauthAppV1AccountEmailPutResponseError = (
  | allauthAppV1AccountEmailPutResponse400
  | allauthAppV1AccountEmailPutResponse403
) & {
  headers: Headers
}

export type allauthAppV1AccountEmailPutResponse =
  | allauthAppV1AccountEmailPutResponseSuccess
  | allauthAppV1AccountEmailPutResponseError

export const getAllauthAppV1AccountEmailPutUrl = () => {
  return `/api/v2/allauth/app/v1/account/email`
}

export const allauthAppV1AccountEmailPut = async (
  emailBody: EmailBody,
  options?: RequestInit,
): Promise<allauthAppV1AccountEmailPutResponse> => {
  return fetchAllauth<allauthAppV1AccountEmailPutResponse>(getAllauthAppV1AccountEmailPutUrl(), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(emailBody),
  })
}

export const getAllauthAppV1AccountEmailPutMutationOptions = <
  TError = ErrorResponse | ForbiddenResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1AccountEmailPut>>,
    TError,
    { data: EmailBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<
  Awaited<ReturnType<typeof allauthAppV1AccountEmailPut>>,
  TError,
  { data: EmailBody },
  TContext
> => {
  const mutationKey = ['allauthAppV1AccountEmailPut']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof allauthAppV1AccountEmailPut>>, { data: EmailBody }> = (
    props,
  ) => {
    const { data } = props ?? {}

    return allauthAppV1AccountEmailPut(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthAppV1AccountEmailPutMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthAppV1AccountEmailPut>>
>
export type AllauthAppV1AccountEmailPutMutationBody = EmailBody
export type AllauthAppV1AccountEmailPutMutationError = ErrorResponse | ForbiddenResponse

/**
 * @summary Request email verification
 */
export const useAllauthAppV1AccountEmailPut = <
  TError = ErrorResponse | ForbiddenResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1AccountEmailPut>>,
    TError,
    { data: EmailBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthAppV1AccountEmailPutMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Used to change primary email address to a different one. Note that only verified email addresses
can be marked as primary.

 * @summary Change primary email address
 */
export type allauthAppV1AccountEmailPatchResponse200 = {
  data: EmailAddressesResponse
  status: 200
}

export type allauthAppV1AccountEmailPatchResponse400 = {
  data: ErrorResponse
  status: 400
}

export type allauthAppV1AccountEmailPatchResponseSuccess = allauthAppV1AccountEmailPatchResponse200 & {
  headers: Headers
}
export type allauthAppV1AccountEmailPatchResponseError = allauthAppV1AccountEmailPatchResponse400 & {
  headers: Headers
}

export type allauthAppV1AccountEmailPatchResponse =
  | allauthAppV1AccountEmailPatchResponseSuccess
  | allauthAppV1AccountEmailPatchResponseError

export const getAllauthAppV1AccountEmailPatchUrl = () => {
  return `/api/v2/allauth/app/v1/account/email`
}

export const allauthAppV1AccountEmailPatch = async (
  markPrimaryEmailBody: MarkPrimaryEmailBody,
  options?: RequestInit,
): Promise<allauthAppV1AccountEmailPatchResponse> => {
  return fetchAllauth<allauthAppV1AccountEmailPatchResponse>(getAllauthAppV1AccountEmailPatchUrl(), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(markPrimaryEmailBody),
  })
}

export const getAllauthAppV1AccountEmailPatchMutationOptions = <TError = ErrorResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1AccountEmailPatch>>,
    TError,
    { data: MarkPrimaryEmailBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<
  Awaited<ReturnType<typeof allauthAppV1AccountEmailPatch>>,
  TError,
  { data: MarkPrimaryEmailBody },
  TContext
> => {
  const mutationKey = ['allauthAppV1AccountEmailPatch']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allauthAppV1AccountEmailPatch>>,
    { data: MarkPrimaryEmailBody }
  > = (props) => {
    const { data } = props ?? {}

    return allauthAppV1AccountEmailPatch(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthAppV1AccountEmailPatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthAppV1AccountEmailPatch>>
>
export type AllauthAppV1AccountEmailPatchMutationBody = MarkPrimaryEmailBody
export type AllauthAppV1AccountEmailPatchMutationError = ErrorResponse

/**
 * @summary Change primary email address
 */
export const useAllauthAppV1AccountEmailPatch = <TError = ErrorResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1AccountEmailPatch>>,
    TError,
    { data: MarkPrimaryEmailBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthAppV1AccountEmailPatchMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Used to remove an email address.

 * @summary Remove an email address
 */
export type allauthAppV1AccountEmailDeleteResponse200 = {
  data: EmailAddressesResponse
  status: 200
}

export type allauthAppV1AccountEmailDeleteResponse400 = {
  data: ErrorResponse
  status: 400
}

export type allauthAppV1AccountEmailDeleteResponseSuccess = allauthAppV1AccountEmailDeleteResponse200 & {
  headers: Headers
}
export type allauthAppV1AccountEmailDeleteResponseError = allauthAppV1AccountEmailDeleteResponse400 & {
  headers: Headers
}

export type allauthAppV1AccountEmailDeleteResponse =
  | allauthAppV1AccountEmailDeleteResponseSuccess
  | allauthAppV1AccountEmailDeleteResponseError

export const getAllauthAppV1AccountEmailDeleteUrl = () => {
  return `/api/v2/allauth/app/v1/account/email`
}

export const allauthAppV1AccountEmailDelete = async (
  emailBody: EmailBody,
  options?: RequestInit,
): Promise<allauthAppV1AccountEmailDeleteResponse> => {
  return fetchAllauth<allauthAppV1AccountEmailDeleteResponse>(getAllauthAppV1AccountEmailDeleteUrl(), {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(emailBody),
  })
}

export const getAllauthAppV1AccountEmailDeleteMutationOptions = <TError = ErrorResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1AccountEmailDelete>>,
    TError,
    { data: EmailBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<
  Awaited<ReturnType<typeof allauthAppV1AccountEmailDelete>>,
  TError,
  { data: EmailBody },
  TContext
> => {
  const mutationKey = ['allauthAppV1AccountEmailDelete']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allauthAppV1AccountEmailDelete>>,
    { data: EmailBody }
  > = (props) => {
    const { data } = props ?? {}

    return allauthAppV1AccountEmailDelete(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthAppV1AccountEmailDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthAppV1AccountEmailDelete>>
>
export type AllauthAppV1AccountEmailDeleteMutationBody = EmailBody
export type AllauthAppV1AccountEmailDeleteMutationError = ErrorResponse

/**
 * @summary Remove an email address
 */
export const useAllauthAppV1AccountEmailDelete = <TError = ErrorResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1AccountEmailDelete>>,
    TError,
    { data: EmailBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthAppV1AccountEmailDeleteMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Retrieves the phone number of the account, if any. Note that while the
endpoint returns a list of phone numbers, at most one entry is returned.

 * @summary Get the phone number
 */
export type allauthBrowserV1AccountPhoneGetResponse200 = {
  data: PhoneNumbersResponse
  status: 200
}

export type allauthBrowserV1AccountPhoneGetResponse401 = {
  data: AuthenticationResponse
  status: 401
}

export type allauthBrowserV1AccountPhoneGetResponseSuccess = allauthBrowserV1AccountPhoneGetResponse200 & {
  headers: Headers
}
export type allauthBrowserV1AccountPhoneGetResponseError = allauthBrowserV1AccountPhoneGetResponse401 & {
  headers: Headers
}

export type allauthBrowserV1AccountPhoneGetResponse =
  | allauthBrowserV1AccountPhoneGetResponseSuccess
  | allauthBrowserV1AccountPhoneGetResponseError

export const getAllauthBrowserV1AccountPhoneGetUrl = () => {
  return `/api/v2/allauth/browser/v1/account/phone`
}

export const allauthBrowserV1AccountPhoneGet = async (
  options?: RequestInit,
): Promise<allauthBrowserV1AccountPhoneGetResponse> => {
  return fetchAllauth<allauthBrowserV1AccountPhoneGetResponse>(getAllauthBrowserV1AccountPhoneGetUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getAllauthBrowserV1AccountPhoneGetQueryKey = () => {
  return ['api', 'v2', 'allauth', 'browser', 'v1', 'account', 'phone'] as const
}

export const getAllauthBrowserV1AccountPhoneGetQueryOptions = <
  TData = Awaited<ReturnType<typeof allauthBrowserV1AccountPhoneGet>>,
  TError = AuthenticationResponse,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof allauthBrowserV1AccountPhoneGet>>, TError, TData>
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAllauthBrowserV1AccountPhoneGetQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof allauthBrowserV1AccountPhoneGet>>> = ({ signal }) =>
    allauthBrowserV1AccountPhoneGet({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AccountPhoneGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type AllauthBrowserV1AccountPhoneGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof allauthBrowserV1AccountPhoneGet>>
>
export type AllauthBrowserV1AccountPhoneGetQueryError = AuthenticationResponse

/**
 * @summary Get the phone number
 */

export function useAllauthBrowserV1AccountPhoneGet<
  TData = Awaited<ReturnType<typeof allauthBrowserV1AccountPhoneGet>>,
  TError = AuthenticationResponse,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof allauthBrowserV1AccountPhoneGet>>, TError, TData>
  request?: SecondParameter<typeof fetchAllauth>
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAllauthBrowserV1AccountPhoneGetQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * The following functionality is available:

- Initiate the phone number change process for signed in users.
- Change to a new phone number during the phone number verification
  process at signup for unauthenticated users. Note that this requires:
  `ACCOUNT_PHONE_VERIFICATION_SUPPORTS_CHANGE = True`.

In both cases, after posting a new phone number, proceed with the phone
verification endpoint to confirm the change of the phone number by
posting the verification code.

 * @summary Change the phone number

 */
export type allauthBrowserV1AccountPhonePostResponse202 = {
  data: PhoneNumberChangeResponse
  status: 202
}

export type allauthBrowserV1AccountPhonePostResponse400 = {
  data: ErrorResponse
  status: 400
}

export type allauthBrowserV1AccountPhonePostResponse401 = {
  data: AuthenticationOrReauthenticationResponse
  status: 401
}

export type allauthBrowserV1AccountPhonePostResponse409 = {
  data: ConflictResponse
  status: 409
}

export type allauthBrowserV1AccountPhonePostResponseSuccess = allauthBrowserV1AccountPhonePostResponse202 & {
  headers: Headers
}
export type allauthBrowserV1AccountPhonePostResponseError = (
  | allauthBrowserV1AccountPhonePostResponse400
  | allauthBrowserV1AccountPhonePostResponse401
  | allauthBrowserV1AccountPhonePostResponse409
) & {
  headers: Headers
}

export type allauthBrowserV1AccountPhonePostResponse =
  | allauthBrowserV1AccountPhonePostResponseSuccess
  | allauthBrowserV1AccountPhonePostResponseError

export const getAllauthBrowserV1AccountPhonePostUrl = () => {
  return `/api/v2/allauth/browser/v1/account/phone`
}

export const allauthBrowserV1AccountPhonePost = async (
  phoneBody: PhoneBody,
  options?: RequestInit,
): Promise<allauthBrowserV1AccountPhonePostResponse> => {
  return fetchAllauth<allauthBrowserV1AccountPhonePostResponse>(getAllauthBrowserV1AccountPhonePostUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(phoneBody),
  })
}

export const getAllauthBrowserV1AccountPhonePostMutationOptions = <
  TError = ErrorResponse | AuthenticationOrReauthenticationResponse | ConflictResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AccountPhonePost>>,
    TError,
    { data: PhoneBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<
  Awaited<ReturnType<typeof allauthBrowserV1AccountPhonePost>>,
  TError,
  { data: PhoneBody },
  TContext
> => {
  const mutationKey = ['allauthBrowserV1AccountPhonePost']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allauthBrowserV1AccountPhonePost>>,
    { data: PhoneBody }
  > = (props) => {
    const { data } = props ?? {}

    return allauthBrowserV1AccountPhonePost(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthBrowserV1AccountPhonePostMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthBrowserV1AccountPhonePost>>
>
export type AllauthBrowserV1AccountPhonePostMutationBody = PhoneBody
export type AllauthBrowserV1AccountPhonePostMutationError =
  | ErrorResponse
  | AuthenticationOrReauthenticationResponse
  | ConflictResponse

/**
 * @summary Change the phone number

 */
export const useAllauthBrowserV1AccountPhonePost = <
  TError = ErrorResponse | AuthenticationOrReauthenticationResponse | ConflictResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AccountPhonePost>>,
    TError,
    { data: PhoneBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthBrowserV1AccountPhonePostMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Retrieves the phone number of the account, if any. Note that while the
endpoint returns a list of phone numbers, at most one entry is returned.

 * @summary Get the phone number
 */
export type allauthAppV1AccountPhoneGetResponse200 = {
  data: PhoneNumbersResponse
  status: 200
}

export type allauthAppV1AccountPhoneGetResponse401 = {
  data: AuthenticationResponse
  status: 401
}

export type allauthAppV1AccountPhoneGetResponseSuccess = allauthAppV1AccountPhoneGetResponse200 & {
  headers: Headers
}
export type allauthAppV1AccountPhoneGetResponseError = allauthAppV1AccountPhoneGetResponse401 & {
  headers: Headers
}

export type allauthAppV1AccountPhoneGetResponse =
  | allauthAppV1AccountPhoneGetResponseSuccess
  | allauthAppV1AccountPhoneGetResponseError

export const getAllauthAppV1AccountPhoneGetUrl = () => {
  return `/api/v2/allauth/app/v1/account/phone`
}

export const allauthAppV1AccountPhoneGet = async (
  options?: RequestInit,
): Promise<allauthAppV1AccountPhoneGetResponse> => {
  return fetchAllauth<allauthAppV1AccountPhoneGetResponse>(getAllauthAppV1AccountPhoneGetUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getAllauthAppV1AccountPhoneGetQueryKey = () => {
  return ['api', 'v2', 'allauth', 'app', 'v1', 'account', 'phone'] as const
}

export const getAllauthAppV1AccountPhoneGetQueryOptions = <
  TData = Awaited<ReturnType<typeof allauthAppV1AccountPhoneGet>>,
  TError = AuthenticationResponse,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof allauthAppV1AccountPhoneGet>>, TError, TData>
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAllauthAppV1AccountPhoneGetQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof allauthAppV1AccountPhoneGet>>> = ({ signal }) =>
    allauthAppV1AccountPhoneGet({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof allauthAppV1AccountPhoneGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type AllauthAppV1AccountPhoneGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof allauthAppV1AccountPhoneGet>>
>
export type AllauthAppV1AccountPhoneGetQueryError = AuthenticationResponse

/**
 * @summary Get the phone number
 */

export function useAllauthAppV1AccountPhoneGet<
  TData = Awaited<ReturnType<typeof allauthAppV1AccountPhoneGet>>,
  TError = AuthenticationResponse,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof allauthAppV1AccountPhoneGet>>, TError, TData>
  request?: SecondParameter<typeof fetchAllauth>
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAllauthAppV1AccountPhoneGetQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * The following functionality is available:

- Initiate the phone number change process for signed in users.
- Change to a new phone number during the phone number verification
  process at signup for unauthenticated users. Note that this requires:
  `ACCOUNT_PHONE_VERIFICATION_SUPPORTS_CHANGE = True`.

In both cases, after posting a new phone number, proceed with the phone
verification endpoint to confirm the change of the phone number by
posting the verification code.

 * @summary Change the phone number

 */
export type allauthAppV1AccountPhonePostResponse202 = {
  data: PhoneNumberChangeResponse
  status: 202
}

export type allauthAppV1AccountPhonePostResponse400 = {
  data: ErrorResponse
  status: 400
}

export type allauthAppV1AccountPhonePostResponse401 = {
  data: AuthenticationOrReauthenticationResponse
  status: 401
}

export type allauthAppV1AccountPhonePostResponse409 = {
  data: ConflictResponse
  status: 409
}

export type allauthAppV1AccountPhonePostResponseSuccess = allauthAppV1AccountPhonePostResponse202 & {
  headers: Headers
}
export type allauthAppV1AccountPhonePostResponseError = (
  | allauthAppV1AccountPhonePostResponse400
  | allauthAppV1AccountPhonePostResponse401
  | allauthAppV1AccountPhonePostResponse409
) & {
  headers: Headers
}

export type allauthAppV1AccountPhonePostResponse =
  | allauthAppV1AccountPhonePostResponseSuccess
  | allauthAppV1AccountPhonePostResponseError

export const getAllauthAppV1AccountPhonePostUrl = () => {
  return `/api/v2/allauth/app/v1/account/phone`
}

export const allauthAppV1AccountPhonePost = async (
  phoneBody: PhoneBody,
  options?: RequestInit,
): Promise<allauthAppV1AccountPhonePostResponse> => {
  return fetchAllauth<allauthAppV1AccountPhonePostResponse>(getAllauthAppV1AccountPhonePostUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(phoneBody),
  })
}

export const getAllauthAppV1AccountPhonePostMutationOptions = <
  TError = ErrorResponse | AuthenticationOrReauthenticationResponse | ConflictResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1AccountPhonePost>>,
    TError,
    { data: PhoneBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<
  Awaited<ReturnType<typeof allauthAppV1AccountPhonePost>>,
  TError,
  { data: PhoneBody },
  TContext
> => {
  const mutationKey = ['allauthAppV1AccountPhonePost']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof allauthAppV1AccountPhonePost>>, { data: PhoneBody }> = (
    props,
  ) => {
    const { data } = props ?? {}

    return allauthAppV1AccountPhonePost(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthAppV1AccountPhonePostMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthAppV1AccountPhonePost>>
>
export type AllauthAppV1AccountPhonePostMutationBody = PhoneBody
export type AllauthAppV1AccountPhonePostMutationError =
  | ErrorResponse
  | AuthenticationOrReauthenticationResponse
  | ConflictResponse

/**
 * @summary Change the phone number

 */
export const useAllauthAppV1AccountPhonePost = <
  TError = ErrorResponse | AuthenticationOrReauthenticationResponse | ConflictResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1AccountPhonePost>>,
    TError,
    { data: PhoneBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthAppV1AccountPhonePostMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * @summary List authenticators
 */
export type allauthBrowserV1AccountAuthenticatorsGetResponse200 = {
  data: AuthenticatorsResponse
  status: 200
}

export type allauthBrowserV1AccountAuthenticatorsGetResponse401 = {
  data: AuthenticationResponse
  status: 401
}

export type allauthBrowserV1AccountAuthenticatorsGetResponse410 = {
  data: SessionGoneResponse
  status: 410
}

export type allauthBrowserV1AccountAuthenticatorsGetResponseSuccess =
  allauthBrowserV1AccountAuthenticatorsGetResponse200 & {
    headers: Headers
  }
export type allauthBrowserV1AccountAuthenticatorsGetResponseError = (
  | allauthBrowserV1AccountAuthenticatorsGetResponse401
  | allauthBrowserV1AccountAuthenticatorsGetResponse410
) & {
  headers: Headers
}

export type allauthBrowserV1AccountAuthenticatorsGetResponse =
  | allauthBrowserV1AccountAuthenticatorsGetResponseSuccess
  | allauthBrowserV1AccountAuthenticatorsGetResponseError

export const getAllauthBrowserV1AccountAuthenticatorsGetUrl = () => {
  return `/api/v2/allauth/browser/v1/account/authenticators`
}

export const allauthBrowserV1AccountAuthenticatorsGet = async (
  options?: RequestInit,
): Promise<allauthBrowserV1AccountAuthenticatorsGetResponse> => {
  return fetchAllauth<allauthBrowserV1AccountAuthenticatorsGetResponse>(
    getAllauthBrowserV1AccountAuthenticatorsGetUrl(),
    {
      ...options,
      method: 'GET',
    },
  )
}

export const getAllauthBrowserV1AccountAuthenticatorsGetQueryKey = () => {
  return ['api', 'v2', 'allauth', 'browser', 'v1', 'account', 'authenticators'] as const
}

export const getAllauthBrowserV1AccountAuthenticatorsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof allauthBrowserV1AccountAuthenticatorsGet>>,
  TError = AuthenticationResponse | SessionGoneResponse,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof allauthBrowserV1AccountAuthenticatorsGet>>, TError, TData>
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAllauthBrowserV1AccountAuthenticatorsGetQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof allauthBrowserV1AccountAuthenticatorsGet>>> = ({ signal }) =>
    allauthBrowserV1AccountAuthenticatorsGet({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AccountAuthenticatorsGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type AllauthBrowserV1AccountAuthenticatorsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof allauthBrowserV1AccountAuthenticatorsGet>>
>
export type AllauthBrowserV1AccountAuthenticatorsGetQueryError = AuthenticationResponse | SessionGoneResponse

/**
 * @summary List authenticators
 */

export function useAllauthBrowserV1AccountAuthenticatorsGet<
  TData = Awaited<ReturnType<typeof allauthBrowserV1AccountAuthenticatorsGet>>,
  TError = AuthenticationResponse | SessionGoneResponse,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof allauthBrowserV1AccountAuthenticatorsGet>>, TError, TData>
  request?: SecondParameter<typeof fetchAllauth>
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAllauthBrowserV1AccountAuthenticatorsGetQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary List authenticators
 */
export type allauthAppV1AccountAuthenticatorsGetResponse200 = {
  data: AuthenticatorsResponse
  status: 200
}

export type allauthAppV1AccountAuthenticatorsGetResponse401 = {
  data: AuthenticationResponse
  status: 401
}

export type allauthAppV1AccountAuthenticatorsGetResponse410 = {
  data: SessionGoneResponse
  status: 410
}

export type allauthAppV1AccountAuthenticatorsGetResponseSuccess = allauthAppV1AccountAuthenticatorsGetResponse200 & {
  headers: Headers
}
export type allauthAppV1AccountAuthenticatorsGetResponseError = (
  | allauthAppV1AccountAuthenticatorsGetResponse401
  | allauthAppV1AccountAuthenticatorsGetResponse410
) & {
  headers: Headers
}

export type allauthAppV1AccountAuthenticatorsGetResponse =
  | allauthAppV1AccountAuthenticatorsGetResponseSuccess
  | allauthAppV1AccountAuthenticatorsGetResponseError

export const getAllauthAppV1AccountAuthenticatorsGetUrl = () => {
  return `/api/v2/allauth/app/v1/account/authenticators`
}

export const allauthAppV1AccountAuthenticatorsGet = async (
  options?: RequestInit,
): Promise<allauthAppV1AccountAuthenticatorsGetResponse> => {
  return fetchAllauth<allauthAppV1AccountAuthenticatorsGetResponse>(getAllauthAppV1AccountAuthenticatorsGetUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getAllauthAppV1AccountAuthenticatorsGetQueryKey = () => {
  return ['api', 'v2', 'allauth', 'app', 'v1', 'account', 'authenticators'] as const
}

export const getAllauthAppV1AccountAuthenticatorsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof allauthAppV1AccountAuthenticatorsGet>>,
  TError = AuthenticationResponse | SessionGoneResponse,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof allauthAppV1AccountAuthenticatorsGet>>, TError, TData>
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAllauthAppV1AccountAuthenticatorsGetQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof allauthAppV1AccountAuthenticatorsGet>>> = ({ signal }) =>
    allauthAppV1AccountAuthenticatorsGet({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof allauthAppV1AccountAuthenticatorsGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type AllauthAppV1AccountAuthenticatorsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof allauthAppV1AccountAuthenticatorsGet>>
>
export type AllauthAppV1AccountAuthenticatorsGetQueryError = AuthenticationResponse | SessionGoneResponse

/**
 * @summary List authenticators
 */

export function useAllauthAppV1AccountAuthenticatorsGet<
  TData = Awaited<ReturnType<typeof allauthAppV1AccountAuthenticatorsGet>>,
  TError = AuthenticationResponse | SessionGoneResponse,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof allauthAppV1AccountAuthenticatorsGet>>, TError, TData>
  request?: SecondParameter<typeof fetchAllauth>
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAllauthAppV1AccountAuthenticatorsGetQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * Retrieve the information about the current TOTP authenticator, if any.

 * @summary TOTP authenticator status
 */
export type allauthBrowserV1AccountAuthenticatorsTotpGetResponse200 = {
  data: TOTPAuthenticatorResponse
  status: 200
}

export type allauthBrowserV1AccountAuthenticatorsTotpGetResponse404 = {
  data: TOTPAuthenticatorNotFoundResponse
  status: 404
}

export type allauthBrowserV1AccountAuthenticatorsTotpGetResponse409 = {
  data: AddAuthenticatorConflictResponse
  status: 409
}

export type allauthBrowserV1AccountAuthenticatorsTotpGetResponseSuccess =
  allauthBrowserV1AccountAuthenticatorsTotpGetResponse200 & {
    headers: Headers
  }
export type allauthBrowserV1AccountAuthenticatorsTotpGetResponseError = (
  | allauthBrowserV1AccountAuthenticatorsTotpGetResponse404
  | allauthBrowserV1AccountAuthenticatorsTotpGetResponse409
) & {
  headers: Headers
}

export type allauthBrowserV1AccountAuthenticatorsTotpGetResponse =
  | allauthBrowserV1AccountAuthenticatorsTotpGetResponseSuccess
  | allauthBrowserV1AccountAuthenticatorsTotpGetResponseError

export const getAllauthBrowserV1AccountAuthenticatorsTotpGetUrl = () => {
  return `/api/v2/allauth/browser/v1/account/authenticators/totp`
}

export const allauthBrowserV1AccountAuthenticatorsTotpGet = async (
  options?: RequestInit,
): Promise<allauthBrowserV1AccountAuthenticatorsTotpGetResponse> => {
  return fetchAllauth<allauthBrowserV1AccountAuthenticatorsTotpGetResponse>(
    getAllauthBrowserV1AccountAuthenticatorsTotpGetUrl(),
    {
      ...options,
      method: 'GET',
    },
  )
}

export const getAllauthBrowserV1AccountAuthenticatorsTotpGetQueryKey = () => {
  return ['api', 'v2', 'allauth', 'browser', 'v1', 'account', 'authenticators', 'totp'] as const
}

export const getAllauthBrowserV1AccountAuthenticatorsTotpGetQueryOptions = <
  TData = Awaited<ReturnType<typeof allauthBrowserV1AccountAuthenticatorsTotpGet>>,
  TError = TOTPAuthenticatorNotFoundResponse | AddAuthenticatorConflictResponse,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof allauthBrowserV1AccountAuthenticatorsTotpGet>>, TError, TData>
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAllauthBrowserV1AccountAuthenticatorsTotpGetQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof allauthBrowserV1AccountAuthenticatorsTotpGet>>> = ({
    signal,
  }) => allauthBrowserV1AccountAuthenticatorsTotpGet({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AccountAuthenticatorsTotpGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type AllauthBrowserV1AccountAuthenticatorsTotpGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof allauthBrowserV1AccountAuthenticatorsTotpGet>>
>
export type AllauthBrowserV1AccountAuthenticatorsTotpGetQueryError =
  | TOTPAuthenticatorNotFoundResponse
  | AddAuthenticatorConflictResponse

/**
 * @summary TOTP authenticator status
 */

export function useAllauthBrowserV1AccountAuthenticatorsTotpGet<
  TData = Awaited<ReturnType<typeof allauthBrowserV1AccountAuthenticatorsTotpGet>>,
  TError = TOTPAuthenticatorNotFoundResponse | AddAuthenticatorConflictResponse,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof allauthBrowserV1AccountAuthenticatorsTotpGet>>, TError, TData>
  request?: SecondParameter<typeof fetchAllauth>
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAllauthBrowserV1AccountAuthenticatorsTotpGetQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * The code should be provided from the consuming TOTP authenticator
application which was generated using the TOTP authenticator secret
retrieved from the TOTP authenticator status endpoint.

 * @summary Activate TOTP
 */
export type allauthBrowserV1AccountAuthenticatorsTotpPostResponse200 = {
  data: TOTPAuthenticatorResponse
  status: 200
}

export type allauthBrowserV1AccountAuthenticatorsTotpPostResponse400 = {
  data: ErrorResponse
  status: 400
}

export type allauthBrowserV1AccountAuthenticatorsTotpPostResponse401 = {
  data: ReauthenticationRequiredResponse
  status: 401
}

export type allauthBrowserV1AccountAuthenticatorsTotpPostResponse409 = {
  data: AddAuthenticatorConflictResponse
  status: 409
}

export type allauthBrowserV1AccountAuthenticatorsTotpPostResponseSuccess =
  allauthBrowserV1AccountAuthenticatorsTotpPostResponse200 & {
    headers: Headers
  }
export type allauthBrowserV1AccountAuthenticatorsTotpPostResponseError = (
  | allauthBrowserV1AccountAuthenticatorsTotpPostResponse400
  | allauthBrowserV1AccountAuthenticatorsTotpPostResponse401
  | allauthBrowserV1AccountAuthenticatorsTotpPostResponse409
) & {
  headers: Headers
}

export type allauthBrowserV1AccountAuthenticatorsTotpPostResponse =
  | allauthBrowserV1AccountAuthenticatorsTotpPostResponseSuccess
  | allauthBrowserV1AccountAuthenticatorsTotpPostResponseError

export const getAllauthBrowserV1AccountAuthenticatorsTotpPostUrl = () => {
  return `/api/v2/allauth/browser/v1/account/authenticators/totp`
}

export const allauthBrowserV1AccountAuthenticatorsTotpPost = async (
  setupTOTPBody: SetupTOTPBody,
  options?: RequestInit,
): Promise<allauthBrowserV1AccountAuthenticatorsTotpPostResponse> => {
  return fetchAllauth<allauthBrowserV1AccountAuthenticatorsTotpPostResponse>(
    getAllauthBrowserV1AccountAuthenticatorsTotpPostUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(setupTOTPBody),
    },
  )
}

export const getAllauthBrowserV1AccountAuthenticatorsTotpPostMutationOptions = <
  TError = ErrorResponse | ReauthenticationRequiredResponse | AddAuthenticatorConflictResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AccountAuthenticatorsTotpPost>>,
    TError,
    { data: SetupTOTPBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<
  Awaited<ReturnType<typeof allauthBrowserV1AccountAuthenticatorsTotpPost>>,
  TError,
  { data: SetupTOTPBody },
  TContext
> => {
  const mutationKey = ['allauthBrowserV1AccountAuthenticatorsTotpPost']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allauthBrowserV1AccountAuthenticatorsTotpPost>>,
    { data: SetupTOTPBody }
  > = (props) => {
    const { data } = props ?? {}

    return allauthBrowserV1AccountAuthenticatorsTotpPost(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthBrowserV1AccountAuthenticatorsTotpPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthBrowserV1AccountAuthenticatorsTotpPost>>
>
export type AllauthBrowserV1AccountAuthenticatorsTotpPostMutationBody = SetupTOTPBody
export type AllauthBrowserV1AccountAuthenticatorsTotpPostMutationError =
  | ErrorResponse
  | ReauthenticationRequiredResponse
  | AddAuthenticatorConflictResponse

/**
 * @summary Activate TOTP
 */
export const useAllauthBrowserV1AccountAuthenticatorsTotpPost = <
  TError = ErrorResponse | ReauthenticationRequiredResponse | AddAuthenticatorConflictResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AccountAuthenticatorsTotpPost>>,
    TError,
    { data: SetupTOTPBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthBrowserV1AccountAuthenticatorsTotpPostMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Deactivates TOTP authentication. If the user authentication is not
sufficiently recent, a reauthentication flow (`401`) will is presented.

 * @summary Deactivate TOTP
 */
export type allauthBrowserV1AccountAuthenticatorsTotpDeleteResponse200 = {
  data: StatusOKResponse
  status: 200
}

export type allauthBrowserV1AccountAuthenticatorsTotpDeleteResponse401 = {
  data: ReauthenticationRequiredResponse
  status: 401
}

export type allauthBrowserV1AccountAuthenticatorsTotpDeleteResponseSuccess =
  allauthBrowserV1AccountAuthenticatorsTotpDeleteResponse200 & {
    headers: Headers
  }
export type allauthBrowserV1AccountAuthenticatorsTotpDeleteResponseError =
  allauthBrowserV1AccountAuthenticatorsTotpDeleteResponse401 & {
    headers: Headers
  }

export type allauthBrowserV1AccountAuthenticatorsTotpDeleteResponse =
  | allauthBrowserV1AccountAuthenticatorsTotpDeleteResponseSuccess
  | allauthBrowserV1AccountAuthenticatorsTotpDeleteResponseError

export const getAllauthBrowserV1AccountAuthenticatorsTotpDeleteUrl = () => {
  return `/api/v2/allauth/browser/v1/account/authenticators/totp`
}

export const allauthBrowserV1AccountAuthenticatorsTotpDelete = async (
  options?: RequestInit,
): Promise<allauthBrowserV1AccountAuthenticatorsTotpDeleteResponse> => {
  return fetchAllauth<allauthBrowserV1AccountAuthenticatorsTotpDeleteResponse>(
    getAllauthBrowserV1AccountAuthenticatorsTotpDeleteUrl(),
    {
      ...options,
      method: 'DELETE',
    },
  )
}

export const getAllauthBrowserV1AccountAuthenticatorsTotpDeleteMutationOptions = <
  TError = ReauthenticationRequiredResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AccountAuthenticatorsTotpDelete>>,
    TError,
    void,
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<
  Awaited<ReturnType<typeof allauthBrowserV1AccountAuthenticatorsTotpDelete>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['allauthBrowserV1AccountAuthenticatorsTotpDelete']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allauthBrowserV1AccountAuthenticatorsTotpDelete>>,
    void
  > = () => {
    return allauthBrowserV1AccountAuthenticatorsTotpDelete(requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthBrowserV1AccountAuthenticatorsTotpDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthBrowserV1AccountAuthenticatorsTotpDelete>>
>

export type AllauthBrowserV1AccountAuthenticatorsTotpDeleteMutationError = ReauthenticationRequiredResponse

/**
 * @summary Deactivate TOTP
 */
export const useAllauthBrowserV1AccountAuthenticatorsTotpDelete = <
  TError = ReauthenticationRequiredResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AccountAuthenticatorsTotpDelete>>,
    TError,
    void,
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthBrowserV1AccountAuthenticatorsTotpDeleteMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Retrieve the information about the current TOTP authenticator, if any.

 * @summary TOTP authenticator status
 */
export type allauthAppV1AccountAuthenticatorsTotpGetResponse200 = {
  data: TOTPAuthenticatorResponse
  status: 200
}

export type allauthAppV1AccountAuthenticatorsTotpGetResponse404 = {
  data: TOTPAuthenticatorNotFoundResponse
  status: 404
}

export type allauthAppV1AccountAuthenticatorsTotpGetResponse409 = {
  data: AddAuthenticatorConflictResponse
  status: 409
}

export type allauthAppV1AccountAuthenticatorsTotpGetResponseSuccess =
  allauthAppV1AccountAuthenticatorsTotpGetResponse200 & {
    headers: Headers
  }
export type allauthAppV1AccountAuthenticatorsTotpGetResponseError = (
  | allauthAppV1AccountAuthenticatorsTotpGetResponse404
  | allauthAppV1AccountAuthenticatorsTotpGetResponse409
) & {
  headers: Headers
}

export type allauthAppV1AccountAuthenticatorsTotpGetResponse =
  | allauthAppV1AccountAuthenticatorsTotpGetResponseSuccess
  | allauthAppV1AccountAuthenticatorsTotpGetResponseError

export const getAllauthAppV1AccountAuthenticatorsTotpGetUrl = () => {
  return `/api/v2/allauth/app/v1/account/authenticators/totp`
}

export const allauthAppV1AccountAuthenticatorsTotpGet = async (
  options?: RequestInit,
): Promise<allauthAppV1AccountAuthenticatorsTotpGetResponse> => {
  return fetchAllauth<allauthAppV1AccountAuthenticatorsTotpGetResponse>(
    getAllauthAppV1AccountAuthenticatorsTotpGetUrl(),
    {
      ...options,
      method: 'GET',
    },
  )
}

export const getAllauthAppV1AccountAuthenticatorsTotpGetQueryKey = () => {
  return ['api', 'v2', 'allauth', 'app', 'v1', 'account', 'authenticators', 'totp'] as const
}

export const getAllauthAppV1AccountAuthenticatorsTotpGetQueryOptions = <
  TData = Awaited<ReturnType<typeof allauthAppV1AccountAuthenticatorsTotpGet>>,
  TError = TOTPAuthenticatorNotFoundResponse | AddAuthenticatorConflictResponse,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof allauthAppV1AccountAuthenticatorsTotpGet>>, TError, TData>
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAllauthAppV1AccountAuthenticatorsTotpGetQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof allauthAppV1AccountAuthenticatorsTotpGet>>> = ({ signal }) =>
    allauthAppV1AccountAuthenticatorsTotpGet({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof allauthAppV1AccountAuthenticatorsTotpGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type AllauthAppV1AccountAuthenticatorsTotpGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof allauthAppV1AccountAuthenticatorsTotpGet>>
>
export type AllauthAppV1AccountAuthenticatorsTotpGetQueryError =
  | TOTPAuthenticatorNotFoundResponse
  | AddAuthenticatorConflictResponse

/**
 * @summary TOTP authenticator status
 */

export function useAllauthAppV1AccountAuthenticatorsTotpGet<
  TData = Awaited<ReturnType<typeof allauthAppV1AccountAuthenticatorsTotpGet>>,
  TError = TOTPAuthenticatorNotFoundResponse | AddAuthenticatorConflictResponse,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof allauthAppV1AccountAuthenticatorsTotpGet>>, TError, TData>
  request?: SecondParameter<typeof fetchAllauth>
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAllauthAppV1AccountAuthenticatorsTotpGetQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * The code should be provided from the consuming TOTP authenticator
application which was generated using the TOTP authenticator secret
retrieved from the TOTP authenticator status endpoint.

 * @summary Activate TOTP
 */
export type allauthAppV1AccountAuthenticatorsTotpPostResponse200 = {
  data: TOTPAuthenticatorResponse
  status: 200
}

export type allauthAppV1AccountAuthenticatorsTotpPostResponse400 = {
  data: ErrorResponse
  status: 400
}

export type allauthAppV1AccountAuthenticatorsTotpPostResponse401 = {
  data: ReauthenticationRequiredResponse
  status: 401
}

export type allauthAppV1AccountAuthenticatorsTotpPostResponse409 = {
  data: AddAuthenticatorConflictResponse
  status: 409
}

export type allauthAppV1AccountAuthenticatorsTotpPostResponseSuccess =
  allauthAppV1AccountAuthenticatorsTotpPostResponse200 & {
    headers: Headers
  }
export type allauthAppV1AccountAuthenticatorsTotpPostResponseError = (
  | allauthAppV1AccountAuthenticatorsTotpPostResponse400
  | allauthAppV1AccountAuthenticatorsTotpPostResponse401
  | allauthAppV1AccountAuthenticatorsTotpPostResponse409
) & {
  headers: Headers
}

export type allauthAppV1AccountAuthenticatorsTotpPostResponse =
  | allauthAppV1AccountAuthenticatorsTotpPostResponseSuccess
  | allauthAppV1AccountAuthenticatorsTotpPostResponseError

export const getAllauthAppV1AccountAuthenticatorsTotpPostUrl = () => {
  return `/api/v2/allauth/app/v1/account/authenticators/totp`
}

export const allauthAppV1AccountAuthenticatorsTotpPost = async (
  setupTOTPBody: SetupTOTPBody,
  options?: RequestInit,
): Promise<allauthAppV1AccountAuthenticatorsTotpPostResponse> => {
  return fetchAllauth<allauthAppV1AccountAuthenticatorsTotpPostResponse>(
    getAllauthAppV1AccountAuthenticatorsTotpPostUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(setupTOTPBody),
    },
  )
}

export const getAllauthAppV1AccountAuthenticatorsTotpPostMutationOptions = <
  TError = ErrorResponse | ReauthenticationRequiredResponse | AddAuthenticatorConflictResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1AccountAuthenticatorsTotpPost>>,
    TError,
    { data: SetupTOTPBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<
  Awaited<ReturnType<typeof allauthAppV1AccountAuthenticatorsTotpPost>>,
  TError,
  { data: SetupTOTPBody },
  TContext
> => {
  const mutationKey = ['allauthAppV1AccountAuthenticatorsTotpPost']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allauthAppV1AccountAuthenticatorsTotpPost>>,
    { data: SetupTOTPBody }
  > = (props) => {
    const { data } = props ?? {}

    return allauthAppV1AccountAuthenticatorsTotpPost(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthAppV1AccountAuthenticatorsTotpPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthAppV1AccountAuthenticatorsTotpPost>>
>
export type AllauthAppV1AccountAuthenticatorsTotpPostMutationBody = SetupTOTPBody
export type AllauthAppV1AccountAuthenticatorsTotpPostMutationError =
  | ErrorResponse
  | ReauthenticationRequiredResponse
  | AddAuthenticatorConflictResponse

/**
 * @summary Activate TOTP
 */
export const useAllauthAppV1AccountAuthenticatorsTotpPost = <
  TError = ErrorResponse | ReauthenticationRequiredResponse | AddAuthenticatorConflictResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1AccountAuthenticatorsTotpPost>>,
    TError,
    { data: SetupTOTPBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthAppV1AccountAuthenticatorsTotpPostMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Deactivates TOTP authentication. If the user authentication is not
sufficiently recent, a reauthentication flow (`401`) will is presented.

 * @summary Deactivate TOTP
 */
export type allauthAppV1AccountAuthenticatorsTotpDeleteResponse200 = {
  data: StatusOKResponse
  status: 200
}

export type allauthAppV1AccountAuthenticatorsTotpDeleteResponse401 = {
  data: ReauthenticationRequiredResponse
  status: 401
}

export type allauthAppV1AccountAuthenticatorsTotpDeleteResponseSuccess =
  allauthAppV1AccountAuthenticatorsTotpDeleteResponse200 & {
    headers: Headers
  }
export type allauthAppV1AccountAuthenticatorsTotpDeleteResponseError =
  allauthAppV1AccountAuthenticatorsTotpDeleteResponse401 & {
    headers: Headers
  }

export type allauthAppV1AccountAuthenticatorsTotpDeleteResponse =
  | allauthAppV1AccountAuthenticatorsTotpDeleteResponseSuccess
  | allauthAppV1AccountAuthenticatorsTotpDeleteResponseError

export const getAllauthAppV1AccountAuthenticatorsTotpDeleteUrl = () => {
  return `/api/v2/allauth/app/v1/account/authenticators/totp`
}

export const allauthAppV1AccountAuthenticatorsTotpDelete = async (
  options?: RequestInit,
): Promise<allauthAppV1AccountAuthenticatorsTotpDeleteResponse> => {
  return fetchAllauth<allauthAppV1AccountAuthenticatorsTotpDeleteResponse>(
    getAllauthAppV1AccountAuthenticatorsTotpDeleteUrl(),
    {
      ...options,
      method: 'DELETE',
    },
  )
}

export const getAllauthAppV1AccountAuthenticatorsTotpDeleteMutationOptions = <
  TError = ReauthenticationRequiredResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1AccountAuthenticatorsTotpDelete>>,
    TError,
    void,
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<
  Awaited<ReturnType<typeof allauthAppV1AccountAuthenticatorsTotpDelete>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['allauthAppV1AccountAuthenticatorsTotpDelete']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allauthAppV1AccountAuthenticatorsTotpDelete>>,
    void
  > = () => {
    return allauthAppV1AccountAuthenticatorsTotpDelete(requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthAppV1AccountAuthenticatorsTotpDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthAppV1AccountAuthenticatorsTotpDelete>>
>

export type AllauthAppV1AccountAuthenticatorsTotpDeleteMutationError = ReauthenticationRequiredResponse

/**
 * @summary Deactivate TOTP
 */
export const useAllauthAppV1AccountAuthenticatorsTotpDelete = <
  TError = ReauthenticationRequiredResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1AccountAuthenticatorsTotpDelete>>,
    TError,
    void,
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthAppV1AccountAuthenticatorsTotpDeleteMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * List recovery codes.

 * @summary List recovery codes
 */
export type allauthBrowserV1AccountAuthenticatorsRecoveryCodesGetResponse200 = {
  data: RecoveryCodesResponse
  status: 200
}

export type allauthBrowserV1AccountAuthenticatorsRecoveryCodesGetResponse401 = {
  data: ReauthenticationRequiredResponse
  status: 401
}

export type allauthBrowserV1AccountAuthenticatorsRecoveryCodesGetResponse404 = {
  data: NotFoundResponse
  status: 404
}

export type allauthBrowserV1AccountAuthenticatorsRecoveryCodesGetResponseSuccess =
  allauthBrowserV1AccountAuthenticatorsRecoveryCodesGetResponse200 & {
    headers: Headers
  }
export type allauthBrowserV1AccountAuthenticatorsRecoveryCodesGetResponseError = (
  | allauthBrowserV1AccountAuthenticatorsRecoveryCodesGetResponse401
  | allauthBrowserV1AccountAuthenticatorsRecoveryCodesGetResponse404
) & {
  headers: Headers
}

export type allauthBrowserV1AccountAuthenticatorsRecoveryCodesGetResponse =
  | allauthBrowserV1AccountAuthenticatorsRecoveryCodesGetResponseSuccess
  | allauthBrowserV1AccountAuthenticatorsRecoveryCodesGetResponseError

export const getAllauthBrowserV1AccountAuthenticatorsRecoveryCodesGetUrl = () => {
  return `/api/v2/allauth/browser/v1/account/authenticators/recovery-codes`
}

export const allauthBrowserV1AccountAuthenticatorsRecoveryCodesGet = async (
  options?: RequestInit,
): Promise<allauthBrowserV1AccountAuthenticatorsRecoveryCodesGetResponse> => {
  return fetchAllauth<allauthBrowserV1AccountAuthenticatorsRecoveryCodesGetResponse>(
    getAllauthBrowserV1AccountAuthenticatorsRecoveryCodesGetUrl(),
    {
      ...options,
      method: 'GET',
    },
  )
}

export const getAllauthBrowserV1AccountAuthenticatorsRecoveryCodesGetQueryKey = () => {
  return ['api', 'v2', 'allauth', 'browser', 'v1', 'account', 'authenticators', 'recovery-codes'] as const
}

export const getAllauthBrowserV1AccountAuthenticatorsRecoveryCodesGetQueryOptions = <
  TData = Awaited<ReturnType<typeof allauthBrowserV1AccountAuthenticatorsRecoveryCodesGet>>,
  TError = ReauthenticationRequiredResponse | NotFoundResponse,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AccountAuthenticatorsRecoveryCodesGet>>,
    TError,
    TData
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAllauthBrowserV1AccountAuthenticatorsRecoveryCodesGetQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof allauthBrowserV1AccountAuthenticatorsRecoveryCodesGet>>> = ({
    signal,
  }) => allauthBrowserV1AccountAuthenticatorsRecoveryCodesGet({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AccountAuthenticatorsRecoveryCodesGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type AllauthBrowserV1AccountAuthenticatorsRecoveryCodesGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof allauthBrowserV1AccountAuthenticatorsRecoveryCodesGet>>
>
export type AllauthBrowserV1AccountAuthenticatorsRecoveryCodesGetQueryError =
  | ReauthenticationRequiredResponse
  | NotFoundResponse

/**
 * @summary List recovery codes
 */

export function useAllauthBrowserV1AccountAuthenticatorsRecoveryCodesGet<
  TData = Awaited<ReturnType<typeof allauthBrowserV1AccountAuthenticatorsRecoveryCodesGet>>,
  TError = ReauthenticationRequiredResponse | NotFoundResponse,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AccountAuthenticatorsRecoveryCodesGet>>,
    TError,
    TData
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAllauthBrowserV1AccountAuthenticatorsRecoveryCodesGetQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Regenerate recovery codes
 */
export type allauthBrowserV1AccountAuthenticatorsRecoveryCodesPostResponse400 = {
  data: ErrorResponse
  status: 400
}

export type allauthBrowserV1AccountAuthenticatorsRecoveryCodesPostResponse401 = {
  data: ReauthenticationRequiredResponse
  status: 401
}
export type allauthBrowserV1AccountAuthenticatorsRecoveryCodesPostResponseError = (
  | allauthBrowserV1AccountAuthenticatorsRecoveryCodesPostResponse400
  | allauthBrowserV1AccountAuthenticatorsRecoveryCodesPostResponse401
) & {
  headers: Headers
}

export type allauthBrowserV1AccountAuthenticatorsRecoveryCodesPostResponse =
  allauthBrowserV1AccountAuthenticatorsRecoveryCodesPostResponseError

export const getAllauthBrowserV1AccountAuthenticatorsRecoveryCodesPostUrl = () => {
  return `/api/v2/allauth/browser/v1/account/authenticators/recovery-codes`
}

export const allauthBrowserV1AccountAuthenticatorsRecoveryCodesPost = async (
  options?: RequestInit,
): Promise<allauthBrowserV1AccountAuthenticatorsRecoveryCodesPostResponse> => {
  return fetchAllauth<allauthBrowserV1AccountAuthenticatorsRecoveryCodesPostResponse>(
    getAllauthBrowserV1AccountAuthenticatorsRecoveryCodesPostUrl(),
    {
      ...options,
      method: 'POST',
    },
  )
}

export const getAllauthBrowserV1AccountAuthenticatorsRecoveryCodesPostMutationOptions = <
  TError = ErrorResponse | ReauthenticationRequiredResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AccountAuthenticatorsRecoveryCodesPost>>,
    TError,
    void,
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<
  Awaited<ReturnType<typeof allauthBrowserV1AccountAuthenticatorsRecoveryCodesPost>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['allauthBrowserV1AccountAuthenticatorsRecoveryCodesPost']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allauthBrowserV1AccountAuthenticatorsRecoveryCodesPost>>,
    void
  > = () => {
    return allauthBrowserV1AccountAuthenticatorsRecoveryCodesPost(requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthBrowserV1AccountAuthenticatorsRecoveryCodesPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthBrowserV1AccountAuthenticatorsRecoveryCodesPost>>
>

export type AllauthBrowserV1AccountAuthenticatorsRecoveryCodesPostMutationError =
  | ErrorResponse
  | ReauthenticationRequiredResponse

/**
 * @summary Regenerate recovery codes
 */
export const useAllauthBrowserV1AccountAuthenticatorsRecoveryCodesPost = <
  TError = ErrorResponse | ReauthenticationRequiredResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AccountAuthenticatorsRecoveryCodesPost>>,
    TError,
    void,
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthBrowserV1AccountAuthenticatorsRecoveryCodesPostMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * List recovery codes.

 * @summary List recovery codes
 */
export type allauthAppV1AccountAuthenticatorsRecoveryCodesGetResponse200 = {
  data: RecoveryCodesResponse
  status: 200
}

export type allauthAppV1AccountAuthenticatorsRecoveryCodesGetResponse401 = {
  data: ReauthenticationRequiredResponse
  status: 401
}

export type allauthAppV1AccountAuthenticatorsRecoveryCodesGetResponse404 = {
  data: NotFoundResponse
  status: 404
}

export type allauthAppV1AccountAuthenticatorsRecoveryCodesGetResponseSuccess =
  allauthAppV1AccountAuthenticatorsRecoveryCodesGetResponse200 & {
    headers: Headers
  }
export type allauthAppV1AccountAuthenticatorsRecoveryCodesGetResponseError = (
  | allauthAppV1AccountAuthenticatorsRecoveryCodesGetResponse401
  | allauthAppV1AccountAuthenticatorsRecoveryCodesGetResponse404
) & {
  headers: Headers
}

export type allauthAppV1AccountAuthenticatorsRecoveryCodesGetResponse =
  | allauthAppV1AccountAuthenticatorsRecoveryCodesGetResponseSuccess
  | allauthAppV1AccountAuthenticatorsRecoveryCodesGetResponseError

export const getAllauthAppV1AccountAuthenticatorsRecoveryCodesGetUrl = () => {
  return `/api/v2/allauth/app/v1/account/authenticators/recovery-codes`
}

export const allauthAppV1AccountAuthenticatorsRecoveryCodesGet = async (
  options?: RequestInit,
): Promise<allauthAppV1AccountAuthenticatorsRecoveryCodesGetResponse> => {
  return fetchAllauth<allauthAppV1AccountAuthenticatorsRecoveryCodesGetResponse>(
    getAllauthAppV1AccountAuthenticatorsRecoveryCodesGetUrl(),
    {
      ...options,
      method: 'GET',
    },
  )
}

export const getAllauthAppV1AccountAuthenticatorsRecoveryCodesGetQueryKey = () => {
  return ['api', 'v2', 'allauth', 'app', 'v1', 'account', 'authenticators', 'recovery-codes'] as const
}

export const getAllauthAppV1AccountAuthenticatorsRecoveryCodesGetQueryOptions = <
  TData = Awaited<ReturnType<typeof allauthAppV1AccountAuthenticatorsRecoveryCodesGet>>,
  TError = ReauthenticationRequiredResponse | NotFoundResponse,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof allauthAppV1AccountAuthenticatorsRecoveryCodesGet>>, TError, TData>
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAllauthAppV1AccountAuthenticatorsRecoveryCodesGetQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof allauthAppV1AccountAuthenticatorsRecoveryCodesGet>>> = ({
    signal,
  }) => allauthAppV1AccountAuthenticatorsRecoveryCodesGet({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof allauthAppV1AccountAuthenticatorsRecoveryCodesGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type AllauthAppV1AccountAuthenticatorsRecoveryCodesGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof allauthAppV1AccountAuthenticatorsRecoveryCodesGet>>
>
export type AllauthAppV1AccountAuthenticatorsRecoveryCodesGetQueryError =
  | ReauthenticationRequiredResponse
  | NotFoundResponse

/**
 * @summary List recovery codes
 */

export function useAllauthAppV1AccountAuthenticatorsRecoveryCodesGet<
  TData = Awaited<ReturnType<typeof allauthAppV1AccountAuthenticatorsRecoveryCodesGet>>,
  TError = ReauthenticationRequiredResponse | NotFoundResponse,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof allauthAppV1AccountAuthenticatorsRecoveryCodesGet>>, TError, TData>
  request?: SecondParameter<typeof fetchAllauth>
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAllauthAppV1AccountAuthenticatorsRecoveryCodesGetQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Regenerate recovery codes
 */
export type allauthAppV1AccountAuthenticatorsRecoveryCodesPostResponse400 = {
  data: ErrorResponse
  status: 400
}

export type allauthAppV1AccountAuthenticatorsRecoveryCodesPostResponse401 = {
  data: ReauthenticationRequiredResponse
  status: 401
}
export type allauthAppV1AccountAuthenticatorsRecoveryCodesPostResponseError = (
  | allauthAppV1AccountAuthenticatorsRecoveryCodesPostResponse400
  | allauthAppV1AccountAuthenticatorsRecoveryCodesPostResponse401
) & {
  headers: Headers
}

export type allauthAppV1AccountAuthenticatorsRecoveryCodesPostResponse =
  allauthAppV1AccountAuthenticatorsRecoveryCodesPostResponseError

export const getAllauthAppV1AccountAuthenticatorsRecoveryCodesPostUrl = () => {
  return `/api/v2/allauth/app/v1/account/authenticators/recovery-codes`
}

export const allauthAppV1AccountAuthenticatorsRecoveryCodesPost = async (
  options?: RequestInit,
): Promise<allauthAppV1AccountAuthenticatorsRecoveryCodesPostResponse> => {
  return fetchAllauth<allauthAppV1AccountAuthenticatorsRecoveryCodesPostResponse>(
    getAllauthAppV1AccountAuthenticatorsRecoveryCodesPostUrl(),
    {
      ...options,
      method: 'POST',
    },
  )
}

export const getAllauthAppV1AccountAuthenticatorsRecoveryCodesPostMutationOptions = <
  TError = ErrorResponse | ReauthenticationRequiredResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1AccountAuthenticatorsRecoveryCodesPost>>,
    TError,
    void,
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<
  Awaited<ReturnType<typeof allauthAppV1AccountAuthenticatorsRecoveryCodesPost>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['allauthAppV1AccountAuthenticatorsRecoveryCodesPost']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allauthAppV1AccountAuthenticatorsRecoveryCodesPost>>,
    void
  > = () => {
    return allauthAppV1AccountAuthenticatorsRecoveryCodesPost(requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthAppV1AccountAuthenticatorsRecoveryCodesPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthAppV1AccountAuthenticatorsRecoveryCodesPost>>
>

export type AllauthAppV1AccountAuthenticatorsRecoveryCodesPostMutationError =
  | ErrorResponse
  | ReauthenticationRequiredResponse

/**
 * @summary Regenerate recovery codes
 */
export const useAllauthAppV1AccountAuthenticatorsRecoveryCodesPost = <
  TError = ErrorResponse | ReauthenticationRequiredResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1AccountAuthenticatorsRecoveryCodesPost>>,
    TError,
    void,
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthAppV1AccountAuthenticatorsRecoveryCodesPostMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Retrieve information about the authentication status for the current
session.

 * @summary Get authentication status

 */
export type allauthBrowserV1AuthSessionGetResponse200 = {
  data: AuthenticatedResponse
  status: 200
}

export type allauthBrowserV1AuthSessionGetResponse401 = {
  data: AuthenticationResponse
  status: 401
}

export type allauthBrowserV1AuthSessionGetResponse410 = {
  data: SessionGoneResponse
  status: 410
}

export type allauthBrowserV1AuthSessionGetResponseSuccess = allauthBrowserV1AuthSessionGetResponse200 & {
  headers: Headers
}
export type allauthBrowserV1AuthSessionGetResponseError = (
  | allauthBrowserV1AuthSessionGetResponse401
  | allauthBrowserV1AuthSessionGetResponse410
) & {
  headers: Headers
}

export type allauthBrowserV1AuthSessionGetResponse =
  | allauthBrowserV1AuthSessionGetResponseSuccess
  | allauthBrowserV1AuthSessionGetResponseError

export const getAllauthBrowserV1AuthSessionGetUrl = () => {
  return `/api/v2/allauth/browser/v1/auth/session`
}

export const allauthBrowserV1AuthSessionGet = async (
  options?: RequestInit,
): Promise<allauthBrowserV1AuthSessionGetResponse> => {
  return fetchAllauth<allauthBrowserV1AuthSessionGetResponse>(getAllauthBrowserV1AuthSessionGetUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getAllauthBrowserV1AuthSessionGetQueryKey = () => {
  return ['api', 'v2', 'allauth', 'browser', 'v1', 'auth', 'session'] as const
}

export const getAllauthBrowserV1AuthSessionGetQueryOptions = <
  TData = Awaited<ReturnType<typeof allauthBrowserV1AuthSessionGet>>,
  TError = AuthenticationResponse | SessionGoneResponse,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof allauthBrowserV1AuthSessionGet>>, TError, TData>
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAllauthBrowserV1AuthSessionGetQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof allauthBrowserV1AuthSessionGet>>> = ({ signal }) =>
    allauthBrowserV1AuthSessionGet({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AuthSessionGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type AllauthBrowserV1AuthSessionGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof allauthBrowserV1AuthSessionGet>>
>
export type AllauthBrowserV1AuthSessionGetQueryError = AuthenticationResponse | SessionGoneResponse

/**
 * @summary Get authentication status

 */

export function useAllauthBrowserV1AuthSessionGet<
  TData = Awaited<ReturnType<typeof allauthBrowserV1AuthSessionGet>>,
  TError = AuthenticationResponse | SessionGoneResponse,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof allauthBrowserV1AuthSessionGet>>, TError, TData>
  request?: SecondParameter<typeof fetchAllauth>
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAllauthBrowserV1AuthSessionGetQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * Logs out the user from the current session.

 * @summary Logout
 */
export type allauthBrowserV1AuthSessionDeleteResponse401 = {
  data: UnauthenticatedResponse
  status: 401
}
export type allauthBrowserV1AuthSessionDeleteResponseError = allauthBrowserV1AuthSessionDeleteResponse401 & {
  headers: Headers
}

export type allauthBrowserV1AuthSessionDeleteResponse = allauthBrowserV1AuthSessionDeleteResponseError

export const getAllauthBrowserV1AuthSessionDeleteUrl = () => {
  return `/api/v2/allauth/browser/v1/auth/session`
}

export const allauthBrowserV1AuthSessionDelete = async (
  options?: RequestInit,
): Promise<allauthBrowserV1AuthSessionDeleteResponse> => {
  return fetchAllauth<allauthBrowserV1AuthSessionDeleteResponse>(getAllauthBrowserV1AuthSessionDeleteUrl(), {
    ...options,
    method: 'DELETE',
  })
}

export const getAllauthBrowserV1AuthSessionDeleteMutationOptions = <
  TError = UnauthenticatedResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof allauthBrowserV1AuthSessionDelete>>, TError, void, TContext>
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<Awaited<ReturnType<typeof allauthBrowserV1AuthSessionDelete>>, TError, void, TContext> => {
  const mutationKey = ['allauthBrowserV1AuthSessionDelete']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof allauthBrowserV1AuthSessionDelete>>, void> = () => {
    return allauthBrowserV1AuthSessionDelete(requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthBrowserV1AuthSessionDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthBrowserV1AuthSessionDelete>>
>

export type AllauthBrowserV1AuthSessionDeleteMutationError = UnauthenticatedResponse

/**
 * @summary Logout
 */
export const useAllauthBrowserV1AuthSessionDelete = <TError = UnauthenticatedResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof allauthBrowserV1AuthSessionDelete>>, TError, void, TContext>
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthBrowserV1AuthSessionDeleteMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Retrieve information about the authentication status for the current
session.

 * @summary Get authentication status

 */
export type allauthAppV1AuthSessionGetResponse200 = {
  data: AuthenticatedResponse
  status: 200
}

export type allauthAppV1AuthSessionGetResponse401 = {
  data: AuthenticationResponse
  status: 401
}

export type allauthAppV1AuthSessionGetResponse410 = {
  data: SessionGoneResponse
  status: 410
}

export type allauthAppV1AuthSessionGetResponseSuccess = allauthAppV1AuthSessionGetResponse200 & {
  headers: Headers
}
export type allauthAppV1AuthSessionGetResponseError = (
  | allauthAppV1AuthSessionGetResponse401
  | allauthAppV1AuthSessionGetResponse410
) & {
  headers: Headers
}

export type allauthAppV1AuthSessionGetResponse =
  | allauthAppV1AuthSessionGetResponseSuccess
  | allauthAppV1AuthSessionGetResponseError

export const getAllauthAppV1AuthSessionGetUrl = () => {
  return `/api/v2/allauth/app/v1/auth/session`
}

export const allauthAppV1AuthSessionGet = async (
  options?: RequestInit,
): Promise<allauthAppV1AuthSessionGetResponse> => {
  return fetchAllauth<allauthAppV1AuthSessionGetResponse>(getAllauthAppV1AuthSessionGetUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getAllauthAppV1AuthSessionGetQueryKey = () => {
  return ['api', 'v2', 'allauth', 'app', 'v1', 'auth', 'session'] as const
}

export const getAllauthAppV1AuthSessionGetQueryOptions = <
  TData = Awaited<ReturnType<typeof allauthAppV1AuthSessionGet>>,
  TError = AuthenticationResponse | SessionGoneResponse,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof allauthAppV1AuthSessionGet>>, TError, TData>
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAllauthAppV1AuthSessionGetQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof allauthAppV1AuthSessionGet>>> = ({ signal }) =>
    allauthAppV1AuthSessionGet({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof allauthAppV1AuthSessionGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type AllauthAppV1AuthSessionGetQueryResult = NonNullable<Awaited<ReturnType<typeof allauthAppV1AuthSessionGet>>>
export type AllauthAppV1AuthSessionGetQueryError = AuthenticationResponse | SessionGoneResponse

/**
 * @summary Get authentication status

 */

export function useAllauthAppV1AuthSessionGet<
  TData = Awaited<ReturnType<typeof allauthAppV1AuthSessionGet>>,
  TError = AuthenticationResponse | SessionGoneResponse,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof allauthAppV1AuthSessionGet>>, TError, TData>
  request?: SecondParameter<typeof fetchAllauth>
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAllauthAppV1AuthSessionGetQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * Logs out the user from the current session.

 * @summary Logout
 */
export type allauthAppV1AuthSessionDeleteResponse401 = {
  data: UnauthenticatedResponse
  status: 401
}
export type allauthAppV1AuthSessionDeleteResponseError = allauthAppV1AuthSessionDeleteResponse401 & {
  headers: Headers
}

export type allauthAppV1AuthSessionDeleteResponse = allauthAppV1AuthSessionDeleteResponseError

export const getAllauthAppV1AuthSessionDeleteUrl = () => {
  return `/api/v2/allauth/app/v1/auth/session`
}

export const allauthAppV1AuthSessionDelete = async (
  options?: RequestInit,
): Promise<allauthAppV1AuthSessionDeleteResponse> => {
  return fetchAllauth<allauthAppV1AuthSessionDeleteResponse>(getAllauthAppV1AuthSessionDeleteUrl(), {
    ...options,
    method: 'DELETE',
  })
}

export const getAllauthAppV1AuthSessionDeleteMutationOptions = <
  TError = UnauthenticatedResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof allauthAppV1AuthSessionDelete>>, TError, void, TContext>
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<Awaited<ReturnType<typeof allauthAppV1AuthSessionDelete>>, TError, void, TContext> => {
  const mutationKey = ['allauthAppV1AuthSessionDelete']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof allauthAppV1AuthSessionDelete>>, void> = () => {
    return allauthAppV1AuthSessionDelete(requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthAppV1AuthSessionDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthAppV1AuthSessionDelete>>
>

export type AllauthAppV1AuthSessionDeleteMutationError = UnauthenticatedResponse

/**
 * @summary Logout
 */
export const useAllauthAppV1AuthSessionDelete = <TError = UnauthenticatedResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof allauthAppV1AuthSessionDelete>>, TError, void, TContext>
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthAppV1AuthSessionDeleteMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Used to retrieve a new access token. Depending on `settings.HEADLESS_JWT_ROTATE_REFRESH_TOKEN`,
a new refresh token is returned as well.

 * @summary Refresh the access token

 */
export type allauthAppV1TokensRefreshPostResponse200 = {
  data: RefreshTokenResponse
  status: 200
}

export type allauthAppV1TokensRefreshPostResponse400 = {
  data: ErrorResponse
  status: 400
}

export type allauthAppV1TokensRefreshPostResponseSuccess = allauthAppV1TokensRefreshPostResponse200 & {
  headers: Headers
}
export type allauthAppV1TokensRefreshPostResponseError = allauthAppV1TokensRefreshPostResponse400 & {
  headers: Headers
}

export type allauthAppV1TokensRefreshPostResponse =
  | allauthAppV1TokensRefreshPostResponseSuccess
  | allauthAppV1TokensRefreshPostResponseError

export const getAllauthAppV1TokensRefreshPostUrl = () => {
  return `/api/v2/allauth/app/v1/tokens/refresh`
}

export const allauthAppV1TokensRefreshPost = async (
  refreshTokenBody: RefreshTokenBody,
  options?: RequestInit,
): Promise<allauthAppV1TokensRefreshPostResponse> => {
  return fetchAllauth<allauthAppV1TokensRefreshPostResponse>(getAllauthAppV1TokensRefreshPostUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(refreshTokenBody),
  })
}

export const getAllauthAppV1TokensRefreshPostMutationOptions = <TError = ErrorResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1TokensRefreshPost>>,
    TError,
    { data: RefreshTokenBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<
  Awaited<ReturnType<typeof allauthAppV1TokensRefreshPost>>,
  TError,
  { data: RefreshTokenBody },
  TContext
> => {
  const mutationKey = ['allauthAppV1TokensRefreshPost']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allauthAppV1TokensRefreshPost>>,
    { data: RefreshTokenBody }
  > = (props) => {
    const { data } = props ?? {}

    return allauthAppV1TokensRefreshPost(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthAppV1TokensRefreshPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthAppV1TokensRefreshPost>>
>
export type AllauthAppV1TokensRefreshPostMutationBody = RefreshTokenBody
export type AllauthAppV1TokensRefreshPostMutationError = ErrorResponse

/**
 * @summary Refresh the access token

 */
export const useAllauthAppV1TokensRefreshPost = <TError = ErrorResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1TokensRefreshPost>>,
    TError,
    { data: RefreshTokenBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthAppV1TokensRefreshPostMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * In order to change the password of an account, the current and new
password must be provider.  However, accounts that were created by
signing up using a third-party provider do not have a password set. In
that case, the current password is not required.

 * @summary Change password
 */
export type allauthBrowserV1AccountPasswordChangePostResponse400 = {
  data: ErrorResponse
  status: 400
}

export type allauthBrowserV1AccountPasswordChangePostResponse401 = {
  data: AuthenticationResponse
  status: 401
}
export type allauthBrowserV1AccountPasswordChangePostResponseError = (
  | allauthBrowserV1AccountPasswordChangePostResponse400
  | allauthBrowserV1AccountPasswordChangePostResponse401
) & {
  headers: Headers
}

export type allauthBrowserV1AccountPasswordChangePostResponse = allauthBrowserV1AccountPasswordChangePostResponseError

export const getAllauthBrowserV1AccountPasswordChangePostUrl = () => {
  return `/api/v2/allauth/browser/v1/account/password/change`
}

export const allauthBrowserV1AccountPasswordChangePost = async (
  changePasswordBody: ChangePasswordBody,
  options?: RequestInit,
): Promise<allauthBrowserV1AccountPasswordChangePostResponse> => {
  return fetchAllauth<allauthBrowserV1AccountPasswordChangePostResponse>(
    getAllauthBrowserV1AccountPasswordChangePostUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(changePasswordBody),
    },
  )
}

export const getAllauthBrowserV1AccountPasswordChangePostMutationOptions = <
  TError = ErrorResponse | AuthenticationResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AccountPasswordChangePost>>,
    TError,
    { data: ChangePasswordBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<
  Awaited<ReturnType<typeof allauthBrowserV1AccountPasswordChangePost>>,
  TError,
  { data: ChangePasswordBody },
  TContext
> => {
  const mutationKey = ['allauthBrowserV1AccountPasswordChangePost']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allauthBrowserV1AccountPasswordChangePost>>,
    { data: ChangePasswordBody }
  > = (props) => {
    const { data } = props ?? {}

    return allauthBrowserV1AccountPasswordChangePost(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthBrowserV1AccountPasswordChangePostMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthBrowserV1AccountPasswordChangePost>>
>
export type AllauthBrowserV1AccountPasswordChangePostMutationBody = ChangePasswordBody
export type AllauthBrowserV1AccountPasswordChangePostMutationError = ErrorResponse | AuthenticationResponse

/**
 * @summary Change password
 */
export const useAllauthBrowserV1AccountPasswordChangePost = <
  TError = ErrorResponse | AuthenticationResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AccountPasswordChangePost>>,
    TError,
    { data: ChangePasswordBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthBrowserV1AccountPasswordChangePostMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * In order to change the password of an account, the current and new
password must be provider.  However, accounts that were created by
signing up using a third-party provider do not have a password set. In
that case, the current password is not required.

 * @summary Change password
 */
export type allauthAppV1AccountPasswordChangePostResponse400 = {
  data: ErrorResponse
  status: 400
}

export type allauthAppV1AccountPasswordChangePostResponse401 = {
  data: AuthenticationResponse
  status: 401
}
export type allauthAppV1AccountPasswordChangePostResponseError = (
  | allauthAppV1AccountPasswordChangePostResponse400
  | allauthAppV1AccountPasswordChangePostResponse401
) & {
  headers: Headers
}

export type allauthAppV1AccountPasswordChangePostResponse = allauthAppV1AccountPasswordChangePostResponseError

export const getAllauthAppV1AccountPasswordChangePostUrl = () => {
  return `/api/v2/allauth/app/v1/account/password/change`
}

export const allauthAppV1AccountPasswordChangePost = async (
  changePasswordBody: ChangePasswordBody,
  options?: RequestInit,
): Promise<allauthAppV1AccountPasswordChangePostResponse> => {
  return fetchAllauth<allauthAppV1AccountPasswordChangePostResponse>(getAllauthAppV1AccountPasswordChangePostUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(changePasswordBody),
  })
}

export const getAllauthAppV1AccountPasswordChangePostMutationOptions = <
  TError = ErrorResponse | AuthenticationResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1AccountPasswordChangePost>>,
    TError,
    { data: ChangePasswordBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<
  Awaited<ReturnType<typeof allauthAppV1AccountPasswordChangePost>>,
  TError,
  { data: ChangePasswordBody },
  TContext
> => {
  const mutationKey = ['allauthAppV1AccountPasswordChangePost']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allauthAppV1AccountPasswordChangePost>>,
    { data: ChangePasswordBody }
  > = (props) => {
    const { data } = props ?? {}

    return allauthAppV1AccountPasswordChangePost(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthAppV1AccountPasswordChangePostMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthAppV1AccountPasswordChangePost>>
>
export type AllauthAppV1AccountPasswordChangePostMutationBody = ChangePasswordBody
export type AllauthAppV1AccountPasswordChangePostMutationError = ErrorResponse | AuthenticationResponse

/**
 * @summary Change password
 */
export const useAllauthAppV1AccountPasswordChangePost = <
  TError = ErrorResponse | AuthenticationResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1AccountPasswordChangePost>>,
    TError,
    { data: ChangePasswordBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthAppV1AccountPasswordChangePostMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * @summary List sessions
 */
export type allauthBrowserV1AuthSessionsGetResponse200 = {
  data: SessionsResponse
  status: 200
}

export type allauthBrowserV1AuthSessionsGetResponseSuccess = allauthBrowserV1AuthSessionsGetResponse200 & {
  headers: Headers
}

export type allauthBrowserV1AuthSessionsGetResponse = allauthBrowserV1AuthSessionsGetResponseSuccess

export const getAllauthBrowserV1AuthSessionsGetUrl = () => {
  return `/api/v2/allauth/browser/v1/auth/sessions`
}

export const allauthBrowserV1AuthSessionsGet = async (
  options?: RequestInit,
): Promise<allauthBrowserV1AuthSessionsGetResponse> => {
  return fetchAllauth<allauthBrowserV1AuthSessionsGetResponse>(getAllauthBrowserV1AuthSessionsGetUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getAllauthBrowserV1AuthSessionsGetQueryKey = () => {
  return ['api', 'v2', 'allauth', 'browser', 'v1', 'auth', 'sessions'] as const
}

export const getAllauthBrowserV1AuthSessionsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof allauthBrowserV1AuthSessionsGet>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof allauthBrowserV1AuthSessionsGet>>, TError, TData>
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAllauthBrowserV1AuthSessionsGetQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof allauthBrowserV1AuthSessionsGet>>> = ({ signal }) =>
    allauthBrowserV1AuthSessionsGet({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AuthSessionsGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type AllauthBrowserV1AuthSessionsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof allauthBrowserV1AuthSessionsGet>>
>
export type AllauthBrowserV1AuthSessionsGetQueryError = unknown

/**
 * @summary List sessions
 */

export function useAllauthBrowserV1AuthSessionsGet<
  TData = Awaited<ReturnType<typeof allauthBrowserV1AuthSessionsGet>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof allauthBrowserV1AuthSessionsGet>>, TError, TData>
  request?: SecondParameter<typeof fetchAllauth>
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAllauthBrowserV1AuthSessionsGetQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary End one or more sessions
 */
export type allauthBrowserV1AuthSessionsDeleteResponse200 = {
  data: SessionsResponse
  status: 200
}

export type allauthBrowserV1AuthSessionsDeleteResponse401 = {
  data: AuthenticationResponse
  status: 401
}

export type allauthBrowserV1AuthSessionsDeleteResponseSuccess = allauthBrowserV1AuthSessionsDeleteResponse200 & {
  headers: Headers
}
export type allauthBrowserV1AuthSessionsDeleteResponseError = allauthBrowserV1AuthSessionsDeleteResponse401 & {
  headers: Headers
}

export type allauthBrowserV1AuthSessionsDeleteResponse =
  | allauthBrowserV1AuthSessionsDeleteResponseSuccess
  | allauthBrowserV1AuthSessionsDeleteResponseError

export const getAllauthBrowserV1AuthSessionsDeleteUrl = () => {
  return `/api/v2/allauth/browser/v1/auth/sessions`
}

export const allauthBrowserV1AuthSessionsDelete = async (
  endSessionsBody: EndSessionsBody,
  options?: RequestInit,
): Promise<allauthBrowserV1AuthSessionsDeleteResponse> => {
  return fetchAllauth<allauthBrowserV1AuthSessionsDeleteResponse>(getAllauthBrowserV1AuthSessionsDeleteUrl(), {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(endSessionsBody),
  })
}

export const getAllauthBrowserV1AuthSessionsDeleteMutationOptions = <
  TError = AuthenticationResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AuthSessionsDelete>>,
    TError,
    { data: EndSessionsBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<
  Awaited<ReturnType<typeof allauthBrowserV1AuthSessionsDelete>>,
  TError,
  { data: EndSessionsBody },
  TContext
> => {
  const mutationKey = ['allauthBrowserV1AuthSessionsDelete']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allauthBrowserV1AuthSessionsDelete>>,
    { data: EndSessionsBody }
  > = (props) => {
    const { data } = props ?? {}

    return allauthBrowserV1AuthSessionsDelete(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthBrowserV1AuthSessionsDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthBrowserV1AuthSessionsDelete>>
>
export type AllauthBrowserV1AuthSessionsDeleteMutationBody = EndSessionsBody
export type AllauthBrowserV1AuthSessionsDeleteMutationError = AuthenticationResponse

/**
 * @summary End one or more sessions
 */
export const useAllauthBrowserV1AuthSessionsDelete = <TError = AuthenticationResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthBrowserV1AuthSessionsDelete>>,
    TError,
    { data: EndSessionsBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthBrowserV1AuthSessionsDeleteMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * @summary List sessions
 */
export type allauthAppV1AuthSessionsGetResponse200 = {
  data: SessionsResponse
  status: 200
}

export type allauthAppV1AuthSessionsGetResponseSuccess = allauthAppV1AuthSessionsGetResponse200 & {
  headers: Headers
}

export type allauthAppV1AuthSessionsGetResponse = allauthAppV1AuthSessionsGetResponseSuccess

export const getAllauthAppV1AuthSessionsGetUrl = () => {
  return `/api/v2/allauth/app/v1/auth/sessions`
}

export const allauthAppV1AuthSessionsGet = async (
  options?: RequestInit,
): Promise<allauthAppV1AuthSessionsGetResponse> => {
  return fetchAllauth<allauthAppV1AuthSessionsGetResponse>(getAllauthAppV1AuthSessionsGetUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getAllauthAppV1AuthSessionsGetQueryKey = () => {
  return ['api', 'v2', 'allauth', 'app', 'v1', 'auth', 'sessions'] as const
}

export const getAllauthAppV1AuthSessionsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof allauthAppV1AuthSessionsGet>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof allauthAppV1AuthSessionsGet>>, TError, TData>
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAllauthAppV1AuthSessionsGetQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof allauthAppV1AuthSessionsGet>>> = ({ signal }) =>
    allauthAppV1AuthSessionsGet({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof allauthAppV1AuthSessionsGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type AllauthAppV1AuthSessionsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof allauthAppV1AuthSessionsGet>>
>
export type AllauthAppV1AuthSessionsGetQueryError = unknown

/**
 * @summary List sessions
 */

export function useAllauthAppV1AuthSessionsGet<
  TData = Awaited<ReturnType<typeof allauthAppV1AuthSessionsGet>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof allauthAppV1AuthSessionsGet>>, TError, TData>
  request?: SecondParameter<typeof fetchAllauth>
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAllauthAppV1AuthSessionsGetQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary End one or more sessions
 */
export type allauthAppV1AuthSessionsDeleteResponse200 = {
  data: SessionsResponse
  status: 200
}

export type allauthAppV1AuthSessionsDeleteResponse401 = {
  data: AuthenticationResponse
  status: 401
}

export type allauthAppV1AuthSessionsDeleteResponseSuccess = allauthAppV1AuthSessionsDeleteResponse200 & {
  headers: Headers
}
export type allauthAppV1AuthSessionsDeleteResponseError = allauthAppV1AuthSessionsDeleteResponse401 & {
  headers: Headers
}

export type allauthAppV1AuthSessionsDeleteResponse =
  | allauthAppV1AuthSessionsDeleteResponseSuccess
  | allauthAppV1AuthSessionsDeleteResponseError

export const getAllauthAppV1AuthSessionsDeleteUrl = () => {
  return `/api/v2/allauth/app/v1/auth/sessions`
}

export const allauthAppV1AuthSessionsDelete = async (
  endSessionsBody: EndSessionsBody,
  options?: RequestInit,
): Promise<allauthAppV1AuthSessionsDeleteResponse> => {
  return fetchAllauth<allauthAppV1AuthSessionsDeleteResponse>(getAllauthAppV1AuthSessionsDeleteUrl(), {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(endSessionsBody),
  })
}

export const getAllauthAppV1AuthSessionsDeleteMutationOptions = <
  TError = AuthenticationResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1AuthSessionsDelete>>,
    TError,
    { data: EndSessionsBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}): UseMutationOptions<
  Awaited<ReturnType<typeof allauthAppV1AuthSessionsDelete>>,
  TError,
  { data: EndSessionsBody },
  TContext
> => {
  const mutationKey = ['allauthAppV1AuthSessionsDelete']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allauthAppV1AuthSessionsDelete>>,
    { data: EndSessionsBody }
  > = (props) => {
    const { data } = props ?? {}

    return allauthAppV1AuthSessionsDelete(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AllauthAppV1AuthSessionsDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof allauthAppV1AuthSessionsDelete>>
>
export type AllauthAppV1AuthSessionsDeleteMutationBody = EndSessionsBody
export type AllauthAppV1AuthSessionsDeleteMutationError = AuthenticationResponse

/**
 * @summary End one or more sessions
 */
export const useAllauthAppV1AuthSessionsDelete = <TError = AuthenticationResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allauthAppV1AuthSessionsDelete>>,
    TError,
    { data: EndSessionsBody },
    TContext
  >
  request?: SecondParameter<typeof fetchAllauth>
}) => {
  const mutationOptions = getAllauthAppV1AuthSessionsDeleteMutationOptions(options)

  return useMutation(mutationOptions)
}
